// Vietnamese for the HEVN Portal — GENERATED by scripts/i18n_langs.cjs from flat translations of `en` in
// i18n.js (2026-10-21). Edit a string here or re-run the script; a key absent here falls back to English.
// Acronyms, system and product names stay as written (EXF, FOB, MOQ, SAP, NetSuite, Helinox …).
const vi = {
  "common": {
    "notif": {
      "title": "Thông báo",
      "unreadCount": "{{count}} thông báo chưa đọc",
      "markAll": "Đánh dấu tất cả là đã đọc",
      "markRead": "Đánh dấu đã đọc",
      "loading": "Đang tải…",
      "empty": "Chưa có thông báo nào. Khi portal gửi mail cho bạn về công việc, nội dung đó cũng hiện ở đây.",
      "open": "Mở trang liên quan",
      "by": "bởi {{name}}",
      "settings": "Chọn nhóm thông báo",
      "settingsHint": "Chọn những nhóm bạn muốn thấy trong chuông. Mail vẫn gửi như cũ; nhóm đã tắt chỉ bị ẩn ở đây, bật lại là hiện lại.",
      "save": "Lưu",
      "cancel": "Quay lại",
      "saved": "Đã lưu",
      "unreadIn": "{{count}} chưa đọc",
      "g_approvals": "Duyệt & quyết định",
      "g_access": "Yêu cầu truy cập (người mới)",
      "g_tickets": "Ticket",
      "g_samples": "Hạn sample",
      "g_projects": "Project (SKU thêm, chuyển, drop)",
      "g_cycletime": "Kiểm tra cycle time",
      "g_ceo": "CEO Office",
      "g_chat": "Chat nhóm (GCC)",
      "g_tasks": "Dự án hệ thống",
      "g_other": "Khác",
      "hidden": "Đang ẩn {{count}} nhóm"
    },
    "common": {
      "language": "Ngôn ngữ",
      "theme": "Giao diện",
      "light": "Sáng",
      "dark": "Tối",
      "allRoles": "Tất cả vai trò"
    },
    "cpAtt": {
      "photos": "Ảnh",
      "messages": "Tin nhắn",
      "you": "Bạn",
      "pendingTag": "gửi khi bạn lưu",
      "noMessages": "Chưa có tin nhắn.",
      "placeholder": "Viết ghi chú về báo giá này…",
      "send": "Gửi",
      "withdraw": "Xóa",
      "deleteConfirm": "Xóa tin nhắn này? Tin nhắn sẽ bị xóa với mọi người và không thể khôi phục.",
      "saveFailed": "Không lưu được tin nhắn.",
      "deleteFailed": "Không xóa được tin nhắn."
    },
    "bench": {
      "title": "Bảng giá thành Inline",
      "sub": "Các bảng giá thành của nhà cung cấp đã được đọc vào đối chiếu Inline, lưu lại để có thể đối chiếu báo giá mà không cần file.",
      "search": "Tìm style, file, nhà cung cấp, mùa…",
      "empty": "Chưa đọc bảng giá thành nào. Dùng \"Nhập bảng giá thành\" ở trên — nội dung đọc được sẽ lưu ở đây và được gợi ý mỗi khi điền đối chiếu Inline của một báo giá.",
      "noHit": "Không có mục nào khớp với \"{{q}}\".",
      "loading": "Đang đọc bảng…",
      "lines": "{{n}} dòng",
      "edit": "Sửa thông tin",
      "remove": "Xóa",
      "save": "Lưu",
      "saved": "Đã lưu.",
      "removed": "Đã xóa khỏi thư viện.",
      "editTitle": "Mùa, nhà cung cấp và ghi chú",
      "editBody": "Ba thông tin mà file Excel không ghi. Không sửa được các khoản chi phí — đó là những gì nhà cung cấp đưa ra, và giá mua bên cạnh là con số dùng để kiểm tra chúng.",
      "season": "Mùa",
      "vendor": "Nhà cung cấp",
      "note": "Ghi chú",
      "removeTitle": "Xóa bảng giá thành này?",
      "removeBody": "{{file}} sẽ rời khỏi thư viện và không còn được gợi ý khi điền đối chiếu. Các báo giá đã đối chiếu với nó vẫn giữ nguyên số liệu và dòng ghi bên cạnh.",
      "colLine": "Dòng",
      "colVariant": "Phiên bản giá thành",
      "colStated": "Giá mua trên bảng",
      "import": "Nhập bảng giá thành",
      "readOk": "{{file}} — đã đọc và lưu {{n}} dòng.",
      "readRefused": "{{n}} dòng bị từ chối: tổng các cột không khớp với giá mua ghi bên cạnh."
    },
    "ceo": {
      "title": "Văn phòng CEO",
      "sub": "Mọi việc đã mở đều được theo dõi đến khi đóng. Mail chuyển tiếp tới ceo.office@ sẽ thành ticket; các bộ đếm được tính từ nhật ký sự kiện của từng ticket.",
      "desk": "Nhóm",
      "bothDesks": "Cả hai",
      "desk_business": "Kinh doanh",
      "desk_executive": "Điều hành",
      "refresh": "Làm mới",
      "newTicket": "Ticket mới",
      "newSub": "Ticket được tạo trên một nhóm và ở lại nhóm đó. Có thể để trống pháp nhân và người liên hệ nội bộ — hầu hết các việc bắt đầu khi chưa có nơi phụ trách.",
      "create": "Tạo",
      "cancel": "Hủy",
      "close": "Đóng",
      "needTitle": "Ticket cần có tiêu đề.",
      "fromWho": "Từ",
      "notSet": "chưa đặt",
      "noTickets": "Nhóm này chưa có ticket nào.",
      "noDesk": "Bạn không thuộc nhóm nào nên không có gì để hiển thị. Hãy nhờ Young thêm bạn vào Business hoặc Executive.",
      "filteredBy": "Chỉ hiển thị {{name}} — {{n}} ticket.",
      "clearFilter": "Hiện tất cả",
      "cardOpen": "Đang làm",
      "cardOpenRule": "chưa đóng hoặc hủy",
      "cardOverdue": "Quá hạn",
      "cardOverdueRule": "vẫn mở, đã qua hạn",
      "cardUntouched": "Không tương tác 3+ ngày",
      "cardUntouchedRule": "kể từ lần liên hệ gần nhất",
      "cardWaiting": "Chờ CEO",
      "cardWaitingRule": "theo trạng thái",
      "cardNoEntity": "Chưa có pháp nhân",
      "cardNoEntityRule": "chưa có nơi phụ trách",
      "cardClosed": "Đóng trong tuần",
      "cardClosedRule": "đóng trong 7 ngày qua",
      "colTicket": "Phiếu",
      "colTitle": "Tiêu đề / từ",
      "colDesk": "Nhóm",
      "colType": "Loại",
      "colEntity": "Pháp nhân",
      "colContact": "Liên hệ nội bộ",
      "colOwner": "Người phụ trách",
      "colDue": "Hạn",
      "colStatus": "Trạng thái",
      "colLast": "Liên hệ gần nhất",
      "colDday": "D-day",
      "logTitle": "Nhật ký sự kiện",
      "logContacted": "Đã liên hệ họ",
      "logReply": "Họ đã trả lời",
      "ev_created": "tạo",
      "ev_contacted": "liên hệ",
      "ev_reply": "trả lời",
      "ev_status": "trạng thái",
      "ev_field": "sửa",
      "ev_closed": "đóng",
      "ev_reopened": "mở lại",
      "ev_note": "ghi chú",
      "closeTicket": "Đóng ticket",
      "reopenTicket": "Mở lại",
      "closeTitle": "Đóng {{id}}",
      "reopenTitle": "Mở lại {{id}}",
      "closeSub": "Ticket rời khỏi ĐANG LÀM và QUÁ HẠN, được tính vào ĐÓNG TRONG TUẦN. Ticket vẫn nằm trong danh sách và kết quả tìm kiếm, kèm toàn bộ lịch sử, và có thể mở lại.",
      "reopenSub": "Ticket quay về trạng thái trước khi đóng và được tính là đang mở trở lại.",
      "closeNote": "Ghi chú khi đóng (không bắt buộc)",
      "reopenNote": "Lý do mở lại (không bắt buộc)",
      "closeNotePh": "VD: Đã thống nhất qua điện thoại — không cần làm gì thêm.",
      "reopenNotePh": "VD: Họ trả lời kèm một yêu cầu mới.",
      "closedBy": "{{who}} đã đóng · {{when}}",
      "statusClosedHint": "Đã đóng — bấm Mở lại để đổi trạng thái.",
      "logNote": "Thêm ghi chú nội bộ",
      "logNoteSub": "Chỉ những ai mở được ticket này mới xem được trong portal, và không gửi mail cho ai. Ghi chú không tính là một lần liên hệ và không thay đổi Liên hệ gần nhất. Ctrl+Enter để ghi.",
      "logNoteWhy": "Ghi chú cho nhóm và CEO. Không thay đổi ngày hay bộ đếm nào.",
      "notePh": "Chuyện gì đã xảy ra, đã quyết định gì, việc gì tiếp theo.",
      "historyTitle": "Lịch sử",
      "hist_all": "Tất cả",
      "hist_mail": "Email",
      "hist_note": "Ghi chú",
      "hist_change": "Thay đổi",
      "historyEmpty": "Ticket chưa có mục nào thuộc loại này.",
      "hSent": "Email đã gửi",
      "hReceived": "Email đã nhận",
      "hSentWhy": "Gửi từ hộp thư Văn phòng CEO hoặc bởi một thành viên của nhóm.",
      "hReceivedWhy": "Gửi tới Văn phòng CEO từ bên ngoài.",
      "hTo": "Đến",
      "hCc": "Cc",
      "hQuoted": "Hiện các thư trước được trích dẫn trong mail này",
      "hQuotedHide": "Ẩn các thư được trích dẫn",
      "hNote": "Ghi chú nội bộ",
      "hCreated": "Đã tạo ticket",
      "hCreatedMail": "Ticket được tạo từ hộp thư Văn phòng CEO",
      "hClosed": "Đã đóng (trước đó: {{from}})",
      "hReopened": "Đã mở lại → {{to}}",
      "hFile": "Đã đính kèm file",
      "historyScope": "Email hiện ở đây khi tới {{mailbox}} — gửi tới, cc tới, hoặc gửi từ địa chỉ này. Mail mà thành viên nhóm gửi từ hộp thư riêng mà không cc {{mailbox}} thì portal không thấy được.",
      "restricted": "bị giới hạn — nhóm khác",
      "otherDesk": "Ticket này thuộc nhóm khác. Bạn thấy được ticket tồn tại nhưng không được xem lịch sử của nó.",
      "entityTitle": "Địa chỉ CC của pháp nhân",
      "entityFilled": "Đã đặt {{n}}/{{total}}",
      "entitySub": "Pháp nhân và người liên hệ nội bộ là những địa chỉ được cc trong mail gửi đi của ticket. Các ô này để trống cho đến khi Young gửi tám địa chỉ — địa chỉ ở đây sẽ nhận mail thật, nên không đoán địa chỉ nào.",
      "entityPh": "chưa đặt",
      "fTitle": "Tiêu đề",
      "fTitlePh": "Việc gì đã mở — nội dung ticket này theo dõi",
      "fFromPh": "Gửi từ ai, nếu có",
      "fTypePh": "Theo dõi, Pháp lý, Tài liệu…",
      "newLater": "Ngoài tiêu đề, mọi thông tin đều có thể để trống và điền sau — hầu hết các việc bắt đầu khi chưa có nơi phụ trách.",
      "fLaterPh": "Để trống nếu chưa biết",
      "tabTickets": "Ticket",
      "allDesks": "Tất cả",
      "unassigned": "Chưa phân nhóm",
      "choosedesk": "Đưa vào nhóm…",
      "deskRule": "Mỗi nhóm chỉ thấy ticket của mình. CEO thấy cả hai.",
      "open": "Mở",
      "fAllStatuses": "Tất cả trạng thái",
      "fAllTypes": "Tất cả loại",
      "fAllEntities": "Tất cả pháp nhân",
      "fAllContacts": "Tất cả liên hệ nội bộ",
      "fAllOwners": "Tất cả người phụ trách",
      "searchPh": "Tìm tiêu đề hoặc người gửi…",
      "searchLeadPh": "Tìm đối tác…",
      "ddayWhat": "Tính từ ngày Hạn. + là số ngày đã quá, - là số ngày còn lại.",
      "ddayLegend": "D-day tính từ ngày Hạn: +5 nghĩa là đã quá 5 ngày, -5 nghĩa là còn 5 ngày. Chỉ tính khi ticket đang mở.",
      "ev_file": "tệp",
      "fileUnreadable": "Không đọc được file đó.",
      "files": "Tệp đính kèm",
      "filesSub": "Những gì ticket này đang chờ, hoặc những gì được gửi kèm. Mỗi file tối đa 10 MB, {{n}} file mỗi ticket.",
      "addFile": "Thêm file",
      "removeFile": "Xóa",
      "removeFileSub": "File sẽ bị xóa khỏi máy chủ. Không thể hoàn tác.",
      "uploading": "Đang tải lên…",
      "logContactedSub": "Gửi qua kênh nào và đã nói gì. Cả hai đều không bắt buộc — ngày vẫn được ghi nhận. Ctrl+Enter để ghi.",
      "logReplySub": "Trả lời qua kênh nào và họ nói gì. Cả hai đều không bắt buộc — ngày vẫn được ghi nhận. Ctrl+Enter để ghi.",
      "channel": "Kênh",
      "channelPh": "Email, Điện thoại, Họp…",
      "contactNote": "Ghi chú",
      "contactNotePh": "VD: nhắc gửi bản đã ký",
      "replyNotePh": "VD: họ cần thêm hai tuần",
      "record": "Ghi lại",
      "colDwell": "Số ngày ở trạng thái",
      "nDays": "{{n}} ngày",
      "atStageN": "{{n}} ngày ở bước này",
      "worstN": "lâu nhất {{n}} ngày",
      "lateShape": "Việc trễ nằm ở đâu",
      "lateShapeSub": "một hàng chờ bị kẹt, hay tất cả",
      "nothingLate": "Không có việc nào quá hạn.",
      "howLong": "Nhóm này xử lý mất bao lâu",
      "howLongSub": "từ nhật ký sự kiện — không nhập tay",
      "toFirstAnswer": "Tạo → trả lời đầu tiên",
      "toClose": "Tạo → đóng",
      "neverAnswered": "Đang mở và chưa từng được trả lời",
      "medianOf": "trung vị của {{n}}",
      "notEnough": "chưa đủ dữ liệu — mới có {{n}}",
      "loading": "Đang tải…",
      "noHistory": "Chưa có ghi nhận nào.",
      "reset": "Đặt lại",
      "resetN": "Đặt lại ({{n}})",
      "sortedBy": "sắp xếp theo {{col}}",
      "showingN": "Hiển thị {{n}}/{{total}} —",
      "leadContactHint": "Ghi lại ngày — Liên hệ gần nhất và \"không trả lời\" đều tính từ ngày này.",
      "exportExcel": "Xuất Excel",
      "contactHint": "Ghi lại ngày — Liên hệ gần nhất và KHÔNG TƯƠNG TÁC 3+ NGÀY đều tính từ ngày này.",
      "logContactedWhy": "Mình đã liên hệ. Ghi ngày hôm nay vào ticket này và đếm lại số ngày không tương tác.",
      "logReplyWhy": "Họ đã trả lời. Cũng ghi ngày hôm nay — tách riêng vì đi nhắc và được trả lời là hai việc khác nhau.",
      "tab_tickets": "Ticket",
      "tab_leads": "Khách tiềm năng",
      "tab_daily": "Hằng ngày",
      "sub_tickets": "Mọi việc đã mở đều được theo dõi đến khi đóng. Mail chuyển tiếp tới ceo.office@ sẽ thành ticket; các bộ đếm được tính từ nhật ký sự kiện của từng ticket.",
      "sub_leads": "Danh sách phát triển khách hàng mới. CEO đặt thị trường cần tìm và điều kiện; nhóm liên hệ và đối chiếu câu trả lời với tiêu chí.",
      "sub_daily": "Bốn khối mỗi sáng. Màn hình và mail tự động hiển thị cùng một nội dung.",
      "newLead": "Khách tiềm năng mới",
      "newLeadSub": "Khách tiềm năng thuộc nhóm Business. Có thể gắn với ticket liên quan, hoặc tạo trước khi có ticket.",
      "needCounterparty": "Cần nhập tên đối tác.",
      "counterpartyPh": "Bên đang trao đổi với mình",
      "sectorPh": "Phân phối, Bán lẻ, Online…",
      "leadTicketPh": "Chọn ticket mà khách tiềm năng này thuộc về, nếu có",
      "countryPh": "Thái Lan, Việt Nam…",
      "criteriaPh": "Theo điều kiện của CEO…",
      "noLeads": "Chưa có khách tiềm năng.",
      "noReply": "{{n}} ngày chưa trả lời",
      "colLead": "Khách tiềm năng",
      "colCounterparty": "Đối tác",
      "colCountry": "Quốc gia",
      "colSector": "Lĩnh vực",
      "colStage": "Giai đoạn",
      "colCriteria": "Tiêu chí",
      "colNext": "Liên hệ tiếp theo",
      "leadsNote": "Khách tiềm năng chỉ thuộc nhóm Business. CEO quyết định thị trường nào và điều kiện gì; nhóm liên hệ, nhận câu trả lời và đối chiếu với tiêu chí.",
      "stageRule_Contacted": "đã gửi mail đầu tiên",
      "stageRule_Replied": "đối tác đã phản hồi",
      "stageRule_Checking_criteria": "đối chiếu điều kiện của CEO",
      "stageRule_With_CEO": "đạt, chờ quyết định",
      "stageRule_Closed": "chốt được hoặc không đạt tiêu chí",
      "dOpened": "Mở từ hôm qua",
      "dMoved": "Có thay đổi",
      "dOverdue": "Quá hạn",
      "dWaiting": "Chờ CEO",
      "nItems": "{{n}} mục",
      "reachFirst": "liên hệ trước",
      "nothingHere": "Không có.",
      "dailyNote": "Gửi lúc 08:30 giờ KL mỗi ngày trong tuần. Mỗi nhóm nhận mail riêng về ticket của mình; CEO nhận cả hai. Màn hình và mail hiển thị cùng một nội dung."
    },
    "pricing": {
      "title": "Công cụ tính giá Collab",
      "subtitle": "Giá thành, T1, MSRP và phí bản quyền trên một màn hình — tính giá bằng USD",
      "modeGeneral": "Collab thông thường · OEM / ODM",
      "modeGeneralSub": "Không phí bản quyền · Markup Base → T1 → MSRP",
      "modeLicensed": "Collab cấp phép (phí bản quyền)",
      "modeLicensedSub": "MSRP toàn cầu → giá địa phương → phí bản quyền",
      "padClose": "Đóng",
      "padNeedInstruction": "Hãy ghi điều khoản vào ô Chỉ thị bên dưới rồi bấm lại nút này.",
      "padOptionN": "Phương án {{n}}",
      "padInlineRrp": "Giá bán lẻ Inline",
      "padPremium": "Phụ trội Collab",
      "padTargetMsrp": "MSRP mục tiêu",
      "padOwnRetailRef": "Inline, để tham khảo",
      "padPartnerNa": "không áp dụng — Inline không bán cho đối tác",
      "padGapOwn": "Bán lẻ trực tiếp: Collab giữ {{c}}% so với Inline {{i}}%",
      "padGapPartnerBelow": "Bán sỉ đối tác: thấp hơn giá thành {{amt}} khi tính cả chi phí bổ sung",
      "padGapPartnerOk": "Bán sỉ đối tác: {{pct}}% sau chi phí bổ sung",
      "padToB7": "→ Khối 7: ai trả {{amt}} mỗi đơn vị này ở phía đối tác?",
      "padSkuN": "SKU {{n}}",
      "padB7NoteMany": "Một quyết định cho cả báo giá: {{n}} SKU, chi phí bổ sung {{e}} trên toàn đơn hàng. Ở A, B và C, MSRP và đơn giá đối tác giữ nguyên — chỉ khác ở bên chịu phần chi phí bổ sung đó.",
      "padFrameModel": "Mẫu khung",
      "padB1": "1 · Đơn hàng",
      "padKindOrder": "điều kiện dùng để tính các số liệu này",
      "padLeadDays": "{{d}} ngày → phụ phí lead time ngắn {{r}}",
      "padWhyShow": "lý do khác nhau ({{n}})",
      "padWhyHide": "ẩn",
      "padNoReason": "không có lý do",
      "padMoqNote": "Riêng phụ phí MOQ đã là {{amt}} — {{pct}}% chi phí bổ sung ở số lượng này.",
      "padB2": "2 · Giá nhà máy",
      "padB3": "3 · Giá khung",
      "padB4": "4 · Chi phí bổ sung",
      "padB5": "5 · Tổng giá thành",
      "padB6": "6 · Giá và biên lợi nhuận",
      "padB7": "7 · Ai chịu chi phí bổ sung — {{amt}} trên toàn đơn hàng {{n}} EA",
      "padB7Kind": "quyết định · một cú bấm · lợi nhuận ròng sau O.H",
      "padB7KindCalc": "chỉ xem · các thẻ người duyệt sẽ chọn",
      "paApproveOne": "chỉ chọn MỘT phương án",
      "paGmAll": "một tỷ lệ chung cho mọi mã",
      "paGmEach": "margin theo từng item",
      "paGmToAll": "áp cho tất cả",
      "paYlOnly": "YL chọn một phương án ở đây, trong màn Pricing Approval",
      "paSwitch": "Chọn phương án này",
      "padB7NoteCalc": "A, B và C có sẵn trên mọi báo giá. Thêm một phương án ở trên cho bất kỳ cách chia chi phí bổ sung nào khác — nó sẽ thành thêm một thẻ ở đây và trên màn hình của người duyệt.",
      "padB7Note": "Chỉ áp dụng cho kênh bán sỉ đối tác. Ở A, B và C, MSRP {{m}} và đơn giá đối tác {{p}} giữ nguyên — chỉ có {{e}} chi phí bổ sung mỗi đơn vị thay đổi.",
      "padKindCompare": "so sánh",
      "padKindSolo": "chỉ Collab · không so sánh",
      "padThisQuote": "báo giá này",
      "padCompareOnly": "chỉ để so sánh",
      "padInlineShort": "Inline",
      "padSameWord": "như nhau",
      "padNoBench": "không có đối chiếu",
      "padNoneWord": "không có",
      "padFactory": "Chi phí nhà máy",
      "padFrame": "Chi phí khung",
      "padFactoryN": "Giá nhà máy (2)",
      "padFrameN": "Giá khung (3)",
      "padExtraN": "Chi phí bổ sung (4)",
      "padExtraPerUnit": "Chi phí bổ sung mỗi đơn vị",
      "padBaseFrom": "= nhà máy {{f}} + khung {{r}}",
      "padBaseSub": "nhà máy + khung",
      "padPctOfTotal": "{{n}}% tổng giá thành",
      "padMultBase": "Chỉ giá cơ sở: Collab gấp {{x}}× Inline",
      "padMultAll": "Tính cả chi phí bổ sung: gấp {{x}}× Inline",
      "padLead": "Giá cơ sở gần như nhau. Vấn đề nằm ở chi phí bổ sung.",
      "padOwnRetailSub": "HINC và các bên khác bán theo MSRP",
      "padPartnerWs": "Bán sỉ đối tác",
      "padPartnerWsSub": "cung cấp ở mức {{p}}% MSRP",
      "padCallout": "Bán lẻ trực tiếp gánh chi phí bổ sung mà vẫn giữ được {{pct}}%. Bán sỉ đối tác thì không — sẽ xuống dưới giá thành. Khối 7 quyết định ai trả chi phí bổ sung ở phía đối tác.",
      "padMsrp": "MSRP",
      "padPartnerUnit": "Đơn giá đối tác",
      "padExtraBilledUnit": "+ chi phí bổ sung được thu",
      "padPerUnit": "/đơn vị",
      "padExtraAbsorbed": "Chi phí bổ sung Helinox gánh",
      "padGrossSub": "= O.H + lợi nhuận ròng",
      "padWhoA": "Chi phí bổ sung được tính thành một dòng riêng theo giá thành thực. Không cộng biên lợi nhuận.",
      "padWhoB": "Chi phí bổ sung được hạch toán vào chi phí marketing của HPAC. Đối tác chỉ thấy đơn giá.",
      "padWhoC": "Một nửa tính cho đối tác, một nửa Helinox gánh.",
      "padCeoDecision": "Quyết định của CEO",
      "padCeoDecisionSub": "Được ghi lại cùng với lần duyệt. Người yêu cầu hoàn tất báo giá theo các điều khoản này — không cần gửi lại.",
      "padDrowFinal": "Điều khoản cuối cùng",
      "padDrowRecorded": "Đã ghi nhận",
      "padOpenCalc": "Mở trong công cụ tính",
      "approverView": "Những gì người duyệt sẽ thấy",
      "approverViewSub": "Hai khối giống hệt màn hình Duyệt giá hiển thị, từ cùng số liệu. Chỉ xem — số liệu được nhập ở trên.",
      "padSubmittedBy": "người gửi",
      "padNoSnapshot": "Báo giá này được gửi trước khi có chức năng cố định số liệu, nên không có gì được ghi lại để hiển thị. Hãy mở trong công cụ tính để xem trạng thái hiện tại.",
      "padFrozen": "Các số liệu dưới đây là số đã gửi để duyệt.",
      "padEdited": "Báo giá đã được sửa sau khi gửi.",
      "padLine": "Hạng mục",
      "padCollab": "Collab",
      "padInline": "Inline",
      "padGap": "Chênh lệch",
      "padBase": "Giá cơ sở",
      "padExtra": "Chi phí bổ sung",
      "padExtraNote": "không phát sinh trong sản xuất Inline",
      "padTotal": "Tổng giá thành mỗi đơn vị",
      "padOrder": "Tổng đơn hàng · {{qty}} EA",
      "padPriceMargin": "Giá và biên lợi nhuận",
      "padOwnRetail": "Bán lẻ trực tiếp",
      "padPartner": "Bán sỉ đối tác · {{pct}}% MSRP",
      "padWeSell": "Giá bán",
      "padMarginPre": "Biên lợi nhuận trước chi phí bổ sung",
      "padMarginPost": "Biên lợi nhuận sau chi phí bổ sung",
      "padWhoCarries": "Ai chịu chi phí bổ sung — {{total}} trên {{qty}} EA",
      "padWhoSub": "Chỉ kênh bán sỉ đối tác. MSRP {{msrp}} và đơn giá đối tác {{unit}} giữ nguyên ở mọi phương án — chỉ chi phí bổ sung thay đổi.",
      "padOptA": "A · Đối tác trả chi phí bổ sung",
      "padOptB": "B · Helinox gánh",
      "padOptC": "C · Chia 50 / 50",
      "fxBilledRule": "chi phí bổ sung × tỷ lệ đối tác chịu",
      "fxRevenueRule": "số lượng × MSRP của từng SKU, cộng cho cả đơn",
      "fxAbsorbedRule": "chi phí bổ sung − phần thu từ đối tác",
      "fxGrossRule": "doanh thu đối tác + chi phí bổ sung được thu − tổng giá thành",
      "fxOhRule": "giá cơ sở của đơn hàng × tỷ lệ O.H",
      "fxNetRule": "lợi nhuận gộp − Helinox O.H",
      "fxMarginRule": "lợi nhuận ròng ÷ doanh thu đối tác",
      "padGate": "Duyệt báo giá này?",
      "padGateSub": "Báo giá đang ở bước {{status}}. Ở bước tiếp theo bạn quyết định từng SKU, kèm theo ghi chú.",
      "padGateApprove": "Duyệt",
      "padGateReject": "Trả lại",
      "padGateCancel": "Để sau",
      "padOtherCostings": "Báo giá này còn có {{n}} cách tính giá khác",
      "padOtherCostingsSub": "Cùng báo giá này được tính theo cách khác, lập trong công cụ tính. Mỗi cách đều được tính theo A để đối chiếu với thẻ A — chọn một cách nghĩa là lấy cách tính đó với đối tác chịu chi phí bổ sung.",
      "padRefAt": "Tính theo A · đối tác trả chi phí bổ sung",
      "padSettings": "Thiết lập dùng để tính các số liệu này",
      "padSetPremium": "Phụ trội Collab",
      "padSetPartner": "Biên lợi nhuận đối tác",
      "padSetSplitC": "Tỷ lệ chia (thẻ C)",
      "padSetOh": "Helinox O.H",
      "padSetOhVal": "{{pct}}% giá cơ sở",
      "padSetCase": "Trường hợp",
      "padOptTerms": "Điều khoản khác",
      "padOptTermsSub": "Không thẻ nào ở trên phù hợp? Hãy ghi điều khoản vào ô Chỉ thị bên dưới. Người yêu cầu sẽ hoàn tất báo giá theo nội dung đó.",
      "padSrcPortal": "Mặc định của portal",
      "padSrcQuote": "Người yêu cầu thêm",
      "padSrcApprover": "Bạn ghi điều khoản",
      "padSumHead": "Bạn đang duyệt {{n}} trên {{all}} SKU của báo giá này",
      "padSumCard": "Ai chịu chi phí bổ sung",
      "padSumQty": "Số lượng được duyệt",
      "padSumNoCard": "Chưa chọn thẻ nào, nên lần duyệt này chỉ chốt các SKU và để chi phí bổ sung chưa phân bổ.",
      "padSumNothing": "Tất cả SKU đều đã bị loại. Hãy dùng Trả lại cho cả báo giá.",
      "padSumUnread": "Trong đó có {{n}} SKU bạn chưa mở.",
      "padSkuUnseen": "chưa mở",
      "padSkuCut": "bị loại",
      "padSkuSeen": "Bạn đã mở {{n}} trên {{all}} SKU của báo giá này",
      "padSkuAllSeen": "Bạn đã mở cả {{n}} SKU",
      "padSkuCutN": "{{n}} SKU đã bị loại trước đó",
      "padCardScope": "Các số liệu này tính cho {{n}} SKU còn lại, không phải cả {{all}} SKU trong báo giá.",
      "padCardGone": "— phương án này không còn trên báo giá",
      "padBilled": "Chi phí bổ sung thu từ đối tác",
      "padRevenue": "Doanh thu bán (SL × MSRP)",
      "padAllIn": "Đối tác trả tổng cộng",
      "padGross": "Lợi nhuận gộp của đơn hàng",
      "padOh": "Helinox O.H · {{pct}}% giá cơ sở",
      "padNetProfit": "Lợi nhuận ròng của Helinox trên đơn hàng",
      "padNetMargin": "Biên lợi nhuận ròng · % giá đối tác",
      "padSelect": "Chọn {{key}}",
      "padDecision": "Quyết định đã ghi nhận",
      "padChosen": "Ai chịu chi phí bổ sung",
      "padUndecided": "Chưa quyết định",
      "padInstruction": "Chỉ thị",
      "padInstructionPh": "VD: Chọn A, nhưng làm tròn đơn giá đối tác thành $60 và tính chi phí bổ sung thành một khoản trọn gói.",
      "padSaveInstruction": "Lưu chỉ thị",
      "padDecisionSaved": "Quyết định đã được ghi nhận.",
      "padMemo": "Ghi chú cuối của Sales OP",
      "padMemoSub": "Giá và điều khoản cuối cùng đã thống nhất, sau khi đọc quyết định ở trên. Chỉ ghi được một lần và không sửa được sau đó.",
      "padMemoPh": "Giá và điều khoản cuối cùng đã thống nhất…",
      "padMemoWaitShort": "Chưa ghi nhận",
      "padMemoWait": "Báo giá này chưa có quyết định nào.",
      "padMemoSave": "Ghi lại ghi chú",
      "padMemoSaved": "Ghi chú đã được ghi lại.",
      "modeRules": "Quy tắc tính giá",
      "modeRulesSub": "Quản trị · các hằng số dùng để tính mọi báo giá",
      "rulesTitle": "Quy tắc tính giá",
      "rulesSub": "Thay đổi áp dụng cho các báo giá được tạo SAU khi lưu. Báo giá đã lập giữ nguyên quy tắc lúc được tính, nên không báo giá nào đã có bị thay đổi.",
      "ruleName": "Quy tắc",
      "ruleNow": "Đang áp dụng",
      "ruleNew": "Giá trị mới",
      "ruleWhy": "Lý do",
      "ruleWhyPh": "Vì sao thay đổi?",
      "ruleSave": "Lưu",
      "ruleSaved": "Đã lưu. Các báo giá tạo từ bây giờ sẽ dùng quy tắc mới.",
      "ruleHistory": "Mọi thay đổi, mới nhất trước",
      "ruleValue": "Giá trị",
      "ruleBy": "Người thay đổi",
      "ruleFrom": "Áp dụng từ",
      "rule_partner_ratio_pct": "Giá đối tác",
      "ruleHint_partner_ratio_pct": "Giá đối tác tính theo tỷ lệ phần trăm của MSRP.",
      "rule_tier_oh_pct": "Helinox O.H",
      "ruleHint_tier_oh_pct": "Phần chi phí chung (overhead) trong tỷ lệ tier. Dùng làm giá trị ban đầu cho báo giá mới; báo giá đã lưu giữ giá trị riêng.",
      "rule_frame_profit_pct": "Lợi nhuận khung",
      "ruleHint_frame_profit_pct": "Giá khung × tỷ lệ này, trừ khi khung được cấp miễn phí.",
      "modeSaved": "Dự án đã lưu",
      "modeSavedSub": "Xem · mở · xuất Excel",
      "modeOpa": "OPA / SCT",
      "modeOpaSub": "Phân tích công đoạn · thời gian chu kỳ chuẩn",
      "projectPlaceholder": "Tên dự án — VD: 26FW MICRO KICKBOARD x Chair One (re)",
      "template": "Mẫu nhập",
      "importExcel": "Nhập Excel",
      "importBom": "Nhập BOM nhà cung cấp",
      "bomRead": "Đã đọc theo BOM {{vendor}} — {{n}} SKU từ: {{names}}",
      "bomFailed": "Không đọc được BOM này",
      "bomLookedFor": "Portal biết hai định dạng của nhà cung cấp và đã tìm:",
      "bomSheets": "Các sheet trong file này: {{list}}",
      "dismiss": "bỏ qua",
      "imported": "Đã tải {{n}} SKU từ file — kiểm tra số liệu rồi bấm Lưu dự án.",
      "save": "Lưu dự án",
      "saveChanges": "Lưu thay đổi",
      "newProject": "Dự án mới",
      "exportExcel": "Xuất Excel",
      "savedAs": "Đã lưu thành {{id}} — màn hình đã sẵn sàng cho dự án tiếp theo.",
      "loaded": "Đã mở {{id}} — Lưu sẽ cập nhật dự án rồi làm trống màn hình.",
      "needName": "Hãy đặt tên dự án trước.",
      "needSave": "Hãy lưu dự án trước — file xuất đọc theo dữ liệu đã lưu.",
      "deleteAsk": "Xóa {{id}}? Dự án rời khỏi danh sách; bản tính giá vẫn được giữ lại.",
      "sku": "SKU",
      "addSku": "Thêm SKU",
      "duplicate": "Nhân bản",
      "del": "Xóa",
      "inputs": "Đầu vào",
      "collapse": "Thu gọn",
      "expand": "Mở rộng",
      "results": "Kết quả",
      "skuName": "SKU / tên mặt hàng",
      "skuNameHint": "Tên để phân biệt mặt hàng này trong dự án.",
      "qty": "Số lượng đặt hàng (EA)",
      "qtyHint": "Quyết định phụ phí MOQ và khoản ghi nợ HPAC.",
      "poDate": "Ngày phát hành PO",
      "poDateHint": "Ngày bắt đầu tính lead time.",
      "xfDate": "Ngày XF yêu cầu",
      "xfDateHint": "XF − PO = thời gian sản xuất.",
      "moqLabel": "MOQ",
      "moqNone": "Từ 500 pcs trở lên → không phụ phí",
      "moqApplied": "{{qty}} pcs → {{rate}} của {{of}}",
      "moqQtyPcs": "{{qty}} pcs →",
      "moqOfBase": "tính trên {{of}}",
      "leadLabel": "Lead time",
      "leadNone": "nhập cả hai ngày để tính",
      "leadDays": "{{days}} ngày → phụ phí lead time ngắn {{rate}}",
      "leadWarn": "{{days}} ngày là dưới 60 — quy định không có mức giá cho trường hợp này. Tạm áp dụng 50% và phụ phí cần được thương lượng.",
      "baseTitle": "Giá Markup Base",
      "baseSub": "Biên lợi nhuận chỉ được tính trên các khoản này và phí FM, ngoài ra không có gì khác.",
      "skin": "Skin + Case + bao bì",
      "skinHint": "Tổng vải skin, case và bao bì.",
      "cmt": "CMT nhà cung cấp",
      "cmtHint": "Công may của nhà cung cấp (Cut · Make · Trim).",
      "ohp": "OH & lợi nhuận nhà cung cấp",
      "ohpHint": "Chi phí chung và biên lợi nhuận của nhà cung cấp.",
      "frame": "Chi phí khung",
      "frameHint": "Chọn mẫu để điền tự động từ bảng giá khung.",
      "framePick": "Chọn mẫu khung…",
      "frameSupply": "Cung cấp khung",
      "supplySell": "Bán cho nhà cung cấp",
      "supplySellHint": "Lợi nhuận khung + phí xử lý $0.50 + cước vận chuyển (p.19)",
      "supplyFoc": "Cấp miễn phí (FOC)",
      "supplyFocHint": "Chỉ phí FM $0.04 (p.13, p.20)",
      "matSupply": "Cung cấp nguyên liệu",
      "matVendor": "Nhà cung cấp tự mua",
      "matVendorHint": "Vải, case và bao bì do nhà cung cấp tự mua.",
      "matFf": "Helinox cấp (FF)",
      "matFfHint": "Nhà cung cấp không tốn tiền nguyên liệu, nên thay vào đó tính phí FF CMT.",
      "frameProfitRate": "Tỷ lệ lợi nhuận khung",
      "excludedTitle": "Hạng mục loại trừ",
      "excludedSub": "Các chi phí không phát sinh trong sản xuất Inline. Chúng nằm trong cơ sở tính biên lợi nhuận T1 và cũng được thu lại từ đối tác dưới dạng khoản ghi nợ marketing HPAC; T2 được tính không bao gồm chúng. Nhập tay vào một ô chỉ ghi đè quy tắc cho riêng ô đó.",
      "autoToggle": "Tự động theo quy định",
      "autoTag": "tự động",
      "resetOverride": "thủ công — đặt lại",
      "fprofit": "Lợi nhuận khung",
      "fprofitHint": "Giá khung x tỷ lệ lợi nhuận. Bằng 0 khi khung được cấp miễn phí.",
      "handling": "Phí xử lý",
      "handlingHint": "$0.50 khi Helinox bán khung cho nhà cung cấp (p.19).",
      "fmfee": "Phí FM",
      "fmfeeHint": "$0.04 khi khung được cấp miễn phí (p.13, p.20). Thuộc giá cơ sở.",
      "transport": "Vận chuyển",
      "transportHint": "Cước thực tế — không ước đoán.",
      "moqCharge": "Phụ phí MOQ",
      "moqChargeHint": "Markup Base x tỷ lệ MOQ (p.15).",
      "addMat": "Nguyên liệu bổ sung",
      "addMatHint": "Những gì đơn hàng cần mà giá cơ sở không bao gồm.",
      "ffcmt": "Phí FF CMT",
      "ffcmtHint": "Công gia công của nhà cung cấp trên nguyên liệu do Helinox cấp. Được cộng sau phụ phí.",
      "ffcmtOff": "Chỉ khi Helinox cấp nguyên liệu — xem Cung cấp nguyên liệu.",
      "shortLead": "Phụ phí giao gấp",
      "shortLeadHint": "CMT nhà cung cấp x (1 + tỷ lệ MOQ) x tỷ lệ lead time ngắn (p.21).",
      "moqBaseLabel": "Phụ phí MOQ tính trên",
      "moqBaseHint": "Bỏ chọn những khoản mà nhà cung cấp này cộng sau phụ phí thay vì tính bên trong.",
      "part_skin": "Skin + Case + bao bì",
      "part_cmt": "CMT nhà cung cấp",
      "part_ohp": "OH & lợi nhuận",
      "part_frame": "Khung",
      "part_fmfee": "Phí FM",
      "pricingTitle": "Tính giá",
      "stepProfit": "Mô phỏng lợi nhuận / MSRP",
      "stepTarget": "MSRP mục tiêu",
      "t1Ratio": "Lợi nhuận HPAC bên ngoài (tỷ lệ T2)",
      "t1RatioHint": "Biên lợi nhuận TRÊN T2, không phải markup trên giá cơ sở. Bắt buộc với Trường hợp A.",
      "t0Ratio": "Lợi nhuận HPAC nội bộ (tỷ lệ T1)",
      "t0RatioHint": "Cấp của pháp nhân Helinox. Bắt buộc với Trường hợp B.",
      "options": "Phương án",
      "optionsNote": "Mỗi phương án là báo giá này với một hoặc hai điều kiện được thay đổi — nó đi theo mọi số liệu ở trên.",
      "optionAdd": "Thêm phương án",
      "optionN": "Phương án {{n}}",
      "optAsQuoted": "Báo giá gốc",
      "optAsQuotedSub": "số liệu đã nhập ở trên",
      "optNoCond": "chưa thay đổi gì",
      "optSameAsQuote": "Giống báo giá — đổi một giá trị bên trái thì các số này thay đổi theo.",
      "optEdit": "Điều kiện",
      "optCancel": "Hủy",
      "optDone": "Xong",
      "optRemove": "Xóa",
      "optCondNote": "Đổi bất kỳ giá trị nào ở đây. Mục nào giữ nguyên sẽ theo báo giá.",
      "optQuoteReadOnly": "Số liệu gốc của báo giá, dùng để đối chiếu với option. Sửa chúng ở các khối phía trên.",
      "optClose": "Đóng",
      "optOrderProfitT1": "Lợi nhuận cả đơn hàng tại T1",
      "optOrderProfitT2": "Lợi nhuận cả đơn hàng tại T2",
      "optQty": "Số lượng đặt hàng",
      "optBasis": "Cơ sở tính biên lợi nhuận",
      "optT1Profit": "Lợi nhuận T1",
      "optT2Ratio": "Tỷ lệ T2",
      "optT2Profit": "Lợi nhuận T2",
      "optPremium": "Phụ trội Collab",
      "optShortLead": "Phụ phí giao gấp",
      "benchTitle": "Đối chiếu inline",
      "benchTag": "chỉ để so sánh",
      "benchLine": "Khoản chi phí",
      "benchThis": "Báo giá này",
      "benchInline": "Sản phẩm inline",
      "benchDiff": "Chênh lệch",
      "vsInline": "so với giá bán lẻ inline",
      "linesApplied": "Các dòng chi phí bổ sung 1 mà option này tính",
      "qtyWord": "số lượng đặt hàng",
      "targetHint": "Giá bán lẻ inline × (1 + phụ trội Collab)",
      "lineDropped": "không tính",
      "inclTitle": "Nằm trong số tiền dùng để tính biên lợi nhuận",
      "exclTitle": "Nằm ngoài — thu hồi qua khoản ghi nợ marketing HPAC",
      "inclBoth": "cũng nằm trong cơ sở tính biên lợi nhuận, nên bị thu hồi hai lần",
      "inclTotal": "cơ sở tính biên lợi nhuận",
      "exclTotal": "ghi nợ cho đối tác",
      "quotedIn": "có tính biên lợi nhuận",
      "quotedOut": "ngoài biên lợi nhuận",
      "estIsCheck": "Chỉ để đối chiếu, không phải MSRP của báo giá — không phép tính nào phía sau dùng số này. MSRP của báo giá nằm ở khối 6.",
      "msrpIsQuote": "MSRP của báo giá",
      "factoryWord": "nhà máy",
      "frameWord": "khung",
      "marginAtQty": "Biên lợi nhuận tại {{n}} EA",
      "gapWord": "Chênh lệch",
      "collabCol": "Collab",
      "benchCol": "Inline",
      "benchTotal": "Chi phí nhà máy",
      "benchWhy": "Lý do chênh lệch",
      "benchWhyHint": "Những gì bản Collab thêm vào hoặc bỏ đi so với bản inline — câu người duyệt đọc bên cạnh khoản chênh lệch. Không gì ở bước này làm thay đổi báo giá.",
      "ohPart": "O.H",
      "ohPartFixed": "O.H (cố định)",
      "frameModelLabel": "Mẫu khung",
      "benchLinkedTo": "Liên kết với",
      "benchNoModel": "chưa chọn mẫu khung",
      "benchFollowsFrame": "theo mẫu khung đã chọn ở khối 3",
      "benchFromCollab": "từ Collab",
      "benchFrameHint": "Khung mà sản phẩm inline sử dụng, theo giá niêm yết của chính nó.",
      "benchModelHint": "Theo khối 3 — cùng một linh kiện, nên chênh lệch nằm ở giá chứ không phải ở thiết kế.",
      "benchSame": "giống nhau",
      "benchBase": "cơ sở",
      "blkExtra": "bổ sung",
      "fxBuying": "Giá vốn một đơn vị trước khi cộng biên lợi nhuận",
      "fxBuyingRule": "Cơ sở là nhà máy + khung — số tiền dùng để áp tỷ lệ các bậc. Chi phí bổ sung được cộng SAU biên lợi nhuận và không bao giờ bị cộng markup. Cộng hai phần lại là giá mua.",
      "fxBenchBase": "Giá thành inline (skin + CMT + OH & lợi nhuận + khung)",
      "fxBenchBaseRule": "Chi phí nhà máy của chính sản phẩm inline cộng với khung nó sử dụng, theo giá niêm yết của khung. Không cộng thêm gì sau đó — phía inline không có chi phí bổ sung.",
      "benchFrameLabel": "Chi phí khung",
      "benchImport": "Điền từ bảng giá thành",
      "benchImportHint": "Điền cột này từ một bảng giá thành đã lưu trong Bảng giá thành inline.",
      "benchSrc": "Nguồn",
      "benchPickTitle": "Báo giá này được so với dòng nào?",
      "benchPickBody": "{{file}} có giá cho {{n}} dòng. Chọn dòng để so với báo giá này — số trên mỗi dòng là giá mua do chính bảng đó ghi.",
      "benchVariant": "Phiên bản giá thành",
      "benchApply": "Điền số đối chiếu",
      "benchRefused": "Không đọc được {{n}} dòng vì tổng các cột không khớp với giá mua ghi bên cạnh:",
      "benchLibBody": "Tìm bảng giá thành đã lưu trong Bảng giá thành inline theo style, SKU, màu hoặc tên file.",
      "benchSearch": "Tìm style, SKU, màu, file…",
      "benchNewFile": "Đọc file mới…",
      "benchBackToLib": "Quay lại thư viện",
      "benchLibEmpty": "Chưa có bảng giá thành nào được lưu. Bảng được đọc vào ở Sales Operation → Bảng giá thành inline.",
      "benchNoHit": "Không có mục nào trong thư viện khớp với \"{{q}}\".",
      "benchLineCol": "Khoản mục",
      "benchWhyCol": "Giải thích",
      "benchWhyPh": "Lý do chênh lệch",
      "benchNoGap": "Không chênh lệch — không cần giải thích",
      "benchAllLevel": "Mọi khoản đều khớp với sản phẩm inline — không cần giải thích.",
      "benchNotFilled": "Điền phần đối chiếu inline để xem hai bên khác nhau ở đâu.",
      "benchElsePh": "Khoản khác…",
      "benchBomSub": "Chênh lệch BOM giữa giá Collab và giá inline.",
      "stepExtra2": "Chi phí bổ sung 2",
      "stepExtra2Sub": "(So sánh chi phí)",
      "addMatWhat": "Là khoản gì…",
      "addLine": "Thêm dòng",
      "removeLine": "Xóa dòng này",
      "ohLine": "Helinox O.H",
      "profitLine": "Lợi nhuận Helinox",
      "extraLine": "Chi phí bổ sung",
      "extraFromBlock": "từ khối 4",
      "inclExtra": "O.H + lợi nhuận + chi phí bổ sung — số đối tác phải trả",
      "fxOpen": "Cách tính {{what}}",
      "fxFactory": "Chi phí nhà máy",
      "fxFrame": "Chi phí khung",
      "fxExtra": "Chi phí bổ sung 1",
      "t2Divide": "{{basis}} ÷ (1 − {{r}}%)",
      "t2ThisQuote": "báo giá này",
      "t2Both": "Cùng một tỷ lệ áp cho từng cách tính giá trong hai cách. Báo giá dùng cách được đánh dấu — việc chọn cách nào được thực hiện ở option.",
      "t2BasisFromOpt": "đặt theo từng option",
      "fxT2": "Cách tính giá T2",
      "fxT2Rule": "Biên lợi nhuận được trừ RA từ giá bán, không cộng thêm lên trên: cơ sở chia cho (1 trừ tỷ lệ T2). Đây là cách mọi báo giá đã lưu đang dùng — cách cộng dồn dùng cho T1 sẽ ra số khác.",
      "fxExtraAfter": "cộng sau biên lợi nhuận, không bao giờ cộng markup",
      "fxT1Base": "Chi phí nhà máy + Chi phí khung + Chi phí bổ sung 1",
      "t1BaseLine": "Chi phí nhà máy + Chi phí khung + Chi phí bổ sung 1",
      "optExtraOff": "Các dòng chi phí bổ sung 1 được áp dụng",
      "optExtraOffLbl": "không",
      "optExtraOffNone": "tất cả",
      "optExtraOffSome": "bỏ {{n}}",
      "t1Sum": "cơ sở + O.H + lợi nhuận",
      "fxT1On": "tính trên {{n}}",
      "fxOh": "Helinox O.H",
      "fxProfit": "Lợi nhuận Helinox",
      "fxTier": "Giá theo bậc",
      "fxMsrp": "MSRP mục tiêu",
      "fxLead": "Thời gian giao hàng",
      "fxBenchProfit": "Lợi nhuận của sản phẩm inline",
      "fxMoq": "Phụ phí MOQ",
      "fxSl": "Phụ phí giao gấp",
      "fxFprofit": "Lợi nhuận khung",
      "byOption": "Cùng một báo giá, theo từng option",
      "optPick": "Option này thay đổi:",
      "optName": "Tên option",
      "optNamePh": "Option {{n}} — nhập tên dễ nhận biết",
      "fxBenchRule": "Giá thành của chính sản phẩm inline, áp tỷ lệ lợi nhuận T1 của bản Collab — không có tỷ lệ riêng cho phần đối chiếu.",
      "optDropCond": "Bỏ mục này khỏi option",
      "tierSubAny": "O.H + lợi nhuận + chi phí bổ sung, theo tỷ lệ của chính cột đó",
      "tierSubOwn": "O.H + lợi nhuận + chi phí bổ sung",
      "fxTimesQty": "Mỗi đơn vị × số lượng đặt hàng — cả đơn hàng, không phải một đơn vị.",
      "fxDebitRule": "Mọi khoản bị loại trừ, tính cho đối tác cộng thêm vào giá theo bậc.",
      "fxDebitInPrice": "Không ghi nợ khoản nào — theo cách tính này, khoản đó đã nằm trong giá.",
      "profitSubOwn": "O.H và lợi nhuận mà bậc này thu được, trên mỗi đơn vị",
      "ohShareAny": "trong đó O.H",
      "profitShareAny": "trong đó lợi nhuận",
      "optSameShort": "giống báo giá",
      "revenueSubAny": "giá theo bậc × số lượng đặt hàng — cả đơn hàng, không phải một đơn vị",
      "totalProfitSubAny": "lợi nhuận mỗi đơn vị × số lượng đặt hàng — doanh thu trừ giá vốn của đơn hàng",
      "fxExtraRule": "Tổng tất cả các khoản bị loại trừ.",
      "fxMoqRule": "Cơ sở MOQ nhân với tỷ lệ ứng với số lượng đặt hàng.",
      "fxMoqBase": "Cơ sở MOQ",
      "fxSlRule": "CMT của nhà cung cấp nhân với tỷ lệ giao gấp ứng với thời gian giao hàng.",
      "extraInBase": "nằm trong cơ sở",
      "unit": "đơn vị",
      "totalWord": "Tổng",
      "estMsrp": "MSRP ước tính: từ",
      "estTo": "đến",
      "estTimes": "lần →",
      "targetMsrp": "MSRP mục tiêu",
      "targetMsrpHint": "Giá bán lẻ inline × (1 + phụ trội).",
      "msrpOverT1": "MSRP ÷ T1",
      "msrpOverT1Hint": "hệ số nhân đạt được",
      "yTarget": "Mục tiêu của Y",
      "yTargetHint": "Mục tiêu đặt theo tỷ lệ so với giá inline. Không bắt buộc.",
      "collabVsInline": "Collab so với inline",
      "blockResult": "Kết quả / Option",
      "blockDetail": "Cách hình thành số liệu",
      "optConditions": "Điều kiện",
      "colCollab": "Collab",
      "colInline": "Đối chiếu inline",
      "profitPart": "Lợi nhuận",
      "ohShare": "trong đó O.H ({{pct}})",
      "profitShare": "trong đó lợi nhuận ({{pct}})",
      "dealCase": "Trường hợp",
      "dealCaseHint": "Đây là mô hình hợp tác nào — quyết định tỷ lệ bậc nào là bắt buộc.",
      "dealCasePick": "Chọn trường hợp…",
      "dealCaseBoth": "Cả hai",
      "dealCaseA": "Trường hợp A: HPAC hợp tác trực tiếp",
      "dealCaseB": "Trường hợp B: Công ty con chủ trì hợp tác",
      "dealCasePath_both": "Nhà máy → HPAC → đối tác   ·   Nhà máy → HPAC → công ty con Helinox → thị trường của công ty đó",
      "dealCasePath_a": "Nhà máy → HPAC → đối tác hợp tác",
      "dealCasePath_b": "Nhà máy → HPAC → công ty con Helinox → thị trường riêng của công ty đó",
      "dealCasePathLbl": "Ai bán cho ai",
      "dealCaseWhat_both": "Tính giá cho cả hai luồng: HPAC mua rồi bán lại, và một công ty con Helinox cũng bán tại thị trường của mình. Bắt buộc nhập cả hai tỷ lệ bậc.",
      "dealCaseWhat_a": "HPAC mua hàng từ nhà máy và bán thẳng cho đối tác hợp tác. Không có công ty con Helinox nào ở giữa, nên chỉ tính giá bậc HPAC.",
      "dealCaseWhat_b": "Một công ty con Helinox — Helinox Inc., Helinox Japan, v.v. — mua từ HPAC và bán tại thị trường của mình. Bước thứ hai đó là phần mà bậc công ty con tính giá.",
      "needPhoto": "Thêm ít nhất một ảnh trước khi lưu.",
      "needCase": "{{sku}}: chọn trường hợp.",
      "needT1": "{{sku}}: trường hợp này bắt buộc nhập tỷ lệ T1.",
      "needT2": "{{sku}}: trường hợp này bắt buộc nhập tỷ lệ T2.",
      "needInlineRrp": "{{sku}}: bắt buộc nhập giá bán lẻ inline.",
      "needPremium": "{{sku}}: bắt buộc nhập phụ trội Collab.",
      "marginBasis": "Cơ sở tính biên lợi nhuận",
      "marginBasisBase": "Markup Base (theo hướng dẫn)",
      "marginBasisBuying": "Tổng giá mua (bảng báo giá)",
      "marginBasisBaseHint": "Các khoản bị loại trừ nằm ngoài cơ sở T2 — chúng được thu hồi qua khoản ghi nợ HPAC.",
      "marginBasisBuyingHint": "Mọi khoản đều được cộng markup, nên không ghi nợ riêng khoản nào.",
      "partnerRatio": "Tỷ lệ đối tác",
      "partnerRatioHint": "Giá đối tác tính theo tỷ lệ của MSRP.",
      "inlineRrp": "Giá bán lẻ inline",
      "productPage": "Trang sản phẩm",
      "folderPlaceholder": "Thư mục — vd. 27SS",
      "folderNone": "Chưa xếp thư mục",
      "newFolder": "Thư mục mới",
      "newFolderPlaceholder": "Tên thư mục",
      "renameFolder": "Đổi tên",
      "renameFolderTitle": "Đổi tên {{name}}",
      "deleteFolderTitle": "Xóa thư mục {{name}}?",
      "deleteFolderBody": "Các báo giá bên trong vẫn được giữ — chúng quay về Chưa xếp thư mục.",
      "dragHint": "Kéo một dòng thả vào thư mục để xếp vào đó.",
      "approvePricing": "Duyệt giá",
      "inlineRrpHint": "Giá bán lẻ của sản phẩm inline tương đương.",
      "premium": "Phụ trội Collab",
      "premiumHint": "Phần tăng thêm do hợp tác, tính theo % của RRP inline.",
      "markupBase": "Markup Base",
      "markupBaseSub": "Chi phí làm cơ sở tính biên lợi nhuận",
      "composition": "Cấu thành FOB của nhà cung cấp",
      "pricingResults": "Kết quả tính giá",
      "buyingCost": "Tổng giá mua",
      "buyingCostSub": "Markup Base + các khoản loại trừ",
      "hpacUnit": "Chi phí marketing HPAC",
      "hpacUnitSub": "mỗi đơn vị",
      "hpacTotal": "Chi phí marketing HPAC",
      "hpacTotalSub": "tổng ghi nợ · mỗi đơn vị × SL đặt hàng",
      "t1": "T2 (Thương hiệu đối tác)",
      "t1Sub": "Markup Base ÷ (1 − tỷ lệ T2)",
      "colStatus": "Trạng thái",
      "stDraft": "Nháp",
      "colNo": "STT",
      "countAll_one": "{{count}} báo giá",
      "countAll_other": "{{count}} báo giá",
      "countOf": "{{n}} trên {{total}}",
      "allTeams": "Tất cả nhóm",
      "approvalTitle": "Duyệt giá",
      "approvalSub": "Hai cấp: quản lý Sales, rồi đến CEO. Báo giá ở đây là việc đang chờ ai đó xử lý.",
      "colTeam": "Sales OP",
      "colTrail": "Lịch sử",
      "colSubmittedBy": "Người gửi",
      "colNote": "Ghi chú",
      "colCreatedBy": "Người tạo",
      "colCreatedAt": "Ngày tạo",
      "colModifiedBy": "Người sửa",
      "colModifiedAt": "Ngày sửa",
      "selected": "Đã chọn {{n}}",
      "approveSelected": "Duyệt mục đã chọn",
      "clearSelection": "Bỏ chọn",
      "submitTitle": "Gửi {{id}}",
      "submitBody": "Thêm ghi chú cho {{who}} — vì sao có giá này, hoặc đã thay đổi gì. Không bắt buộc.",
      "submitPh": "vd. cập nhật chi phí khung theo báo giá nhà cung cấp ngày 9 tháng 9",
      "recall": "Thu hồi",
      "recallTitle": "Thu hồi {{id}}",
      "recallBody": "Thao tác này rút báo giá khỏi hàng chờ của {{who}} và đưa về Nháp để bạn sửa và gửi lại. Người đó sẽ nhận email báo rằng báo giá không còn chờ họ nữa.",
      "recallPh": "Lý do thu hồi (không bắt buộc)",
      "remind": "Nhắc duyệt",
      "remindTitle": "Nhắc duyệt {{id}}",
      "remindBody": "{{who}} sẽ nhận email báo rằng báo giá này vẫn đang chờ họ quyết định, kèm link. Người tạo được CC. Mỗi báo giá chỉ nhắc 4 tiếng một lần.",
      "remindPh": "Lời nhắn thêm (không bắt buộc), vd. đối tác cần giá trước thứ 6",
      "remindSend": "Gửi nhắc",
      "remindSent": "Đã gửi nhắc duyệt {{id}} tới {{to}}.",
      "reminded": "{{who}} đã nhắc · {{at}}",
      "remindCount": "Đã nhắc {{n}} lần",
      "remindSoon": "{{who}} đã gửi nhắc rồi. Lần nhắc tiếp theo được gửi từ {{at}}.",
      "noteFrom": "Ghi chú",
      "noteManager": "Quản lý",
      "noteFinal": "Người duyệt cuối",
      "gateBy": "do {{who}} gửi",
      "openMissing": "{{id}} không có trong danh sách này — có thể đã được duyệt.",
      "deleted": "Đã xóa {{id}}.",
      "deleteTitle": "Xóa dự án này?",
      "deleteBody": "{{id}} sẽ bị gỡ khỏi danh sách đã lưu. Bản tính giá vẫn được giữ và quản trị viên có thể khôi phục.",
      "confirmDelete": "Xóa",
      "stagePending": "Đang chờ",
      "stagePendingHint": "Đang ở người soạn — bản nháp mới và những báo giá bị trả lại. Trạng thái trên dòng cho biết là loại nào.",
      "stageManager": "Quản lý Sales — duyệt",
      "stageManagerHint": "Đã gửi, đang chờ quản lý nhóm Sales OP.",
      "stageFinal": "CEO — duyệt",
      "stageFinalHint": "Quản lý đã duyệt. Đang chờ quyết định cuối cùng.",
      "stageDone": "Đã duyệt",
      "stageDoneHint": "Đã duyệt và hoàn tất. Không còn gì ở đây chờ ai xử lý.",
      "stageApproval": "duyệt",
      "approvedElsewhere": "Báo giá đã duyệt là việc đã xong — chúng nằm trong Dự án đã lưu, có nút Nhân bản.",
      "queueMine": "Đang chờ bạn",
      "queueMineHint": "Bạn quyết định. Duyệt thì chuyển tiếp; trả lại thì cần lý do.",
      "queueBack": "Bị trả lại",
      "queueBackHint": "Sửa những gì được yêu cầu rồi gửi lại.",
      "queueDraft": "Chưa gửi",
      "queueDraftHint": "Bản nháp chưa gửi cho ai duyệt.",
      "queueWaiting": "Đang chờ người khác",
      "queueWaitingHint": "Đang chờ người khác xử lý — hiển thị ở đây để không phải hỏi \"báo giá của tôi đang ở đâu\".",
      "queueDone": "Đã duyệt",
      "queueDoneHint": "Đã chốt. Nhân bản sẽ tạo một bản nháp mới có ghi rõ nguồn gốc.",
      "queueEmpty": "Không có gì ở đây.",
      "trailSubmitted": "{{who}} gửi · {{on}}",
      "trailManager": "Quản lý Sales: {{who}} · {{on}}",
      "trailFinal": "CEO duyệt: {{who}} · {{on}}",
      "trailNone": "chưa gửi",
      "resubmit": "Gửi lại",
      "gate": "Duyệt",
      "goApproval": "Mở màn hình Duyệt giá",
      "reload": "Tải lại",
      "loading": "Đang tải…",
      "stPendingmanager": "Chờ: quản lý",
      "stPendingCEO": "Chờ: CEO",
      "stApproved": "Đã duyệt",
      "stRejected": "Bị từ chối",
      "sentBackMgr": "bị quản lý Sales từ chối",
      "sentBackCeo": "bị CEO từ chối",
      "submit": "Gửi",
      "reject": "Trả lại",
      "revise": "Nhân bản",
      "view": "Xem",
      "rejectTitle": "Trả lại {{id}}",
      "rejectBody": "Ghi rõ cần thay đổi gì. Người nhận lại chỉ có nội dung này để làm theo.",
      "nowStatus": "Xong — báo giá hiện ở trạng thái {{status}}. {{to}}",
      "revisedInto": "Đã sao chép sang {{id}} thành bản nháp mới.",
      "leadWorked": "XF − PO = {{days}} ngày → giao gấp {{rate}}",
      "stepOrder": "Đơn hàng",
      "stepFactory": "Chi phí nhà máy",
      "stepFrame": "Chi phí khung",
      "stepOthers": "Chi phí bổ sung 1",
      "days": "ngày",
      "unitCost": "Giá vốn một đơn vị",
      "share": "Tỷ trọng",
      "bothConventions": "Cùng một báo giá theo hai cách tính",
      "whatTheyPay": "Số tiền các pháp nhân và đối tác phải trả",
      "marginTakenOn": "Biên lợi nhuận tính trên",
      "profitAtT1": "Lợi nhuận tại T1",
      "profitAtT2": "Lợi nhuận tại T2",
      "profitSub": "giá theo bậc trừ đi cơ sở tính biên lợi nhuận, trên mỗi đơn vị",
      "totalProfitAtT1": "Tổng lợi nhuận tại T1",
      "totalProfitAtT2": "Tổng lợi nhuận tại T2",
      "totalProfitSub": "lợi nhuận mỗi đơn vị × {{qty}} EA — doanh thu trừ giá vốn của đơn hàng",
      "revenueAtT1": "Doanh thu tại T1",
      "revenueAtT2": "Doanh thu tại T2",
      "revenueSub": "giá theo bậc × {{qty}} EA — cả đơn hàng, không phải một đơn vị",
      "gapNote": "Hai cách tính chênh nhau {{gap}} ở {{tier}}. Theo hướng dẫn, chi phí khác {{unit}} mỗi đơn vị được tính riêng cho đối tác — {{debit}} cho {{qty}} EA; theo bảng báo giá thì khoản này đã nằm trong giá. Cùng một khoản tiền nhưng nằm ở hai chỗ, vì vậy báo giá phải ghi rõ đang theo cách nào.",
      "basisLine": "Gửi theo {{name}} — cột được tô sáng là số người duyệt được đề nghị chấp nhận.",
      "t0": "T1 (Pháp nhân Helinox)",
      "t0Sub": "Markup Base ÷ (1 − tỷ lệ T1)",
      "t0SubBuying": "Tổng giá mua ÷ (1 − tỷ lệ T1)",
      "t1SubBuying": "Tổng giá mua ÷ (1 − tỷ lệ T2)",
      "marginOnBuying": "Tổng giá mua",
      "hpacTotalInPrice": "Đã nằm trong giá theo cơ sở tính biên lợi nhuận này",
      "msrp": "MSRP",
      "msrpSub": "Giá bán lẻ inline × (1 + % phụ trội)",
      "partnerPrice": "Giá đối tác",
      "partnerPriceSub": "MSRP × tỷ lệ đối tác",
      "allSkus": "Tất cả SKU",
      "globalInputs": "Thông số chung",
      "licensedSub": "Mô hình cấp phép tính giá ngược từ giá bán trên kệ của đối tác. Phí bản quyền được trả trên giá bán của họ, nên con số quan trọng là biên lợi nhuận còn lại sau khi trừ khoản này.",
      "globalMsrp": "MSRP toàn cầu (USD)",
      "t1Fob": "Giá T1 FOB",
      "logistics": "Chi phí logistics %",
      "logisticsHint": "Cộng vào T1 FOB để ra giá thành nhập kho.",
      "wholesale": "Bán sỉ %",
      "wholesaleHint": "Giá bán sỉ tính theo tỷ lệ của SRP địa phương.",
      "wsRoyalty": "Phí bản quyền bán sỉ %",
      "wsRoyaltyHint": "Phí bản quyền tính trên giá bán sỉ.",
      "dtcRoyalty": "Phí bản quyền DTC %",
      "dtcRoyaltyHint": "Phí bản quyền tính trên giá bán lẻ.",
      "landed": "Giá thành nhập kho",
      "landedSub": "T1 FOB × (1 + % logistics)",
      "entities": "Pháp nhân",
      "addEntity": "Thêm pháp nhân",
      "entity": "Pháp nhân",
      "fx": "Tỷ giá / USD",
      "localSrp": "SRP địa phương",
      "resultsByEntity": "Kết quả theo pháp nhân",
      "resultsByEntitySub": "Biên lợi nhuận hiển thị trước và sau phí bản quyền. Chênh lệch giữa hai số là chi phí của giấy phép.",
      "srpUsd": "SRP (USD)",
      "wholesaleCol": "Giá bán sỉ",
      "wsMargin": "Biên lợi nhuận bán sỉ",
      "dtcMargin": "Biên lợi nhuận DTC",
      "prePost": "trước → sau",
      "fobMult": "Bội số FOB",
      "addEntityFirst": "Hãy thêm một pháp nhân",
      "colProject": "Dự án",
      "colName": "Tên",
      "openQuote": "Mở báo giá {{id}}",
      "colMode": "Loại",
      "colSkus": "Số SKU",
      "colSavedBy": "Người lưu",
      "colSaved": "Ngày lưu",
      "general": "Thông thường",
      "licensed": "Cấp phép",
      "nothingSaved": "Chưa lưu gì",
      "skuField": "SKU",
      "skuFieldHint": "Một mặt hàng để tính.",
      "globalMsrpHint": "Một giá bán lẻ toàn cầu (USD). Các SRP địa phương được quy đổi từ giá này.",
      "t1FobHint": "Giá chuyển giao giữa các pháp nhân sau khi đàm phán với nhà cung cấp, chưa gồm logistics.",
      "royaltyNote": "Phí bản quyền không phải là chi phí. Đó không phải là khoản để làm ra sản phẩm — mà là phí thương hiệu trả từ doanh số sau khi bán, nên được tách thành một dòng riêng dưới doanh thu thay vì cộng dồn vào giá vốn. Phí này cũng không áp dụng cho các giao dịch chuyển giao T1 nội bộ (HPAC → từng pháp nhân): nó chỉ phát sinh khi sản phẩm ra bên ngoài, đến nhà bán sỉ hoặc người tiêu dùng.",
      "burdenNote": "Khi giá bán sỉ bằng 50% SRP, phí bản quyền bán sỉ 11% có gánh nặng thực tế bằng phí bản quyền DTC 5.5%. Thay đổi tỷ lệ bán sỉ thì sự tương đương này cũng thay đổi, nên hãy xem xét hai mức phí cùng lúc.",
      "autoFillSrp": "Tự điền SRP địa phương",
      "autoFillHint": "MSRP toàn cầu × từng tỷ giá.",
      "resetEntities": "Đặt lại",
      "wholesalePrice": "Giá bán sỉ",
      "dtcRoyaltyAmt": "Phí bản quyền DTC",
      "wsRoyaltyAmt": "phí bản quyền",
      "wsMarginLabel": "Biên lợi nhuận bán sỉ",
      "dtcMarginLabel": "Biên lợi nhuận DTC",
      "pre": "trước",
      "lowMargin": "biên lợi nhuận thấp",
      "fobBadge": "FOB",
      "cancel": "Hủy",
      "colAction": "Thao tác",
      "colBuying": "Giá mua",
      "colT1": "T2",
      "edit": "Sửa",
      "clearFilters": "Xóa sắp xếp & bộ lọc",
      "discardTitle": "Bỏ bản tính giá này?",
      "discardBody": "Nội dung trên màn hình chưa được lưu. Bỏ sẽ xóa hết và bắt đầu một dự án trống.",
      "keepEditing": "Tiếp tục sửa",
      "discard": "Bỏ"
    },
    "ask": {
      "launch": "Hỏi Catchy",
      "role": "Trợ lý AI hỗ trợ công việc",
      "note": "Nội dung chat được dùng để Catchy thông minh hơn.",
      "moveHint": "Kéo để di chuyển · nhấp đúp để về chỗ cũ",
      "hello": "Xin chào, tôi là Catchy. Hãy hỏi tôi về dự án, SKU và các giai đoạn của chúng, mẫu, ticket, OPA / SCT, token NFC và doanh số — trong phạm vi các màn hình bạn được xem. Bạn cũng có thể dán ảnh chụp màn hình.",
      "s1": "Mẫu nào đến hạn trong tuần này?",
      "s2": "Ticket nào đã quá hạn?",
      "s3": "Team 2 có bao nhiêu SKU bị Trễ?",
      "hideSugs": "Ẩn câu hỏi gợi ý",
      "showSugs": "Hiện câu hỏi gợi ý",
      "otherSugs": "Câu hỏi khác",
      "placeholder": "Đặt câu hỏi hoặc dán ảnh chụp màn hình…",
      "send": "Gửi",
      "attach": "Thêm ảnh chụp màn hình",
      "screenshot": "Ảnh chụp màn hình",
      "screenshotReady": "Đã đính kèm ảnh chụp màn hình",
      "lookingAt": "Đang xem:",
      "lookingAtHint": "Catchy hiểu “cái này” là mục đang mở trên màn hình",
      "dropContext": "Hỏi không kèm mục này",
      "remove": "Xóa",
      "save": "Lưu cuộc trò chuyện",
      "newChat": "Cuộc trò chuyện mới",
      "expand": "Phóng to",
      "shrink": "Thu nhỏ",
      "close": "Đóng",
      "you": "Bạn",
      "leftToday_one": "Hôm nay còn {{count}} câu hỏi",
      "leftToday_other": "Hôm nay còn {{count}} câu hỏi",
      "noneLeft": "Hôm nay đã hết lượt hỏi. Hãy hỏi lại sau nửa đêm."
    },
    "ps": {
      "titleFor": "Theo dõi mẫu {{org}}",
      "partner": "Đối tác",
      "loading": "Đang tải…",
      "fills": "{{org}} điền",
      "requiresReview": "Cần {{reviewer}} đánh giá",
      "reviewerDefault": "designer",
      "reviewerNote": "{{reviewer}} đánh giá: ghi Ngày đánh giá và kết quả vào mục Kết quả vòng bên dưới.",
      "reviewDateHint": "Ngày {{reviewer}} đưa ra đánh giá",
      "internalOnly": "Chỉ đánh giá nội bộ {{org}}",
      "internalNote": "Dùng Ngày đánh giá và Ghi chú để lưu lại đánh giá nội bộ của {{org}}. Vòng này không được tính vào khối lượng công việc của designer hay phản hồi đang chờ.",
      "internalReview": "Đánh giá nội bộ {{org}}",
      "location": "Địa điểm",
      "allLocations": "Tất cả địa điểm",
      "locationPh": "Chọn hoặc nhập địa điểm...",
      "createTitle": "Mẫu mới — nhập style / item",
      "createSub": "Style mới sẽ nhận Base ID tiếp theo ({{prefix}}-00001, {{prefix}}-00002…) và cần có ảnh. Style đã có thì vòng này được thêm vào Base ID của nó.",
      "styleTypedHint": "Nhập tại đây — Base ID được cấp theo tên style",
      "pickPh": "vd. {{prefix}}-00001-P1 hoặc {{prefix}}-00001...",
      "pickNone": "Không có mẫu nào khớp. Để tạo mẫu mới, dùng + Tạo mẫu.",
      "pickCompany": "Chọn công ty cho mẫu này",
      "allCompanies": "Tất cả công ty",
      "empty": "Chưa có mẫu nào của {{org}}. Bấm + Tạo mẫu để tạo mẫu đầu tiên.",
      "tourCreateB": "Nhập tên style / item và thêm ảnh. Style mới nhận Base ID tiếp theo; style đã có thì vòng được thêm vào Base ID của nó. Sau đó điền Kế hoạch mẫu.",
      "tourFiltersB": "Lọc theo trạng thái, developer hoặc địa điểm, hoặc gõ vào ô tìm kiếm. Xóa lọc sẽ đưa mọi thứ về như cũ, kể cả bộ lọc trên tiêu đề cột.",
      "manual": "Hướng dẫn sử dụng",
      "manualTitle": "Mở hướng dẫn sử dụng của trang theo dõi này trong tab mới — Tiếng Việt, English, 한국어, 中文, Français, 日本語",
      "tourTabsT": "Hai cách xem",
      "tourTabsB": "Tất cả mẫu liệt kê từng Base ID cùng các vòng của nó. Tổng hợp theo mẫu hiển thị mỗi mẫu một dòng, với các vòng R1 đến R5 nằm cạnh nhau."
    },
    "cr": {
      "requestTitle": "Yêu cầu chuyển phát",
      "requestSub": "Trước khi gửi bất kỳ lô hàng nào bằng tài khoản chuyển phát của Helinox (FedEx, DHL, UPS …), hãy gửi yêu cầu tại đây trước. Portal đối chiếu chi phí với hợp đồng; người duyệt quyết định trước khi gửi hàng. Không áp dụng cho vận chuyển đường biển hoặc hàng không thông thường.",
      "approvalTitle": "Duyệt chuyển phát",
      "approvalSub": "Các lô courier chờ quyết định trước khi gửi, kiểm tra theo giá hợp đồng FedEx của HINC và DHL của HPAC. Người duyệt: {{who}}.",
      "new": "Yêu cầu mới",
      "newTitle": "Yêu cầu chuyển phát mới",
      "close": "Đóng",
      "cancel": "Hủy",
      "send": "Gửi duyệt",
      "pick": "Chọn…",
      "loading": "Đang tải…",
      "clear": "Xóa lọc",
      "sendNote": "Gửi duyệt sẽ chuyển đến người duyệt, {{who}}, người sẽ duyệt hoặc từ chối tại đây. Bạn và những người trong mục Đồng gửi cũng nhận được email.",
      "b_requester": "Người yêu cầu",
      "b_carrier": "Hãng chuyển phát và tài khoản bị tính phí",
      "b_route": "Từ đâu đến đâu",
      "b_weight": "Trọng lượng và số thùng",
      "b_cost": "Chi phí ước tính",
      "b_goods": "Hàng hóa",
      "requester": "Người yêu cầu",
      "department": "Bộ phận",
      "ccEmails": "Đồng gửi (pháp nhân sở hữu tài khoản)",
      "ccHint": "Quy tắc 1 của Young: đồng gửi cho pháp nhân sở hữu tài khoản. Chỉ dùng địa chỉ @helinox.com, cách nhau bằng dấu phẩy.",
      "carrier": "Hãng chuyển phát",
      "carrierOther": "Tên hãng chuyển phát",
      "service": "Mức dịch vụ",
      "accountHolder": "Tài khoản Helinox bị tính phí",
      "accountHint": "Pháp nhân có tài khoản chuyển phát thanh toán.",
      "accountNo": "Số tài khoản",
      "from": "Từ (nơi đi)",
      "to": "Đến (nơi đến)",
      "shipper": "Người gửi",
      "receiver": "Người nhận",
      "country": "Quốc gia",
      "city": "Thành phố",
      "address": "Địa chỉ",
      "zipHint": "Ghi kèm mã bưu chính (ZIP).",
      "toIndividual": "Giao đến địa chỉ cá nhân (nhà đồng nghiệp, địa điểm của khách hàng)",
      "importer": "Người nhận hàng và nhà nhập khẩu đứng tên",
      "importerHint": "Quy tắc 5 của Young: ghi pháp nhân Helinox, cá nhân ghi dạng nhờ chuyển (c/o) — không bao giờ chỉ ghi riêng cá nhân.",
      "shipmentTo": "Gửi đến",
      "to_internal": "Một pháp nhân hoặc nhóm của Helinox",
      "to_direct": "Khách hàng hoặc bên thứ ba (gửi thẳng)",
      "toDirect": "Gửi thẳng cho khách hàng hoặc bên thứ ba (không gửi cho pháp nhân Helinox)",
      "to_customer": "Khách hàng (gửi thẳng)",
      "to_partner": "Đối tác hoặc bên thứ ba (gửi thẳng)",
      "freightPayer": "Bên chịu cước vận chuyển",
      "payerHint": "Quy tắc 6 của Young: ghi rõ ai trả, trước khi đặt chỗ.",
      "incoterm": "Điều kiện giao hàng (Incoterm)",
      "cartons": "Số thùng",
      "actualKg": "Trọng lượng thực (cả bì), kg",
      "dimKg": "Trọng lượng thể tích, kg",
      "dimPh": "Tổng tất cả các thùng",
      "useBoxTitle": "Tính trọng lượng thể tích từ một thùng (L × W × H ÷ 5,000) × số thùng",
      "boxSize": "Kích thước thùng, cm (L × W × H)",
      "useBox": "Áp dụng",
      "estCost": "Cước vận chuyển ước tính",
      "currency": "Tiền tệ",
      "duties": "Thuế / phí nhập khẩu ước tính",
      "dutiesDdp": "DDP: Helinox trả các khoản này — nhập số ước tính (0 nếu không có).",
      "bulkyNote": "Hàng cồng kềnh (trọng lượng thể tích lớn hơn trọng lượng thực, hoặc trên 100 kg): không mặc định dùng chuyển phát nhanh. Thêm ít nhất một báo giá forwarder để so sánh trước khi đặt chỗ (quy tắc 2 của Young). Cọc, lều, khung và đồ nội thất mặc nhiên là hàng cồng kềnh.",
      "fwdName": "Công ty giao nhận",
      "fwdCost": "Báo giá giao nhận",
      "goodsFor": "Hàng gửi cho ai",
      "goodsForHint": "Người, nhóm hoặc khách hàng nhận hàng.",
      "contents": "Nội dung hàng",
      "purpose": "Mục đích",
      "notes": "Ghi chú",
      "checkTitle": "Kiểm tra chi phí",
      "checkWhat": "Khi bạn điền biểu mẫu, portal sẽ so sánh chi phí ước tính của bạn với giá hợp đồng FedEx của HINC.",
      "checkNeed": "Còn thiếu: {{list}}.",
      "need_courier": "hãng chuyển phát",
      "need_dest": "quốc gia đến",
      "need_weight": "trọng lượng thực",
      "need_cost": "chi phí ước tính",
      "need_currency": "tiền tệ",
      "chargeable": "Trọng lượng tính cước",
      "bulky": "HÀNG CỒNG KỀNH",
      "quoted": "Số ước tính của bạn",
      "usdPerKg": "Mỗi kg",
      "diff": "So với giá hợp đồng",
      "fxWeek": "Tỷ giá (NetSuite)",
      "v_reasonable": "Hợp lý",
      "v_review": "Nên xem xét lại",
      "v_high": "Có thể cao",
      "v_nocontract": "Không có giá hợp đồng",
      "v_manual": "Kiểm tra thủ công",
      "v_undefined": "—",
      "s_waiting": "Đang chờ",
      "s_approved": "Đã duyệt",
      "s_rejected": "Bị từ chối",
      "s_withdrawn": "Đã rút lại",
      "tab_waiting": "Chờ quyết định",
      "tab_approved": "Đã duyệt",
      "tab_rejected": "Bị từ chối",
      "tab_all": "Tất cả",
      "tab_rates": "Bảng giá",
      "empty_waiting": "Không có yêu cầu nào đang chờ quyết định.",
      "empty_approved": "Chưa có yêu cầu nào được duyệt.",
      "empty_rejected": "Chưa có yêu cầu nào bị từ chối.",
      "empty_all": "Chưa có yêu cầu chuyển phát nào.",
      "emptyMine": "Bạn chưa gửi yêu cầu chuyển phát nào.",
      "countRows": "{{n}} / {{total}}",
      "c_no": "Yêu cầu",
      "c_created": "Ngày gửi",
      "c_requester": "Người yêu cầu",
      "c_entity": "Pháp nhân",
      "c_route": "Tuyến",
      "c_carrier": "Hãng chuyển phát",
      "c_originCountry": "Nước đi",
      "c_originCity": "Thành phố đi",
      "c_destCountry": "Nước đến",
      "c_destCity": "Thành phố đến",
      "c_service": "Dịch vụ",
      "c_account": "Tài khoản",
      "c_kg": "Trọng lượng tính cước (kg)",
      "c_cost": "Ước tính",
      "c_check": "Kiểm tra",
      "c_status": "Trạng thái",
      "c_decidedBy": "Người quyết định",
      "c_decidedAt": "Ngày quyết định",
      "f_route": "Tuyến",
      "f_carrier": "Hãng chuyển phát và dịch vụ",
      "f_account": "Tài khoản thanh toán cước",
      "f_weight": "Trọng lượng và số thùng",
      "f_cost": "Cước ước tính",
      "f_fwd": "Báo giá forwarder",
      "f_goodsFor": "Hàng gửi cho ai",
      "f_purpose": "Mục đích",
      "f_contents": "Nội dung hàng",
      "f_shipper": "Người gửi",
      "f_receiver": "Người nhận",
      "f_importer": "Nhà nhập khẩu đứng tên",
      "f_direct": "Giao thẳng (bên chịu cước)",
      "f_incoterm": "Điều kiện giao hàng",
      "ddpShort": "Helinox trả thuế và phí nhập khẩu",
      "f_requester": "Người yêu cầu",
      "f_cc": "CC",
      "f_notes": "Ghi chú",
      "actualShort": "thực tế",
      "dimShort": "thể tích",
      "chargeableShort": "tính cước",
      "cartonsShort": "thùng",
      "dutiesShort": "thuế/phí",
      "raised": "{{by}} đã gửi lúc {{at}}.",
      "approvedBy": "{{by}} đã duyệt · {{at}}",
      "rejectedBy": "{{by}} đã từ chối · {{at}}",
      "withdrawnAt": "Đã rút lại lúc {{at}}.",
      "rule4": "Nếu báo giá của hãng vận chuyển khi đặt chỗ cao hơn mức ước tính này, hãy dừng lại trước khi gửi hàng và báo lại (quy tắc 4 của Young).",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "withdraw": "Rút lại",
      "withdrawAsk": "Rút lại {{no}}? Người duyệt sẽ được báo là không còn gì cần quyết định.",
      "didApprove": "Đã duyệt {{no}} — người yêu cầu đã được thông báo.",
      "didReject": "Đã từ chối {{no}} — người yêu cầu được thông báo lý do.",
      "didWithdraw": "Đã rút lại {{no}}.",
      "s_draft": "Nháp",
      "notSent": "Chưa gửi",
      "saveDraft": "Lưu nháp",
      "c_createdBy": "Người tạo",
      "c_createdAt": "Ngày tạo",
      "checkSource": "Tính từ file bảng giá hợp đồng FedEx của HINC — không phải AI đánh giá.",
      "noContract": "tuyến này không có giá hợp đồng",
      "contractBase": "Giá hợp đồng chưa gồm phụ phí nhiên liệu",
      "h_shipment": "Lô hàng",
      "h_source": "Nguồn số liệu",
      "h_findings": "Kết quả kiểm tra",
      "editTitle": "Sửa {{no}}",
      "copyTitle": "Yêu cầu chuyển phát mới — sao chép từ {{no}}",
      "savedDraft": "Đã lưu {{no}} dạng nháp — gửi đi khi đã sẵn sàng.",
      "didDelete": "Đã xóa {{no}}.",
      "didDeleteMailed": "Đã xóa {{no}} — người duyệt đã được báo là không còn gì cần quyết định.",
      "deleteAsk": "Xóa {{no}}? Thao tác này không thể hoàn tác.",
      "deleteAskWaiting": "Xóa {{no}}? Yêu cầu đang nằm ở người duyệt, người duyệt sẽ được báo là không còn gì cần quyết định. Thao tác này không thể hoàn tác.",
      "saveWaiting": "Lưu",
      "changedByYou": "Đã thay đổi {{no}} — người yêu cầu được báo những gì đã thay đổi. Yêu cầu vẫn đang chờ bạn quyết định.",
      "changedBy": "{{by}} thay đổi gần nhất · {{at}}.",
      "why_notWaiting": "Chỉ yêu cầu đang chờ quyết định",
      "c_managerNote": "Ghi chú của quản lý",
      "c_action": "Thao tác",
      "a_view": "Xem",
      "a_edit": "Sửa",
      "a_submit": "Gửi",
      "a_copy": "Nhân bản",
      "a_delete": "Xóa",
      "a_withdraw": "Rút lại",
      "why_waiting": "Đang nằm ở người duyệt — hãy rút lại trước rồi mới sửa",
      "why_approved": "Đã duyệt — hãy nhân bản để dùng cho lô hàng khác",
      "why_sent": "Đã gửi cho người duyệt",
      "why_done": "Đã có quyết định",
      "why_record": "Đã duyệt — được giữ làm hồ sơ phê duyệt",
      "why_notMine": "Không phải yêu cầu của bạn",
      "sent": "Đã gửi {{no}} để duyệt.",
      "sentMailed": "Đã gửi {{no}} để duyệt — người duyệt đã được thông báo.",
      "billed": "Trọng lượng tính phí",
      "lane": "Tuyến hợp đồng",
      "dir_export": "Xuất từ Hàn Quốc",
      "dir_import": "Nhập vào Hàn Quốc",
      "dir_sg-export": "Xuất từ Singapore",
      "dir_sg-import": "Nhập vào Singapore",
      "dhlFreightOnly": "Bảng giá DHL: chỉ cước — phụ phí nhiên liệu, thuế và phí DHL tính thêm",
      "estSurcharge": "Phụ phí ước tính",
      "estSurchargeHint": "Phụ phí nhiên liệu, vùng xa và các phụ phí khác ngoài cước — giá hợp đồng chỉ gồm cước",
      "dhlSettingsTitle": "HPAC DHL (Singapore) — bảng giá chỉ gồm cước",
      "dhlFuelPct": "Phụ phí nhiên liệu DHL %",
      "dhlRemarkLabel": "Ghi chú hiện dưới mỗi lần so với giá DHL",
      "ratesTitleDhl": "Giá hợp đồng HPAC DHL Express (SGD)",
      "ratesNoteDhl": "DHL Express Worldwide, theo bảng giá DHL Express Singapore của HPAC. Đến 30 kg là giá cả lô, theo từng 0.5 kg; từ 30.1 kg là giá mỗi kg, theo kg tròn. Chỉ gồm cước: phụ phí nhiên liệu, thuế và phí DHL tính thêm. Giá chứng từ (documents) và DHL nước thứ ba chưa được nạp. Bảng giá năm sau (.pdf) cũng tải lên bằng nút Upload như vậy.",
      "contract": "Giá hợp đồng",
      "withFuel": "Kèm phụ phí nhiên liệu {{pct}}%",
      "prioRate": "Priority: giá Economy × {{f}}",
      "econRate": "Giá Economy, theo file",
      "economyBase": "Giá Economy trong file",
      "h_remark": "Ghi chú",
      "priorityFactor": "Priority = giá Economy ×",
      "remarkLabel": "Ghi chú hiển thị dưới mỗi phần so sánh với giá hợp đồng",
      "rateFile": "File bảng giá",
      "depPick": "Chọn hoặc nhập phòng ban",
      "depNone": "Không có kết quả cho “{{name}}”",
      "depAddTo": "+ Thêm “{{name}}” vào danh sách phòng ban",
      "depAdded": "Đã thêm \"{{name}}\" vào danh sách.",
      "rateVersion": "Giá hợp đồng từ {{file}} · {{by}} tải lên · {{at}}",
      "rateNone": "Chưa tải bảng giá hợp đồng nào.",
      "settingsTitle": "Cách kiểm tra đánh giá một báo giá",
      "settingsNote": "File bảng giá là giá Economy của FedEx; dịch vụ Priority bằng giá đó nhân với hệ số. Hợp đồng không có phụ phí nhiên liệu nên giữ ở 0 trừ khi có thay đổi. Báo giá nằm trong mức \"Hợp lý đến\" so với giá hợp đồng là hợp lý, đến mức \"Xem lại đến\" thì nên xem lại, cao hơn nữa là có thể quá cao.",
      "fuelPct": "Phụ phí nhiên liệu %",
      "okPct": "Hợp lý đến (%)",
      "reviewPct": "Xem lại đến (%)",
      "saveSettings": "Lưu",
      "settingsSaved": "Đã lưu.",
      "ratesTitle": "Giá hợp đồng FedEx của HINC (KRW)",
      "ratesNote": "Đến 20.5 kg, giá tính cho cả lô hàng, theo từng nửa kg; từ 21 kg là giá mỗi kg, theo từng kg tròn. File của năm sau được đưa vào bằng nút Tải lên: file được đọc trước, rồi mới thay thế danh sách này.",
      "upload": "Tải file giá lên (FedEx .xlsx / DHL .pdf)",
      "previewCounts": "Xuất: {{el}} cột, {{ec}} điểm đến. Nhập: {{il}} mã vùng, {{ic}} quốc gia. {{rows}} mức giá.",
      "replaceRates": "Thay thế bảng giá",
      "ratesLoaded": "Đã tải bảng giá từ {{file}}.",
      "weightCol": "Trọng lượng",
      "perKgShort": "(mỗi kg)",
      "laneNoCountry": "Chưa có quốc gia nào gắn với cột này",
      "countriesTitle": "Các quốc gia trong từng cột"
    },
    "spl": {
      "title": "Kế hoạch bán hàng",
      "loading": "Đang tải…",
      "cycle": "Chu kỳ đặt hàng",
      "season": "Mùa",
      "next": "Tiếp theo",
      "orderDue": "Đặt hàng",
      "exf": "Xuất xưởng",
      "tab_format": "Mẫu đơn hàng",
      "tab_sheets": "Phiếu đặt hàng",
      "tab_stock": "Tồn kho",
      "tab_production": "Sản xuất",
      "tab_overview": "Tổng quan",
      "tab_setup": "Thiết lập",
      "fmtNone": "chưa tải lên",
      "fmtCount": "{{n}} SKU",
      "sheetsCount": "{{done}}/{{n}} xong",
      "stockServed": "{{n}} cái từ tồn kho",
      "prodCount": "{{set}}/{{n}} đã gán nhà máy",
      "st_open": "Đang mở",
      "st_closed": "Đã đóng",
      "closedNote": "Đơn hàng này đã đóng — mở lại ở Mẫu đơn hàng (Sửa › Trạng thái) để thay đổi.",
      "newOrder": "Tạo đơn hàng",
      "newOrderTitle": "Tạo một đơn hàng",
      "open": "Mở",
      "openFormat": "Mở mẫu đơn hàng của đơn này",
      "delOrder": "Xóa đơn hàng",
      "col_id": "ID",
      "view": "Xem",
      "viewOrder": "Xem đơn hàng này — chỉ đọc",
      "editOrder": "Sửa đơn hàng này và mẫu đơn hàng của nó",
      "modeView": "Chỉ xem",
      "modeEdit": "Đang sửa",
      "formatHead": "Mẫu đơn hàng · {{n}} SKU",
      "col_file": "File mẫu đơn hàng",
      "fileBy": "{{by}} · {{at}}",
      "fileNone": "Chưa có file mẫu đơn hàng.",
      "col_format": "Số SKU trong mẫu",
      "col_sheets": "Phiếu đã xong",
      "col_qty": "Đã đặt (cái)",
      "col_createdBy": "Người tạo",
      "col_createdAt": "Ngày tạo",
      "col_action": "Thao tác",
      "ordersCount": "{{n}} / {{total}} đơn hàng",
      "clearFilters": "Xóa bộ lọc",
      "noOrderYetMgr": "Chưa có đơn hàng — bấm Tạo đơn hàng và nhập mẫu đơn hàng của nó.",
      "noOrderYet": "Chưa có đơn hàng — quản lý Kế hoạch bán hàng sẽ tạo ở Mẫu đơn hàng.",
      "fmtSource": "Mẫu đơn hàng",
      "src_file": "Nhập Master order format (.xlsx)",
      "src_copy": "Sao chép mẫu của một đơn hàng trước",
      "src_later": "Thêm sau",
      "copyOption": "{{date}} · xuất xưởng {{exf}} · {{n}} SKU",
      "datesFirst": "Điền Hạn đặt hàng và Xuất xưởng — file sẽ được đọc ngay khi có đủ cả hai.",
      "pvFile": "Sheet \"{{sheet}}\": {{rows}} SKU sẽ trở thành mẫu đơn hàng của đơn này.",
      "pvCopy": "{{n}} SKU sẽ được sao chép từ đơn hàng ngày {{date}}.",
      "orderCreated": "Đã tạo đơn hàng {{date}} — mẫu đơn hàng có {{n}} SKU.",
      "orderCreatedNoFmt": "Đã tạo đơn hàng {{date}} — hãy nhập mẫu đơn hàng khi đã sẵn sàng.",
      "orderDeleted": "Đã xóa đơn hàng {{date}}.",
      "delAsk": "Xóa đơn hàng có hạn {{date}} (xuất xưởng {{exf}}) cùng {{n}} SKU trong mẫu đơn hàng? Chưa ai làm gì trên đơn này.",
      "formatOf": "Mẫu đơn hàng · {{date}} ({{season}}) · Xuất xưởng {{exf}}",
      "seasonAuto": "Mùa {{s}} — theo hạn đặt hàng (tháng 10 đến tháng 9).",
      "seasonAutoTip": "Tính từ hạn đặt hàng: một mùa kéo dài từ tháng 10 đến tháng 9.",
      "sh_none": "Chưa bắt đầu",
      "sh_open": "Đang làm",
      "sh_done": "Xong",
      "sh_checked": "Đã kiểm",
      "st_done_done": "{{cust}}: đã đánh dấu xong — quản lý Kế hoạch bán hàng có thể kiểm tra ngay.",
      "st_check_done": "{{cust}}: đã kiểm.",
      "st_reopen_done": "{{cust}}: đã mở lại.",
      "cancel": "Hủy",
      "close": "Đóng",
      "save": "Lưu",
      "saveN": "Lưu ({{n}})",
      "saved": "Đã lưu.",
      "savedCells": "Đã lưu {{n}} thay đổi.",
      "edit": "Sửa",
      "remove": "Gỡ bỏ",
      "removed": "Đã gỡ {{sap}} khỏi chu kỳ này.",
      "read": "Đọc file",
      "write": "Ghi",
      "writeN": "Ghi {{n}} thay đổi",
      "search": "Mã SAP, sản phẩm, màu…",
      "allCategories": "Tất cả danh mục",
      "allLineups": "Tất cả dòng sản phẩm",
      "noRows": "Không có kết quả phù hợp.",
      "noOrders": "Chu kỳ này chưa có đơn đặt nào.",
      "sap": "Mã SAP",
      "product": "Sản phẩm",
      "qty": "SL đặt",
      "amountUsd": "Thành tiền (USD)",
      "total": "Tổng",
      "buyer": "Khách hàng",
      "pic": "Người phụ trách",
      "status": "Trạng thái",
      "fmtEmpty": "Chu kỳ này chưa có mẫu đơn hàng.",
      "fmtEmptyHint": "Tải lên Master order format của tháng (.xlsx). Các SKU và giá trong đó sẽ thành danh sách của chu kỳ này — các phiếu đặt hàng chỉ đưa ra đúng các SKU này. Có thể thêm hoặc sửa SKU bất cứ lúc nào.",
      "fmtWaiting": "Quản lý Kế hoạch bán hàng sẽ tải lên.",
      "upload": "Tải lên mẫu đơn hàng",
      "uploadNew": "Tải lên phiên bản mới",
      "copyFrom": "Sao chép mẫu của {{cycle}}",
      "addSku": "Thêm SKU",
      "fmtDownload": "Tải mẫu xuống",
      "fmtDownloadTip": "Mẫu đơn hàng của chu kỳ này dưới dạng .xlsx theo bố cục của Master order format — sửa rồi tải lên lại.",
      "portalOnly": "Do Portal lưu — Master order format không có cột này; lấy từ chu kỳ gần nhất có SKU đó.",
      "fmtNote": "{{n}} / {{total}} SKU · giá bằng USD",
      "fmtUploadTitle": "Tải lên Master order format",
      "fmtUploadBody": "File được đọc trước và chỉ được ghi khi bạn bấm Ghi. Các SKU đã có trong chu kỳ này sẽ lấy thuộc tính và giá theo file; SKU nào file không liệt kê sẽ được giữ lại, trừ khi bạn đánh dấu ô bên dưới.",
      "fmtSummary": "Sheet \"{{sheet}}\": {{rows}} SKU — {{added}} mới, {{changed}} thay đổi, {{missing}} có trong chu kỳ này nhưng không có trong file.",
      "fmtAdded": "Mới",
      "fmtChanged": "Thay đổi",
      "fmtMissing": "Không có trong file",
      "fmtUsed": "đã đánh dấu hoặc đã đặt, giữ lại",
      "fmtRemove": "Gỡ luôn {{n}} SKU không có trong file mà chưa ai đánh dấu hay đặt",
      "fmtNoChange": "File khớp với mẫu đơn hàng của chu kỳ này.",
      "fmtDone": "Đã ghi mẫu đơn hàng: {{added}} mới, {{changed}} thay đổi, {{removed}} gỡ bỏ.",
      "fmtCopied": "Đã sao chép {{n}} SKU.",
      "skuNew": "Thêm SKU",
      "skuEdit": "Sửa {{sap}}",
      "skuRemoveAsk": "Gỡ {{sap}} ({{product}}) khỏi mẫu đơn hàng của chu kỳ này?",
      "noFormatYet": "Hãy tải lên mẫu đơn hàng trước — mọi phiếu đều đưa ra các SKU trong đó.",
      "priceCol": "Tính theo giá",
      "pf_price_t1": "T1 FOB",
      "pf_price_t2": "T2 FOB",
      "pf_price_hema_dt": "Giá HEMA DT",
      "pf_null": "—",
      "ticked": "SKU đã đánh dấu",
      "ordered": "Đã đặt",
      "updated": "Lưu gần nhất",
      "myBuyers": "Chỉ khách hàng của tôi",
      "allStatus": "Tất cả trạng thái",
      "sheetsNote": "{{done}} / {{n}} phiếu đã xong",
      "sapAll": "File tải lên SAP (tất cả khách hàng)",
      "sapOne": "File tải lên SAP SO cho khách hàng này",
      "sheetTitle": "phiếu đặt hàng {{date}}",
      "customerRef": "Customer Reference (PO# của khách)",
      "showTicked": "Đã đánh dấu ({{n}})",
      "showAll": "Tất cả SKU ({{n}})",
      "tick": "Đánh dấu",
      "tickShown": "Đánh dấu tất cả đang hiện",
      "untickShown": "Bỏ đánh dấu tất cả đang hiện",
      "fromLast": "Cùng SKU như chu kỳ trước",
      "fromLastDone": "Đã đánh dấu {{n}} SKU, giống {{date}}.",
      "nothingTicked": "Chưa đánh dấu gì — hãy đánh dấu các SKU khách hàng này được đặt (Tất cả SKU), hoặc bắt đầu từ chu kỳ trước.",
      "tickedN": "{{n}} đã đánh dấu",
      "exportForm": "Biểu mẫu cho khách hàng",
      "exportTip": "Mẫu đơn hàng chỉ gồm các SKU đã đánh dấu và giá của khách hàng này — khách hàng điền SL đặt.",
      "tickFirst": "Hãy đánh dấu trước các SKU khách hàng này được đặt",
      "saveFirst": "Hãy lưu thay đổi trước",
      "importForm": "Nhập biểu mẫu của khách hàng",
      "markDone": "Xong",
      "markChecked": "Đánh dấu đã kiểm",
      "reopen": "Mở lại",
      "doneBy": "{{who}} hoàn thành, {{at}}",
      "checkedBy": "{{who}} đã kiểm, {{at}}",
      "unsaved": "{{n}} thay đổi chưa lưu.",
      "keepEditing": "Tiếp tục sửa",
      "discard": "Bỏ thay đổi",
      "sheetLocked": "Phiếu này đã được bàn giao — quản lý Kế hoạch bán hàng vẫn có thể sửa hoặc mở lại.",
      "notYours": "Người phụ trách khách hàng này là {{pic}} — chỉ người đó hoặc quản lý Kế hoạch bán hàng được điền phiếu này.",
      "flagCycle": "Mẫu đơn hàng: {{rule}} — không mở trong chu kỳ này",
      "flagPrice": "Không có giá cho khách hàng này",
      "formTitle": "{{cust}} — nhập biểu mẫu của khách hàng",
      "formBody": "Biểu mẫu bạn đã gửi, do khách hàng điền (.xlsx): đọc cột SAP Code và Order Q'ty. Mỗi SKU trên biểu mẫu nhận số lượng của nó — ô trống là không đặt — còn SKU không có trên biểu mẫu được giữ nguyên. Không có gì được ghi cho đến khi bạn bấm Ghi.",
      "formSummary": "Sheet \"{{sheet}}\": {{rows}} dòng SKU, đặt {{total}} cái — {{n}} SKU thay đổi.",
      "formUnknown": "Không có trong mẫu đơn hàng của chu kỳ này (không nhập): {{list}}",
      "formDup": "Bị liệt kê hai lần (dùng dòng đầu tiên): {{list}}",
      "formNoChange": "Biểu mẫu giống hệt những gì phiếu đang có.",
      "formWritten": "{{cust}}: đã ghi {{n}} SKU từ biểu mẫu.",
      "was": "Hiện tại",
      "now": "Trên biểu mẫu",
      "stockNote": "Nhập ba nguồn tồn kho, rồi phân bổ: khách hàng được phục vụ theo thứ tự ưu tiên tồn kho (Thiết lập › Khách hàng), mỗi khách lấy từ KR nội địa, rồi EUSU, rồi KR SOP.",
      "notAllDone": "{{n}} phiếu chưa xong — hãy phân bổ lại khi đã đủ.",
      "countOver": "{{n}} dòng khách hàng nhận từ tồn kho nhiều hơn số đã đặt.",
      "pool_kr_dom": "KR nội địa",
      "pool_eusu": "EUSU (SOP)",
      "pool_kr_sop": "KR (SOP)",
      "avail": "Có sẵn",
      "fromStock": "Từ tồn kho",
      "left": "Còn lại",
      "allocation": "Phân cho",
      "onlyActive": "Chỉ SKU có đơn đặt hoặc tồn kho",
      "stockTpl": "File tồn kho",
      "stockImport": "Nhập file tồn kho",
      "allocate": "Phân bổ tồn kho",
      "allocateTitle": "Phân bổ tồn kho",
      "allocateGo": "Phân bổ",
      "allocateBody": "Mọi SKU có tồn kho sẽ được phân lại: khách hàng theo thứ tự bên dưới, mỗi khách lấy từ KR nội địa, rồi EUSU, rồi KR SOP, tối đa bằng số đã đặt và lượng nguồn còn lại. Số liệu đã sửa tay trên các SKU đó sẽ bị thay thế.",
      "allocateOrder": "Thứ tự phục vụ (Thiết lập › Khách hàng › Ưu tiên tồn kho):",
      "allocated": "Đã phân bổ tồn kho cho {{skus}} SKU: {{pcs}} cái từ tồn kho.",
      "allocEdit": "Phân bổ của {{sap}}",
      "allocTotal": "Đã phân {{served}} / {{avail}} có sẵn",
      "stockImportBody": "Các SKU trong file lấy ba số liệu của file (ô trống là không có tồn kho); SKU không có trong file được giữ nguyên. Tải file tồn kho xuống để xem bố cục.",
      "stockSummary": "Sheet \"{{sheet}}\": {{rows}} dòng — {{n}} SKU thay đổi.",
      "stockWritten": "Đã ghi tồn kho cho {{n}} SKU.",
      "prodNote": "Cần sản xuất = đơn đặt − lượng từ tồn kho, tính theo từng khách hàng rồi cộng lại. Gán nhà máy và lượng sản xuất thêm (nếu có) cho mỗi SKU; các thẻ là số lượng dự kiến theo từng nhà máy.",
      "required": "Cần sản xuất",
      "overbuild": "Sản xuất thêm",
      "planned": "Dự kiến",
      "factory": "Nhà máy",
      "comment": "Ghi chú",
      "needsOnly": "Chỉ SKU cần sản xuất",
      "allFactories": "Tất cả nhà máy",
      "unassigned": "Chưa gán",
      "byBuyer": "Theo khách hàng",
      "m_order": "Đơn đặt",
      "m_stock": "Từ tồn kho",
      "m_prod": "Sản xuất",
      "total_order": "Tổng đơn đặt",
      "total_stock": "Tổng từ tồn kho",
      "total_prod": "Cần sản xuất",
      "mNote_order": "Vàng cam: đặt trên SKU không mở trong chu kỳ này, hoặc không có giá cho khách hàng đó.",
      "mNote_stock": "Đỏ: lấy từ tồn kho nhiều hơn số khách hàng đã đặt.",
      "mNote_prod": "Đơn đặt − từ tồn kho, theo từng khách hàng.",
      "c_orders": "Tổng đơn đặt",
      "c_stock": "Từ tồn kho",
      "c_prod": "Cần sản xuất",
      "c_ob": "Sản xuất thêm",
      "c_planned": "Sản xuất dự kiến",
      "c_amount": "Giá trị đơn hàng",
      "customerReport": "Báo cáo khách hàng — theo danh mục sản phẩm",
      "priceRule": "Thành tiền = SL × giá của khách hàng: khách T2 tính theo T2 FOB, nhà phân phối HEMA tính theo giá HEMA DT, các khách còn lại tính theo T1 FOB.",
      "sub_customers": "Khách hàng",
      "sub_cycles": "Lịch",
      "addCustomer": "Thêm khách hàng",
      "active": "Đang hoạt động",
      "discontinued": "Đã ngừng",
      "custNote": "Người phụ trách = nhân viên Sale OP điền phiếu của khách hàng. Bậc giá và pháp nhân quyết định cột giá; có Cột sổ đặt hàng thì khách hàng đó xuất hiện trong các phiếu; Ưu tiên tồn kho là thứ tự phân tồn kho.",
      "cycleNote": "Lịch đặt hàng & xuất xưởng (Monthly order program 2026). Không thể thay đổi chu kỳ đã đóng.",
      "etas": "ETA KR/JP/SIN · AUS · EU · USA",
      "etaLine": "{{a}} · {{au}} · {{eu}} · {{us}}",
      "edit_customer": "Sửa khách hàng",
      "edit_customer_new": "Thêm khách hàng",
      "edit_cycle": "Sửa đơn hàng {{date}}",
      "f_customer_key": "Khách hàng",
      "f_pic_user_id": "Người phụ trách (Sale OP)",
      "f_country": "Quốc gia",
      "f_pricing": "Bậc giá",
      "f_entity": "Pháp nhân Helinox",
      "f_status": "Trạng thái",
      "f_sold_to": "Sold-To (SAP)",
      "f_ship_to": "Ship-To (SAP)",
      "f_grid_order": "Cột sổ đặt hàng",
      "f_alloc_priority": "Ưu tiên tồn kho",
      "f_remark": "Ghi chú",
      "f_sap_code": "SKU# mới (SAP Code)",
      "f_product": "Sản phẩm",
      "f_skin_color": "Màu vải",
      "f_frame_color": "Màu khung",
      "f_selling_sku": "SKU# bán hàng",
      "f_upc": "UPC",
      "f_line_category": "Danh mục",
      "f_lineup": "Dòng sản phẩm",
      "f_order_cycle": "Chu kỳ đặt hàng",
      "f_noos": "NOOS=Never Out of Stock (SKU luôn duy trì hàng)",
      "f_product_category": "Danh mục sản phẩm",
      "f_ex_factory_loc": "Địa điểm xuất xưởng",
      "f_carton_qty": "SL trong thùng",
      "f_hts_usa": "Mã HTS Mỹ",
      "f_hts_eu": "Mã HTS châu Âu",
      "f_ctn_size": "Kích thước thùng (mm) /Loại",
      "f_frame_category": "Loại khung",
      "f_price_t1": "T1 FOB cho pháp nhân toàn cầu & khách hàng châu Á",
      "f_price_hema_dt": "T1 FOB chỉ dành cho HEMA DT",
      "f_price_t2": "T2 FOB cho khách không phải nhà phân phối",
      "f_season": "Mùa",
      "f_fc_due": "Hạn FC",
      "f_order_due": "Hạn đặt hàng",
      "f_ex_factory": "Xuất xưởng",
      "f_items_note": "Mặt hàng",
      "f_eta_asia": "ETA KR/JP/SIN",
      "f_eta_aus": "ETA Úc",
      "f_eta_eu": "ETA châu Âu",
      "f_eta_usa": "ETA Mỹ"
    },
    "nav": {
      "aiPowered": "Các bản tóm tắt và câu trả lời trong portal này do Claude, AI của Anthropic, viết",
      "report": "Báo cáo",
      "salesReport": "Báo cáo bán hàng",
      "saleOperation": "Công cụ khác",
      "development": "Phát triển",
      "salesOperation": "Vận hành bán hàng",
      "production": "Sản xuất",
      "productSalesDashboard": "Dashboard doanh số sản phẩm",
      "salesReportDashboard": "Hiệu quả kinh doanh",
      "marketingDashboard": "Dashboard marketing",
      "dataExplorer": "Khám phá dữ liệu",
      "salesDataLoad": "Cập nhật dữ liệu bán hàng",
      "inventoryReport": "Global Inventory Report",
      "poleInventory": "Chốt tồn kho khung",
      "eusuStock": "Tồn kho không bán EUSU",
      "inventoryDashboard": "Dashboard tồn kho",
      "poleDashboard": "Dashboard tồn kho khung",
      "demandForecastDashboard": "Dashboard dự báo nhu cầu",
      "autoJobs": "Sales Op. Python",
      "dashboard": "Bảng điều khiển",
      "projectTracker": "Theo dõi dự án",
      "documents": "Tài liệu",
      "documentLibrary": "Thư viện",
      "sampleTracker": "Theo dõi mẫu",
      "partnerSamples": "Theo dõi mẫu DAC",
      "ticketStation": "Ticket Station",
      "userManual": "Hướng dẫn sử dụng",
      "projectApproval": "Duyệt dự án",
      "nfcTokenPortal": "Cổng token NFC",
      "pricingCalculator": "Tính giá Collab",
      "ceoOffice": "Văn phòng CEO",
      "gtm": "GTM",
      "finance": "Tài chính",
      "cashSetup": "Thiết lập",
      "cashImport": "Gửi báo cáo",
      "cashApproval": "Duyệt",
      "courierRequests": "Yêu cầu chuyển phát",
      "courierApproval": "Duyệt chuyển phát",
      "courier": "Chuyển phát",
      "collabPricing": "Tính giá Collab",
      "arrangeOpen": "Sắp xếp menu",
      "arrangeTitle": "Sắp xếp menu của bạn",
      "arrangeHint": "Kéo một thư mục hoặc một mục, hoặc dùng các mũi tên. Chỉ bạn thấy thứ tự này.",
      "arrangeUp": "Đưa {{name}} lên",
      "arrangeDown": "Đưa {{name}} xuống",
      "arrangeDone": "Xong",
      "arrangeCancel": "Hủy",
      "arrangeReset": "Đặt lại",
      "arrangeResetHint": "Khôi phục thứ tự mặc định của portal",
      "arrangeIsDefault": "Đây đã là thứ tự mặc định của portal",
      "arrangeFailed": "Không lưu được thứ tự menu",
      "arrangeUnfold": "Hiện các mục trong {{name}}",
      "arrangeFold": "Ẩn các mục trong {{name}}",
      "hevnAdmin": "Hành chính HEVN",
      "driverLog": "Nhật ký lái xe",
      "salesPlanning": "Kế hoạch bán hàng",
      "splFormat": "Mẫu đơn hàng",
      "splOrders": "Phiếu đặt hàng",
      "splStock": "Phân bổ tồn kho",
      "splProduction": "Phân bổ nhà máy",
      "splOverview": "Tổng quan đơn hàng",
      "splSetup": "Thiết lập kế hoạch",
      "cashWeekly": "Báo cáo tiền mặt hằng tuần",
      "cashPlan": "Kế hoạch tiền mặt theo tháng",
      "cashMonthEnd": "Đối chiếu cuối tháng",
      "cashReport": "Báo cáo tiền mặt",
      "gtmProgrammes": "Chương trình GTM",
      "gtmApproval": "Duyệt GTM",
      "gtmTracker": "Theo dõi GTM",
      "ceoFolder": "CEO",
      "benchmarkLibrary": "Bảng giá thành Inline",
      "pricingApproval": "Duyệt giá",
      "costing": "Tính giá",
      "opaSct": "OPA / SCT",
      "sctSummary": "Tổng hợp SCT"
    },
    "cash": {
      "title": "Thiết lập",
      "sub": "Các danh sách mà mọi báo cáo tiền mặt sử dụng: pháp nhân, tài khoản ngân hàng, tuần, tỷ giá, danh mục chi phí và người lập, người duyệt, người phê duyệt. Mọi thay đổi chỉ có hiệu lực sau khi Group CFO phê duyệt.",
      "loading": "Đang tải…",
      "tab_entity": "Pháp nhân",
      "tab_account": "Tài khoản",
      "tab_user": "Người dùng",
      "tab_period": "Kỳ",
      "tab_fx": "Tỷ giá",
      "tab_expense": "Danh mục chi phí",
      "tab_account_type": "Loại tài khoản",
      "tab_role": "Vai trò",
      "tab_notice": "Thông báo",
      "tab_flow": "Quy trình",
      "tab_changes": "Thay đổi chờ duyệt",
      "tab_history": "Lịch sử",
      "tab_setting": "Cài đặt",
      "tab_currency": "Tiền tệ",
      "f_code": "Mã",
      "f_name": "Tên",
      "f_tax_code": "Mã số thuế / Mã định danh",
      "f_legal_address": "Địa chỉ pháp lý",
      "f_country": "Quốc gia",
      "f_ho_address": "Địa chỉ trụ sở chính",
      "f_acc_mail": "Email Hành chính / Kế toán",
      "f_min_balance_sgd": "Số dư tối thiểu (SGD)",
      "f_status": "Trạng thái",
      "f_seq": "Thứ tự",
      "f_account_id": "Mã tài khoản",
      "f_entity_code": "Pháp nhân",
      "f_account_no": "Số tài khoản",
      "f_currency": "Tiền tệ",
      "f_bank_name": "Tên ngân hàng",
      "f_account_type": "Loại tài khoản",
      "f_restricted": "Bị hạn chế",
      "f_fixed_deposit": "Tiền gửi có kỳ hạn",
      "f_remarks": "Ghi chú",
      "f_user_code": "Mã",
      "f_mail": "Email",
      "f_role_key": "Vai trò",
      "f_year": "Năm",
      "f_week": "Tuần",
      "f_week_ending": "Ngày cuối tuần (thứ Sáu)",
      "f_submit_deadline": "Hạn nộp",
      "f_category_type": "Loại",
      "f_describe": "Mô tả",
      "f_type_name": "Loại",
      "f_default_restricted": "Mặc định: Bị hạn chế",
      "f_default_fd": "Mặc định: Tiền gửi có kỳ hạn",
      "f_action": "Hành động",
      "f_right_scope": "Quyền",
      "f_restriction": "Hạn chế (phân tách nhiệm vụ)",
      "f_notice_id": "Mã thông báo",
      "f_header": "Tiêu đề",
      "f_content": "Nội dung",
      "f_report": "Báo cáo",
      "f_send_to_role": "Gửi đến (Vai trò)",
      "f_send_day": "Ngày gửi",
      "f_send_time": "Giờ gửi",
      "f_setting_value": "Giá trị",
      "f_rate": "Tỷ giá",
      "f_week_code": "Tuần",
      "f_trigger_key": "Sự kiện kích hoạt",
      "tab_log": "Nhật ký thông báo",
      "trg_report_open": "Mở báo cáo tuần (theo lịch)",
      "trg_due_soon": "Nhắc hạn nộp (theo lịch)",
      "trg_missing": "Chưa nộp (theo lịch)",
      "trg_plan_update": "Cập nhật kế hoạch 13 tuần (theo lịch)",
      "trg_month_open": "Mở đối chiếu cuối tháng (theo lịch)",
      "trg_upload_errors": "Tệp tải lên có lỗi",
      "trg_submitted": "Đã gửi để xem xét",
      "trg_reviewed": "Đã xem xét",
      "trg_approved": "Group CFO đã phê duyệt",
      "trg_closed": "CEO đã đóng",
      "trg_returned": "Bị trả lại",
      "trg_below_min": "Dưới số dư tối thiểu",
      "trg_setup_submitted": "Đã gửi Thiết lập để phê duyệt",
      "mailHeld": "Đang giữ mail",
      "mailLive": "Mail đang gửi thật",
      "mailHeldLine": "Mail của Báo cáo tiền mặt đang được GIỮ LẠI trong lúc xây dựng module: mọi thông báo bên dưới đã được tạo và ghi nhật ký, nhưng không gửi cho ai cả.",
      "mailLiveLine": "Mail của Báo cáo tiền mặt đang gửi thật: các thông báo bên dưới đã được gửi.",
      "logRun": "Chạy ngay các thông báo theo lịch",
      "logRunAt": "Chạy theo thời điểm này",
      "logAtWhy": "Để trống để chạy ngay, hoặc chọn một thời điểm để xem khi đó sẽ gửi gì (chỉ khi mail đang được giữ). Theo giờ máy chủ.",
      "logRan_one": "Đã chạy theo thời điểm {{at}}: tạo {{count}} thông báo.",
      "logRan_other": "Đã chạy theo thời điểm {{at}}: tạo {{count}} thông báo.",
      "logEmpty": "Chưa có mail Báo cáo tiền mặt nào được tạo.",
      "logWhen": "Thời điểm",
      "logStatus": "Trạng thái",
      "logWhat": "Thông báo",
      "logFor": "Pháp nhân · kỳ",
      "logTo": "Gửi đến",
      "logSubject": "Tiêu đề",
      "log_held": "Đang giữ",
      "log_sent": "Đã gửi",
      "log_failed": "Thất bại",
      "log_claimed": "Đang gửi…",
      "log_tester": "Đã gửi cho người thử nghiệm",
      "testAs": "Thử với vai trò",
      "testOff": "Tắt — vai trò của tôi",
      "testOnNote": "Đang thử với vai trò {{role}}: mọi bước thực hiện đều được ghi là \"(test as {{role}})\". Chỉ dùng được khi mail Báo cáo tiền mặt đang được giữ.",
      "testOffNote": "Trong lúc xây dựng: đóng vai Người lập hoặc Người duyệt để chạy một báo cáo qua hai bước.",
      "logSim": "mô phỏng",
      "logSimWhy": "Được tạo bằng \"Chạy theo thời điểm\" tại một thời điểm đã chọn. Không làm mất thông báo thật của ngày đó.",
      "s_base_currency": "Tiền tệ gốc",
      "s_rate_source": "Nguồn tỷ giá",
      "s_rate_date": "Ngày tỷ giá",
      "state_clean": "Đang có hiệu lực",
      "state_draft": "Nháp — chưa gửi",
      "state_submitted": "Chờ Group CFO",
      "bandClean": "Mọi thứ trên các tab này đã được phê duyệt và đang có hiệu lực.",
      "bandEmpty": "Chưa có gì được phê duyệt. Hãy nhập workbook Thiết lập để bắt đầu, rồi gửi cho Group CFO.",
      "bandCounts": "{{insert}} mới · {{update}} thay đổi · {{delete}} gỡ bỏ — chưa có hiệu lực cho đến khi Group CFO phê duyệt",
      "sentBy": "{{by}} gửi lúc {{at}}",
      "returned": "{{by}} đã trả lại lúc {{at}}:",
      "bootstrap": "Danh sách người dùng chưa có dòng nào được phê duyệt, nên bạn đang đóng vai Admin Báo cáo tiền mặt vì bạn là admin của portal. Điều này kết thúc khi danh sách đầu tiên được phê duyệt.",
      "provisional": "Chưa có gì được phê duyệt, nên bạn xem trang này với vai trò mà danh sách người dùng đề xuất gán cho bạn ({{roles}}). Vai trò sẽ chính thức khi Group CFO phê duyệt danh sách.",
      "import": "Nhập Excel",
      "send": "Gửi cho Group CFO",
      "approve": "Phê duyệt",
      "notePh": "Ghi chú cho Group CFO (không bắt buộc)",
      "fixFirst": "Các dòng có lỗi Kiểm tra dữ liệu phải được sửa trước khi gửi.",
      "sent": "Đã gửi cho Group CFO. Không có gì thay đổi cho đến khi được phê duyệt.",
      "approved": "Đã phê duyệt — các thay đổi đã có hiệu lực.",
      "rejected": "Đã trả lại cho admin kèm lý do của bạn.",
      "imported": "Đã nhập: {{insert}} mới, {{update}} thay đổi, {{same}} vốn đã giống. Các thay đổi nằm trong bản nháp, chưa có hiệu lực.",
      "sumErrors_one": "{{count}} dòng có lỗi Kiểm tra dữ liệu",
      "sumErrors_other": "{{count}} dòng có lỗi Kiểm tra dữ liệu",
      "sumWarns_one": "{{count}} dòng có cảnh báo",
      "sumWarns_other": "{{count}} dòng có cảnh báo",
      "onlyIssues": "Chỉ các dòng có thông báo Kiểm tra dữ liệu",
      "onlyChanged": "Chỉ các dòng đã thay đổi",
      "rows_one": "{{count}} dòng",
      "rows_other": "{{count}} dòng",
      "search": "Tìm kiếm…",
      "clear": "Xóa lọc",
      "addRow": "Thêm dòng",
      "save": "Lưu",
      "cancel": "Hủy",
      "edit": "Sửa",
      "remove": "Gỡ bỏ",
      "undo": "Hoàn tác thay đổi này",
      "was": "Giá trị đã duyệt",
      "choose": "Chọn…",
      "auto": "cấp khi lưu",
      "autoHint": "Mã của dòng mới do portal cấp (Entity-01, EC-0001, N-001…) và không bao giờ dùng lại.",
      "dataCheck": "Kiểm tra dữ liệu",
      "chkOk": "Đạt",
      "chkError": "Lỗi",
      "chkWarn": "Cảnh báo",
      "op_insert": "Mới",
      "op_update": "Thay đổi",
      "op_delete": "Sẽ gỡ bỏ",
      "noRows": "Không có dòng nào.",
      "yes": "Có",
      "no": "Không",
      "week": "Tuần",
      "allWeeks": "Tất cả các tuần",
      "year": "Năm",
      "addYear": "Thêm mọi tuần của năm",
      "addWeeks": "Thêm tuần",
      "weeksAdded": "Đã thêm {{count}} tuần của năm {{year}} vào bản nháp.",
      "fxHint": "Tỷ giá = số đơn vị tiền tệ gốc cho 1 đơn vị của tiền tệ đó, nên số tiền SGD = số tiền ngoại tệ × tỷ giá. Mỗi tuần một tỷ giá; Template 1 đọc tỷ giá của chính tuần đó.",
      "newCurrency": "ví dụ CHF",
      "addCurrency": "Thêm tiền tệ",
      "editRates": "Sửa tỷ giá",
      "saveRates": "Lưu {{count}} ô",
      "fxSync": "Đồng bộ từ NetSuite",
      "fxSyncTitle": "Đọc tỷ giá ngày thứ Sáu của từng tuần từ NetSuite. Các tỷ giá này được áp dụng ngay, không cần Group CFO duyệt; tỷ giá đã nhập tay ở đây được giữ nguyên.",
      "fxLastSync": "Tỷ giá NetSuite gần nhất: {{when}}",
      "fxNeverSynced": "Chưa đồng bộ từ NetSuite",
      "fxSynced": "NetSuite: đã ghi {{written}} tỷ giá, {{unchanged}} tỷ giá đã cập nhật sẵn, trong {{weeks}} tuần.",
      "fxKeptTyped": "{{n}} tỷ giá nhập trong Thiết lập được giữ nguyên ({{list}}).",
      "fxMissing": "NetSuite không có tỷ giá cho {{n}} mục ({{list}}).",
      "fxFromNetsuite": "Từ NetSuite — tỷ giá ngày {{day}}",
      "fxBase": "Đồng tiền cơ sở",
      "fxTyped": "Nhập trong Thiết lập và đã được duyệt — đồng bộ NetSuite không thay đổi tỷ giá này",
      "flowReport": "Báo cáo",
      "step": "Bước {{n}}",
      "rep_weekly": "Báo cáo tiền mặt hằng tuần",
      "rep_13w": "Kế hoạch tiền mặt 13 tuần",
      "rep_month": "Đối chiếu cuối tháng",
      "rep_setup": "Thiết lập",
      "flowPrep": "Người lập: lập báo cáo",
      "flowReview": "Người duyệt: xem xét & đồng ý",
      "flowCfo": "Group CFO: duyệt",
      "flowCeo": "CEO: duyệt & đóng",
      "flowAdmin": "Admin: thực hiện Thiết lập",
      "flowNote": "Cả ba báo cáo đều theo quy trình này (Tài chính › Báo cáo tiền mặt: Báo cáo tiền mặt hằng tuần, Kế hoạch tiền mặt 13 tuần, Đối chiếu cuối tháng) — sự đồng ý của Người duyệt là bước cuối cùng, và báo cáo hiện trong Báo cáo tiền mặt sau khi được đồng ý. Tab Thông báo cho biết gửi gì, gửi cho ai và khi nào — Ngày và Giờ gửi cho các thông báo theo lịch, Sự kiện cho các thông báo do một bước kích hoạt — và Nhật ký thông báo hiển thị mọi mail đã được tạo.",
      "noChanges": "Không có thay đổi nào đang chờ.",
      "list": "Danh sách",
      "code": "Mã",
      "change": "Thay đổi",
      "what": "Nội dung thay đổi",
      "by": "Người thực hiện",
      "noHistory": "Chưa có thay đổi nào được duyệt.",
      "histLine": "{{n}} thay đổi · {{by}} gửi lúc {{at}} · {{cfo}} duyệt lúc {{on}}",
      "histBuild": "{{n}} thay đổi · {{by}} áp dụng để xây dựng lúc {{on}} — CHƯA được Group CFO duyệt"
    },
    "cashr": {
      "title": "Báo cáo tiền mặt",
      "reviewedOnly": "Chỉ những báo cáo đã được Người duyệt đồng ý mới hiện số liệu ở đây."
    },
    "cashw": {
      "h_balance": "Số dư ({{ccy}})",
      "h_balanceOrig": "Số dư (tiền tệ tài khoản)",
      "h_amountIn": "Số tiền ({{ccy}})",
      "baseLabel": "Hiển thị bằng",
      "baseWhy": "Mọi số tiền được quy đổi từ SGD theo tỷ giá của tuần trong Set up (NetSuite, thứ Sáu); số dư riêng của tài khoản giữ nguyên tiền tệ của nó.",
      "baseRate": "Theo tỷ giá của tuần trong Set up: 1 {{ccy}} = {{rate}} SGD.",
      "noBaseRate": "Chưa có tỷ giá {{ccy}} của tuần này trong Set up — hiển thị bằng SGD.",
      "balanceWhy": "Xem tiền mặt theo từng tài khoản ngân hàng",
      "balanceNote": "Số dư = tiền ngân hàng đang giữ cuối tuần. Khả dụng = Số dư − Bị hạn chế − Tiền gửi có kỳ hạn. Số dư riêng của tài khoản theo tiền tệ của nó, như trên sao kê; các số khác quy đổi theo tỷ giá của tuần trong Set up (NetSuite). Thay đổi tính trên các pháp nhân báo cáo cả hai tuần.",
      "tot_balance": "Số dư",
      "title": "Báo cáo tiền mặt · Tuần",
      "sub": "Mỗi pháp nhân nhập Template 1 của tuần trên màn hình Gửi báo cáo; báo cáo sau đó đi từ Người lập → Người duyệt, và hiện ở đây sau khi Người duyệt đồng ý. Mọi số liệu ở đây đều tính bằng SGD và do Portal tính từ dữ liệu đã nhập.",
      "prevWeek": "Tuần trước",
      "nextWeek": "Tuần sau",
      "weekLine": "Tuần kết thúc {{end}} · hạn nộp báo cáo {{due}}",
      "closedWeek": "Đã đóng",
      "noRates": "Thiết lập chưa có tỷ giá cho tuần này — tỷ giá sẽ được lấy từ NetSuite khi có tỷ giá ngày thứ Sáu. Trước đó, số liệu không thể hiển thị bằng SGD và không thể gửi báo cáo.",
      "h_entity": "Pháp nhân",
      "h_opening": "Đầu kỳ",
      "h_inflow": "Tiền vào",
      "h_outflow": "Tiền ra",
      "h_closing": "Cuối kỳ",
      "h_restricted": "Bị hạn chế",
      "h_fd": "Tiền gửi có kỳ hạn",
      "h_available": "Khả dụng",
      "h_change": "So với tuần trước",
      "h_belowMin": "Dưới số dư tối thiểu",
      "h_status": "Trạng thái",
      "h_no": "STT",
      "h_category": "Hạng mục",
      "h_memo": "Ghi chú",
      "h_amount": "Số tiền (SGD)",
      "h_account": "Tài khoản",
      "h_ccy": "Tiền tệ",
      "h_closingStmt": "Cuối kỳ (sao kê)",
      "h_diff": "Chênh lệch",
      "h_rate": "Tỷ giá sang SGD",
      "h_closingSgd": "Cuối kỳ (SGD)",
      "h_files": "Tệp",
      "h_kind": "Loại",
      "h_other": "Pháp nhân đối ứng",
      "h_ref": "Tham chiếu",
      "groupNote": "Không tính giao dịch giữa các pháp nhân với nhau",
      "groupCount": "{{n}}/{{of}} pháp nhân đã được xem xét",
      "unmatched": "Giao dịch liên công ty chưa bù trừ: {{amt}} SGD",
      "unmatchedWhy": "Số tiền các pháp nhân báo đã nhận của nhau và đã trả cho nhau không cộng lại bằng 0 — một bên chưa báo cáo, hoặc khoản tiền đang trên đường chuyển. Cuối kỳ là tiền mặt các ngân hàng đang giữ, nên nó khác Đầu kỳ + Tiền vào − Tiền ra đúng bằng số tiền này.",
      "nothingYet": "Chưa có pháp nhân nào tải lên trong tuần này.",
      "yearTitle": "Tất cả các tuần của năm {{year}}",
      "yearPick": "Năm",
      "h_weekEntity": "Pháp nhân / Tài khoản",
      "h_bank": "Ngân hàng",
      "h_acctNo": "Số tài khoản",
      "h_acctType": "Loại tài khoản",
      "h_acctFlag": "Bị hạn chế / Tiền gửi có kỳ hạn",
      "weekTitle": "Tuần {{code}} · kết thúc {{end}}",
      "weekOpenWhy": "Mở hoặc thu gọn các pháp nhân của tuần này",
      "weekPickWhy": "Chọn tuần này để hiển thị — biểu đồ, Top 3 và báo cáo của tuần",
      "weekNothing": "Chưa có báo cáo",
      "yearLoading": "Đang tải các tuần còn lại của năm…",
      "yearNote": "Mỗi tuần trong năm có một dòng GROUP; bấm ▸ để mở các pháp nhân của tuần, bấm ▸ của pháp nhân để xem các tài khoản, và bấm mã tuần để chọn tuần đó hiển thị.",
      "origClosing": "Cuối kỳ bằng {{ccy}}: {{amt}}",
      "inCcy": "Bằng {{ccy}}",
      "origWhy": "Bằng {{ccy}}, đồng tiền của chính tài khoản, như trên sao kê ngân hàng.",
      "notUploaded": "Chưa tải lên.",
      "notReviewed": "Chưa được xem xét — số liệu sẽ hiện khi Người duyệt đồng ý.",
      "expandWhy": "Xem tiền mặt theo từng tài khoản ngân hàng",
      "errorsN_one": "{{count}} lỗi Data Check",
      "errorsN_other": "{{count}} lỗi Data Check",
      "below": "Dưới mức",
      "belowWhy": "Tiền mặt khả dụng thấp hơn số dư tối thiểu {{min}} SGD đã đặt cho pháp nhân này.",
      "noMinWhy": "Chưa đặt số dư tối thiểu cho pháp nhân này trong Thiết lập.",
      "interGroup": "Giao dịch liên công ty",
      "interGroupWhy": "Với các pháp nhân Helinox khác — không tính vào dòng GROUP.",
      "restrictedTag": "Bị hạn chế",
      "fdTag": "Tiền gửi có kỳ hạn",
      "noTxn": "Không có giao dịch",
      "sgdNote": "SGD = số tiền theo đồng tiền của tài khoản × tỷ giá của tuần trong Thiết lập (NetSuite). Số dư cuối kỳ theo đồng tiền của tài khoản được ghi trên dòng của tài khoản đó. Tiền vào và Tiền ra không tính các khoản chuyển nội bộ pháp nhân; Khả dụng = Cuối kỳ − Bị hạn chế − Tiền gửi có kỳ hạn.",
      "topTitle": "Top 3",
      "top_spend": "Top 3 khoản chi chính trong tuần",
      "top_payable": "Top 3 khoản phải trả tuần sau",
      "noTops": "Chưa có pháp nhân nào báo cáo trong tuần này",
      "expandAll": "Mở tất cả",
      "collapseAll": "Thu gọn tất cả",
      "st_none": "Chưa tải lên",
      "st_open": "Đã lập — chưa gửi",
      "st_returned": "Bị trả lại",
      "st_submitted": "Đang ở Người duyệt",
      "st_reviewed": "Đã đồng ý",
      "st_approved": "Đã duyệt",
      "st_closed": "Đã đóng",
      "by_submitted": "{{by}} gửi lúc {{at}}",
      "by_reviewed": "{{by}} xem xét lúc {{at}}",
      "by_approved": "{{by}} duyệt lúc {{at}}",
      "by_closed": "{{by}} đóng lúc {{at}}",
      "by_returned": "{{by}} trả lại lúc {{at}}",
      "weekEnding": "tuần kết thúc {{d}}",
      "step_prep": "Người lập",
      "step_review": "Người duyệt",
      "step_cfo": "Group CFO",
      "step_ceo": "CEO",
      "notYet": "Chưa",
      "returnedBy": "{{by}} đã trả lại lúc {{at}}:",
      "weekClosed": "Tuần này đã đóng trong Thiết lập — chỉ có thể xem báo cáo, không thể tải lên.",
      "weekClosedReturned": "Tuần này đã đóng trong Thiết lập, nhưng báo cáo bị trả lại vẫn có thể sửa và gửi lại.",
      "selfBlocked": "Bạn đã tải lên phiên bản này hoặc đã thực hiện một bước trước đó của báo cáo, nên bước “{{step}}” phải do người khác thực hiện.",
      "tooBig": "Mỗi tệp tối đa 3.5 MB. Hãy lưu sao kê ngân hàng thành tệp PDF nhỏ hơn, hoặc đính kèm thành nhiều phần.",
      "changeOver_one": "Tính trên {{count}} pháp nhân đã báo cáo cả hai tuần",
      "changeOver_other": "Tính trên {{count}} pháp nhân đã báo cáo cả hai tuần",
      "template": "Tải mẫu",
      "upload": "Nhập tệp",
      "uploadAgain": "Nhập lại",
      "notePh": "Ghi chú cho Người duyệt (không bắt buộc)",
      "submit": "Gửi cho Người duyệt",
      "fixFirst": "Hãy sửa các lỗi Data Check trước khi gửi.",
      "btn_review": "Xem xét & đồng ý",
      "btn_approve": "Duyệt",
      "btn_close": "Duyệt & đóng",
      "sendBack": "Trả lại",
      "reopen": "Mở lại để sửa",
      "reopenWhy": "Đã đồng ý. Mở lại sẽ trả báo cáo về Người lập kèm lý do của bạn; số liệu của báo cáo sẽ rời khỏi Báo cáo tiền mặt cho đến khi được đồng ý lại.",
      "done_submit": "Đã gửi cho Người duyệt.",
      "done_review": "Đã xem xét và đồng ý — báo cáo hiện đã có trong Báo cáo tiền mặt.",
      "done_approve": "Đã duyệt — hiện đang chờ CEO.",
      "done_close": "Đã duyệt và đóng.",
      "done_return": "Đã trả lại cho Người lập kèm lý do của bạn.",
      "mailHeld": "(Không có mail nào được gửi: mail của Báo cáo tiền mặt đang được giữ lại trong lúc xây dựng module.)",
      "uploadedOk": "Đã nhập phiên bản {{v}}.",
      "replacedOk": "Đã nhập phiên bản {{v}} — phiên bản này đã qua Data Check và thay thế phiên bản {{old}} đang ở Người duyệt.",
      "correctWhileReview": "Đang ở Người duyệt (phiên bản {{v}}). Bạn vẫn có thể sửa ngay bên dưới hoặc nhập tệp đã sửa: sau khi lưu, nếu qua Data Check, phiên bản mới sẽ thay thế phiên bản Người duyệt đang xem.",
      "uploadedErrors_one": "Đã tải lên phiên bản {{v}} — có {{count}} lỗi Data Check cần sửa trước khi gửi.",
      "uploadedErrors_other": "Đã tải lên phiên bản {{v}} — có {{count}} lỗi Data Check cần sửa trước khi gửi.",
      "nothingUploaded": "Chưa nhập gì.",
      "sumErrors_one": "{{count}} lỗi Data Check",
      "sumErrors_other": "{{count}} lỗi Data Check",
      "sumWarns_one": "{{count}} cảnh báo",
      "sumWarns_other": "{{count}} cảnh báo",
      "versionLine": "Đang hiển thị phiên bản {{v}}",
      "accountsTitle": "Tài khoản",
      "transfersTitle": "Chuyển khoản",
      "filesTitle": "Sao kê ngân hàng và ảnh chụp màn hình",
      "versionsTitle": "Phiên bản — nhập từ tệp hoặc nhập tay",
      "historyTitle": "Lịch sử và bình luận",
      "current": "Đang trong quy trình",
      "rateFrom_setup": "Tỷ giá từ Thiết lập",
      "rateFrom_base": "Đồng tiền cơ sở",
      "tot_opening": "Đầu kỳ",
      "tot_inflow": "Tiền vào",
      "tot_outflow": "Tiền ra",
      "tot_closing": "Cuối kỳ",
      "tot_restricted": "Bị hạn chế",
      "tot_fixed_deposit": "Tiền gửi có kỳ hạn",
      "tot_available": "Khả dụng",
      "tr_internal": "Nội bộ pháp nhân",
      "tr_group": "Liên công ty",
      "kind_statement": "Sao kê",
      "kind_balance": "Ảnh chụp số dư",
      "kind_other": "Khác",
      "wholeEntity": "Toàn pháp nhân",
      "attach": "Đính kèm tệp",
      "attached": "Đã đính kèm tệp.",
      "removeFile": "Xóa tệp này",
      "noFiles": "Chưa có tệp đính kèm.",
      "commentPh": "Viết bình luận…",
      "comment": "Bình luận",
      "noEvents": "Chưa có hoạt động nào.",
      "waitingYou": "Đang chờ bạn",
      "waitingOpen": "Mở trong mục Duyệt để quyết định",
      "ev_upload": "đã nhập phiên bản {{v}} từ tệp",
      "ev_entry": "đã lưu phiên bản {{v}}, sửa trên Portal",
      "changesAgainst": "Thay đổi so với phiên bản {{v}} — {{n}}",
      "noChange": "Không có số liệu nào thay đổi so với phiên bản {{v}}.",
      "moreChanges": "Xem thêm {{n}}",
      "fewerChanges": "Thu gọn",
      "changesCut": "…và {{n}} thay đổi khác.",
      "ev_discard": "đã hủy phiên bản {{v}}",
      "cancelled": "Đã hủy",
      "ev_submit": "đã gửi phiên bản {{v}} cho Người duyệt",
      "ev_review": "đã xem xét và đồng ý",
      "ev_approve": "đã duyệt",
      "ev_close": "đã duyệt và đóng",
      "ev_return": "đã trả lại",
      "ev_comment": "đã bình luận",
      "ev_file": "đã đính kèm một tệp",
      "ev_unfile": "đã xóa một tệp"
    },
    "cashp": {
      "title": "Báo cáo tiền mặt · Kế hoạch tiền mặt 13 tuần",
      "sub": "Mỗi pháp nhân lập kế hoạch cho 13 tuần tới bằng SGD (Template 2), và kế hoạch được so với số liệu trong các Báo cáo tiền mặt hằng tuần sau đó. Mỗi tuần lập một kế hoạch mới; cùng hai bước như báo cáo tuần.",
      "startsLine": "Kế hoạch bắt đầu từ {{week}} (tuần kết thúc {{end}}), kéo dài đến {{last}}",
      "h_week": "Tuần số",
      "h_end": "Ngày cuối tuần",
      "h_planOpen": "Đầu kỳ (cuối kỳ trước)",
      "h_planIn": "Tiền vào kế hoạch",
      "h_planOut": "Tiền ra kế hoạch",
      "h_planClose": "Cuối kỳ kế hoạch (Dự kiến)",
      "h_actIn": "Tiền vào thực tế",
      "h_actOut": "Tiền ra thực tế",
      "h_actClose": "Cuối kỳ thực tế",
      "h_variance": "Chênh lệch so với kế hoạch (Cuối kỳ)",
      "h_weekly": "Báo cáo tuần",
      "h_reported": "Đã báo cáo",
      "h_comment": "Bình luận",
      "h_planClose13": "Cuối kỳ kế hoạch, tuần 13",
      "h_planOpen1": "Đầu kỳ, tuần 1",
      "h_planIn13": "Tiền vào kế hoạch, 13 tuần",
      "h_planOut13": "Tiền ra kế hoạch, 13 tuần",
      "noReviewed": "Chưa có kế hoạch nào được xem xét",
      "reportedOf": "{{n}} đã báo cáo",
      "noPlan": "Chưa có pháp nhân nào tải lên kế hoạch bắt đầu từ tuần này.",
      "openWhy": "Mở hoặc thu gọn kế hoạch cả năm",
      "groupPlanned": "Kế hoạch đã xem xét: {{n}}/{{of}} pháp nhân",
      "listHint": "Tình trạng kế hoạch tuần này của từng pháp nhân. Biểu đồ và bảng phía trên thay đổi theo lựa chọn.",
      "pickLabel": "Hiển thị",
      "pickGroup": "GROUP (tất cả pháp nhân)",
      "pickGroupWhy": "tất cả pháp nhân, cộng gộp",
      "filtersTitle": "Lọc kế hoạch",
      "filterEntities": "Pháp nhân",
      "filtersHint": "Chọn GROUP, một pháp nhân hoặc nhiều pháp nhân (sẽ được cộng gộp); sau đó chọn năm. Biểu đồ và bảng 53 tuần bên dưới thay đổi theo cả hai.",
      "oneYear": "Hiện các kế hoạch mới chỉ có trong một năm",
      "weeksShown": "{{count}}/{{of}} tuần",
      "h_planFrom": "Từ kế hoạch",
      "planFromWhy": "Lấy từ kế hoạch bắt đầu {{week}} — kế hoạch mới nhất bao gồm tuần này",
      "plannedBy_one": "{{count}} pháp nhân",
      "plannedBy_other": "{{count}} pháp nhân",
      "yearOf": "tất cả các tuần của năm {{year}}",
      "yearNote": "Tất cả các tuần trong năm. Mỗi tuần lấy số liệu từ kế hoạch mới nhất bao gồm tuần đó — tuần đã qua lấy từ kế hoạch lập cho tuần đó, tuần sắp tới lấy từ dự báo mới nhất — và cột “Từ kế hoạch” cho biết đó là kế hoạch nào.",
      "groupTitle_one": "GROUP — {{count}} pháp nhân đã lập kế hoạch",
      "groupTitle_other": "GROUP — tổng của {{n}} pháp nhân đã lập kế hoạch cho tuần này",
      "groupNote": "GROUP cộng gộp các pháp nhân đã lập kế hoạch cho tuần này. Số thực tế chỉ được tính khi tất cả các pháp nhân đó đã báo cáo tuần đó, nên chênh lệch không bao giờ so số thực tế của một vài pháp nhân với kế hoạch của tất cả.",
      "entityNote": "Số thực tế là số liệu bằng SGD của chính Báo cáo tiền mặt hằng tuần (tiền vào và tiền ra không tính chuyển khoản nội bộ pháp nhân, cuối kỳ = số dư cuối kỳ tại các ngân hàng). Chênh lệch = cuối kỳ thực tế − cuối kỳ kế hoạch.",
      "panelHeading": "Kế hoạch bắt đầu {{week}}",
      "opening": "Tiền mặt đầu kỳ (SGD)",
      "closing13": "Cuối kỳ kế hoạch, tuần 13 (SGD)"
    },
    "cashm": {
      "title": "Báo cáo tiền mặt · Đối chiếu cuối tháng",
      "sub": "Mỗi pháp nhân đối chiếu từng tài khoản vào cuối tháng (Template 3): số dư cuối kỳ trên sao kê ngân hàng hằng tháng so với số dư cuối tuần trong Báo cáo tiền mặt hằng tuần (ngày cuối tuần gần nhất vào hoặc trước ngày cuối tháng), và các khoản phát sinh giữa hai ngày đó. Đối chiếu = Chênh lệch − Tiền vào + Tiền ra, và phải bằng 0. Cùng hai bước như báo cáo tuần.",
      "monthLine": "{{month}} · cuối tháng {{end}}",
      "open": "Có thể đối chiếu",
      "notEnded": "Chưa kết thúc",
      "notEndedLine": "Tháng này chưa kết thúc — việc đối chiếu sẽ mở khi tháng kết thúc.",
      "ruleHead": "Mốc cuối tuần: {{week}} ({{end}}).",
      "h_reconciled": "Tài khoản đã đối chiếu",
      "h_totalSgd": "Số dư cuối tháng (SGD)",
      "h_monthEnd": "Số dư cuối tháng",
      "h_weekEnd": "Số dư cuối tuần ({{week}})",
      "h_variance": "Chênh lệch",
      "netOff": "Bù trừ",
      "statusGroup": "Trạng thái",
      "h_netIn": "Tiền vào bù trừ",
      "h_netOut": "Tiền ra bù trừ",
      "h_reconcile": "Đối chiếu",
      "accountsTitle": "Tài khoản",
      "reconciled": "Tài khoản đã đối chiếu",
      "totalSgd": "Số dư cuối tháng (SGD)",
      "unconvertedWhy": "Các tài khoản chưa có tỷ giá trong Thiết lập cho ngày cuối tuần không được tính vào tổng SGD.",
      "monthEndOn": "cuối tháng {{d}}",
      "st_submitted": "Đã lập",
      "st_reviewed": "Đã xem xét",
      "st_approved": "Đã duyệt",
      "st_closed": "Đã đóng",
      "unconverted": "{{n}} chưa có tỷ giá",
      "allReconciled": "Cả {{n}} đều đã đối chiếu",
      "reportNote": "Dòng của mỗi pháp nhân ghi số dư cuối tháng bằng SGD và người lập, người xem xét phần đối chiếu; các tài khoản của pháp nhân nằm bên dưới, theo đồng tiền của từng tài khoản. Bấm vào một pháp nhân để mở phần đối chiếu."
    },
    "cashq": {
      "title": "Duyệt",
      "sub": "Các báo cáo Người lập đã gửi, gồm Báo cáo tiền mặt hằng tuần, Kế hoạch tiền mặt 13 tuần và Đối chiếu cuối tháng. Chọn một báo cáo để xem, rồi đồng ý hoặc trả lại. Khi Người duyệt đồng ý, báo cáo sẽ hiện trong Báo cáo tiền mặt. Báo cáo bị trả lại nằm ở mục Đang xử lý cho đến khi được gửi lại.",
      "tab_waiting": "Đang chờ bạn",
      "tab_progress": "Đang xử lý",
      "tab_closed": "Đã đồng ý",
      "rows_one": "{{count}} báo cáo",
      "rows_other": "{{count}} báo cáo",
      "clear": "Xóa sắp xếp và bộ lọc",
      "colReport": "Báo cáo",
      "colEntity": "Pháp nhân",
      "colPeriod": "Kỳ",
      "colStatus": "Trạng thái",
      "colSentBy": "Người gửi",
      "colSentAt": "Ngày gửi",
      "colUpdated": "Thay đổi gần nhất",
      "empty_waiting": "Không có gì đang chờ bạn quyết định.",
      "empty_progress": "Không có báo cáo nào đang đi qua các bước hoặc bị trả lại cho Người lập.",
      "empty_closed": "Chưa có báo cáo nào được đồng ý.",
      "notListed": "Báo cáo đó không có trong danh sách chờ của bạn — có thể chưa được gửi, hoặc bạn không có quyền xem."
    },
    "cashi": {
      "title": "Gửi báo cáo",
      "sub": "Tải từng mẫu cho pháp nhân của bạn, điền, nhập vào, kiểm tra rồi gửi cho Người duyệt.",
      "entity": "Pháp nhân",
      "yoursOne": "Pháp nhân của bạn, theo danh sách Người dùng trong Thiết lập.",
      "yoursMany": "Bạn là Người lập của {{n}} pháp nhân — hãy chọn pháp nhân bạn đang nhập.",
      "notPreparer": "Bạn không phải Người lập của pháp nhân nào trong danh sách Người dùng của Báo cáo tiền mặt, nên ở đây bạn chỉ có thể xem và tải xuống, không thể nhập. Người lập được chỉ định trong Thiết lập › Người dùng.",
      "noEntity": "Không có pháp nhân nào để hiển thị.",
      "checkPassed": "Đã qua Data Check",
      "saveOrCancel": "Hãy lưu hoặc hủy các thay đổi trước, rồi mới nhập.",
      "openReport": "Mở {{report}}",
      "pointer": "Báo cáo này được nhập và gửi trên màn hình Gửi báo cáo ({{tpl}}).",
      "pointerReturned": "Đã trả lại cho Người lập — báo cáo được sửa và gửi lại trên màn hình Gửi báo cáo.",
      "goImport": "Mở Gửi báo cáo",
      "pointerDecide": "Báo cáo này đang chờ bạn quyết định — hãy đồng ý hoặc trả lại trong mục Duyệt.",
      "nothingYet": "Chưa nhập gì — Người lập của pháp nhân sẽ nhập {{tpl}} trên màn hình Gửi báo cáo."
    },
    "cashc": {
      "byEntity": "Tiền mặt theo pháp nhân ({{ccy}})",
      "byEntitySub": "Số dư cuối kỳ chia thành Khả dụng, Bị hạn chế và Tiền gửi có kỳ hạn — {{n}}/{{of}} pháp nhân đã được xem xét trong tuần này.",
      "trend": "Tiền mặt GROUP, 12 tuần gần nhất ({{ccy}})",
      "trendSub": "Số dư và Khả dụng của các pháp nhân đã báo cáo mỗi tuần — khoảng trống là tuần không ai báo cáo.",
      "reported": "{{n}}/{{of}} đã báo cáo",
      "noneYet": "Chưa có pháp nhân nào báo cáo.",
      "noTrend": "Chưa có tuần nào trong khoảng này có báo cáo.",
      "planTitle": "Kế hoạch — {{who}} (SGD)",
      "planSub": "Tiền vào kế hoạch hướng lên, tiền ra kế hoạch hướng xuống; đường nét đứt là cuối kỳ kế hoạch, đường liền là cuối kỳ thực tế từ Báo cáo tiền mặt hằng tuần.",
      "monthCash": "Tiền mặt cuối tháng theo pháp nhân (SGD)",
      "monthCashSub": "{{n}}/{{of}} pháp nhân đã báo cáo trong tháng này.",
      "noRateAll": "Sẽ hiển thị bằng SGD khi có tỷ giá cho {{week}} trong Thiết lập — hiện chưa tài khoản nào đã báo cáo có thể quy đổi.",
      "noRateSome": "Chưa vẽ — chưa có tỷ giá cho {{week}}: {{list}}.",
      "recon": "Tài khoản đã đối chiếu",
      "reconSub": "Theo pháp nhân: tài khoản có Đối chiếu bằng 0, và tài khoản có chênh lệch.",
      "reconciled": "Đã đối chiếu",
      "difference": "Có chênh lệch",
      "accounts_one": "{{count}} tài khoản",
      "accounts_other": "{{count}} tài khoản"
    },
    "cashf": {
      "inputTitle": "Nhập liệu — {{tpl}}",
      "enterHere": "Nhập trên Portal",
      "editHere": "Sửa trên Portal",
      "inputClosed": "Chỉ Người lập của pháp nhân mới nhập được báo cáo này, khi báo cáo đang mở hoặc bị trả lại.",
      "field1": "Field 1 — Dòng tiền thực tế của pháp nhân (SGD)",
      "field2": "Field 2 — Tài khoản của pháp nhân: tổng tất cả giao dịch",
      "field3": "Field 3 — Chuyển khoản nội bộ pháp nhân (giữa các tài khoản của chính pháp nhân)",
      "field4": "Field 4 — Giao dịch liên công ty (với một pháp nhân Helinox khác)",
      "field5": "Field 5 — Top 3 khoản chi chính trong tuần",
      "field6": "Field 6 — Top 3 khoản phải trả tuần sau",
      "f1Entity": "Pháp nhân",
      "f1Overall": "Tổng thể",
      "f1Group": "Giao dịch liên công ty",
      "f1NoRate": "Field 1 được tính bằng SGD khi đồng tiền của mọi tài khoản đều có tỷ giá tuần này trong Thiết lập › Tỷ giá.",
      "h_rate": "Tỷ giá",
      "h_noTxn": "Xác nhận không có giao dịch",
      "h_restrictedAcct": "Tài khoản bị hạn chế",
      "h_fdAcct": "Tiền gửi có kỳ hạn",
      "h_upStatement": "Tải lên sao kê",
      "h_upBalance": "Tải lên ảnh chụp số dư",
      "h_entity": "Pháp nhân",
      "h_no": "STT",
      "h_category": "Hạng mục",
      "h_memo": "Ghi chú",
      "h_amountSgd": "Số tiền (SGD)",
      "fromSetup": "Theo loại tài khoản trong Thiết lập",
      "rateFromSetup": "Tỷ giá tuần này từ Thiết lập",
      "rateMissing": "Chưa có tỷ giá {{ccy}} cho tuần này trong Thiết lập › Tỷ giá (đồng bộ từ NetSuite) — không thể nhập tay ở đây",
      "closingCalc": "Cuối kỳ = Đầu kỳ + Tiền vào − Tiền ra",
      "closingFiled": "Tệp đã nhập ghi Cuối kỳ là {{v}} — Đầu kỳ + Tiền vào − Tiền ra ra con số đang hiển thị. Lưu ở đây sẽ giữ con số được tính.",
      "closingDiff": "Đầu kỳ + Tiền vào − Tiền ra lệch {{d}} so với Cuối kỳ này",
      "memoPh": "Đây là khoản gì — dài bao nhiêu cũng được",
      "f4None": "Không có giao dịch liên công ty trong tuần này.",
      "rateOpt": "Tỷ giá sang SGD (không bắt buộc)",
      "noTxn": "Không có giao dịch",
      "check": "Kiểm tra",
      "ok": "OK",
      "diff": "Lệch {{d}}",
      "notNumber": "Không phải số",
      "noTxnAmounts": "Ghi không có giao dịch nhưng lại có số tiền",
      "upStatement": "Sao kê",
      "upBalance": "Số dư",
      "addRow": "Thêm dòng",
      "removeRow": "Xóa dòng này",
      "save": "Lưu thành phiên bản mới",
      "cancel": "Hủy chỉnh sửa",
      "cancelImport": "Hủy nhập",
      "cancelBack": "Gỡ phiên bản {{v}} và đưa báo cáo về phiên bản {{back}}.",
      "cancelEmpty": "Gỡ phiên bản {{v}} — báo cáo trở về trống, sẵn sàng để nhập lại.",
      "discardedBack": "Đã hủy phiên bản {{v}} — quay về phiên bản {{back}}.",
      "discardedEmpty": "Đã hủy phiên bản {{v}} — báo cáo lại trống.",
      "noChanges": "Chưa có thay đổi — hãy sửa một số liệu hoặc nhập tệp.",
      "saveHint": "Lưu sẽ tạo phiên bản mới và chạy lại Data Check.",
      "payrollRule": "Lương chỉ nhập MỘT con số tổng. Tuyệt đối không nhập tên nhân viên hay lương của từng người.",
      "savedOk": "Đã lưu phiên bản {{v}}.",
      "savedReplaced": "Đã lưu phiên bản {{v}} — phiên bản này đã qua Data Check và thay thế phiên bản {{old}} đang ở Người duyệt.",
      "savedErrors_one": "Đã lưu phiên bản {{v}} — có {{count}} lỗi Data Check cần sửa trước khi gửi.",
      "savedErrors_other": "Đã lưu phiên bản {{v}} — có {{count}} lỗi Data Check cần sửa trước khi gửi.",
      "openingFrom": "Số dư cuối kỳ trước của tuần đầu tiên là số dư cuối kỳ trong Báo cáo tiền mặt hằng tuần {{week}} của bạn — chỉ sửa nếu sai.",
      "prepareDate": "Ngày lập",
      "entityGroup": "Pháp nhân / Nhóm",
      "entityLabel": "Pháp nhân",
      "currency": "Tiền tệ",
      "currencySgd": "SGD — mọi số liệu trong mẫu này",
      "planCloseExp": "Cuối kỳ kế hoạch (Dự kiến)",
      "prevWeek": "tuần trước",
      "thisWeek": "tuần này",
      "openingNone": "Không có Báo cáo tiền mặt hằng tuần cho tuần trước — hãy nhập tiền mặt đầu kỳ."
    },
    "gtm": {
      "title": "Chương trình GTM",
      "subtitle": "Viết chương trình theo bảy câu hỏi rồi gửi để duyệt. Người duyệt quyết định trong GTM › Duyệt.",
      "newProgramme": "Chương trình mới",
      "createTitle": "Bắt đầu một chương trình",
      "nameLabel": "Tiêu đề",
      "namePlaceholder": "VD: Sunset Chair (re) Home · Book Reading Edition",
      "create": "Tạo",
      "cancel": "Hủy",
      "back": "Tất cả chương trình",
      "none": "Chưa có chương trình nào.",
      "openDecisions": "Cần quyết định",
      "openVerifies": "Cần xác minh",
      "regionsWaiting": "Khu vực chờ phản hồi",
      "committed": "Số lượng đã cam kết",
      "ofTarget": "trên tổng {{n}}",
      "editProgramme": "Sửa chương trình",
      "headline": "Mô tả ngắn",
      "openItem": "Mục chưa giải quyết",
      "openItems": "Quyết định, công việc và kiểm tra",
      "noItems": "Câu hỏi này chưa có mục nào.",
      "lineTitle": "Đây là gì",
      "lineDetail": "Chi tiết",
      "inThisProgrammeHint": "Lý do có trong chương trình, hoặc lý do không — câu mà bảng in bên cạnh.",
      "discardAsk": "Bỏ những gì bạn đã nhập?",
      "needed": "Còn thiếu: {{fields}}",
      "editTable": "Sửa bảng",
      "editTableWhy": "Mở khóa bảng, sửa bao nhiêu dòng tùy ý, rồi lưu một lần",
      "editTableHint": "Cứ nhập thoải mái — chưa có gì được ghi cho đến khi bạn lưu, và việc lưu diễn ra một lần: hoặc tất cả được ghi, hoặc không có gì thay đổi.",
      "saveTable": "Lưu bảng",
      "saveTableN": "Lưu bảng ({{n}})",
      "layerHead": "Những gì diễn ra phía trên các kênh bán hàng",
      "stage": "Giai đoạn",
      "role": "Vai trò",
      "condition": "Điều kiện",
      "addStage": "Thêm giai đoạn",
      "orderHead": "Thứ tự",
      "orderLabel": "Thứ tự các việc diễn ra",
      "step": "Bước",
      "stepDetail": "Đây là gì",
      "addStep": "Thêm bước",
      "savedN": "Đã lưu {{n}} thay đổi.",
      "savedNothing": "Không có gì thay đổi.",
      "regionsHint": "Các khu vực chương trình này bao phủ, theo thứ tự ưu tiên — kéo một dòng hoặc dùng mũi tên để thay đổi.",
      "sheetLocked": "Bấm Sửa để thay đổi bất kỳ nội dung nào trên trang này.",
      "sheetOpen": "Trang đang mở — cứ nhập thoải mái. Chưa có gì được ghi cho đến khi bạn bấm Lưu. Di chuyển một dòng sẽ được lưu ngay khi bạn thực hiện.",
      "acrossProgramme": "Trên toàn chương trình",
      "qOpenCount": "{{n}} mục còn mở",
      "removeYes": "Gỡ bỏ",
      "waitingOnYou": "Đang chờ bạn quyết định",
      "rev_draft": "Chưa gửi duyệt",
      "rev_in_review": "Đang ở người duyệt",
      "rev_approved": "Đã duyệt",
      "rev_rejected": "Bị từ chối",
      "approver": "Người duyệt",
      "sentForReview": "Đã gửi duyệt",
      "approvedOn": "Đã duyệt",
      "rejectedOn": "Bị từ chối",
      "sendForReview": "Gửi duyệt",
      "reviewAgain": "Gửi duyệt lại",
      "approve": "Duyệt",
      "resubmit": "Gửi lại",
      "sent": "Đã gửi",
      "view": "Xem",
      "kpiAll": "Tất cả chương trình",
      "kpiMine": "Chương trình của tôi",
      "scopeMine": "Chương trình của tôi",
      "scopeAll": "Tất cả chương trình",
      "noneMine": "Bạn chưa có chương trình nào — không có chương trình nào do bạn tạo, gửi hoặc phụ trách.",
      "showAll_one": "Hiển thị {{count}} chương trình",
      "showAll_other": "Hiển thị tất cả {{count}} chương trình",
      "backApproval": "Duyệt GTM",
      "approvalTitle": "Duyệt GTM",
      "approvalSub": "Các chương trình được gửi cho bạn để quyết định. Bản nháp vẫn nằm ở tác giả và không bao giờ xuất hiện ở đây.",
      "approvalSubAdmin": "Các chương trình đã gửi để quyết định. Là admin, bạn thấy danh sách chờ của mọi người duyệt; bản nháp không bao giờ xuất hiện ở đây.",
      "tabWaiting": "Chờ quyết định",
      "tabApproved": "Đã duyệt",
      "tabRejected": "Bị từ chối",
      "emptyQueue_in_review": "Không có gì đang chờ bạn quyết định.",
      "emptyQueue_approved": "Chưa có gì được duyệt.",
      "emptyQueue_rejected": "Không có gì bị từ chối.",
      "colSentBy": "Người gửi",
      "colSentOn": "Ngày gửi",
      "colDecidedOn": "Ngày quyết định",
      "colCreatedBy": "Người tạo",
      "colCreatedAt": "Ngày tạo",
      "colUpdatedBy": "Người cập nhật",
      "colUpdatedAt": "Ngày cập nhật",
      "colManagerNote": "Ghi chú của quản lý",
      "colSkus": "SKU dự án",
      "skuHead": "SKU dự án đã liên kết",
      "skuHint": "Các SKU dự án được ra mắt theo chương trình này. Liên kết này cũng chính là trường GTM trên mỗi SKU trong Theo dõi dự án.",
      "skuNone": "Chưa liên kết SKU dự án nào.",
      "skuId": "ID SKU dự án",
      "skuName": "Tên SKU",
      "skuGroup": "Nhóm dự án",
      "skuStatus": "Trạng thái",
      "skuPh": "Chọn hoặc nhập SKU dự án, VD: 9048 hoặc SKU-09048",
      "skuAdd": "Liên kết SKU",
      "skuUnlink": "Bỏ liên kết SKU này",
      "deleteLockedSent": "Đã gửi duyệt — không thể xóa khi người duyệt đang giữ.",
      "deleteLockedApproved": "Đã duyệt — chương trình đã duyệt không thể xóa.",
      "countAll_one": "{{count}} chương trình",
      "countAll_other": "{{count}} chương trình",
      "countOf": "{{n}}/{{total}} chương trình",
      "searchPh": "Tìm mã, tiêu đề, người phụ trách…",
      "clear": "Xóa lọc",
      "noMatch": "Không có chương trình nào khớp với bộ lọc này.",
      "loading": "Đang tải…",
      "colNo": "STT",
      "colCode": "Mã GTM",
      "colTitle": "Chương trình",
      "colStatus": "Trạng thái",
      "colOwner": "Người phụ trách",
      "colApprover": "Người duyệt",
      "colLaunch": "Ra mắt",
      "colDecisions": "Quyết định",
      "colVerify": "Cần xác minh",
      "colRegions": "Khu vực",
      "colAction": "Thao tác",
      "reviewDone_submit": "Đã gửi duyệt.",
      "reviewDone_approve": "Đã duyệt.",
      "reviewDone_reject": "Đã từ chối.",
      "coverEyebrow": "Chương trình GTM",
      "printedOn": "Ngày in",
      "coverStatus": "Tình trạng duyệt",
      "coverDecisionNote": "Ghi chú quyết định",
      "exportPdf": "Xuất PDF",
      "delete": "Xóa",
      "deleteProgramme": "Xóa chương trình này",
      "deleteBody": "Thao tác này sẽ xóa {{n}} dòng và {{photos}} ảnh thuộc chương trình.",
      "deleteWarn": "Không thể hoàn tác.",
      "exporting": "Đang xuất…",
      "pdf": "PDF",
      "addStop": "Thêm điều kiện dừng",
      "stopKind_manual": "Theo dõi thủ công",
      "stopKind_commit_min": "Cam kết của các khu vực dưới một mức",
      "stopKind_anchor_consent": "Người phụ trách ở khu vực dẫn đầu không đồng ý",
      "stopKindAsk": "Portal cần đọc thông tin gì?",
      "deleteYes": "Xóa",
      "measureHead": "Cách đo lường thành công",
      "measureHint": "Mỗi chỉ số là gì và thế nào được xem là tốt.",
      "measureItem": "Chỉ số",
      "measureWhat": "Là gì và được đánh giá ra sao",
      "measurePh": "Bảo vệ dòng chính, bản đặc biệt, dòng thường…",
      "timelineHead": "Tiến trình · Người phụ trách",
      "timelineHint": "Chương trình này được triển khai thế nào, và ai phụ trách từng bước.",
      "timelineStep": "Bước",
      "timelineStage": "Giai đoạn",
      "timelineWho": "Việc diễn ra",
      "timelinePh": "Giao người phụ trách, quyết định, ra mắt…",
      "timelineWhen": "Dự kiến",
      "timelineNote": "Người nhận",
      "stopWhere": "Tình trạng hiện tại",
      "stopThreshold": "Ngưỡng",
      "removeDoc": "Vẫn xóa",
      "removeDocWhy": "Dòng này lấy từ kế hoạch tổng thể. Chạy lại lệnh nhập sẽ đưa nó trở lại.",
      "keepIt": "Giữ lại",
      "specHead": "Hạng mục và nội dung",
      "specHint": "Những gì phải có trước khi ra mắt: từng hạng mục và nội dung của nó. Thêm một dòng cho bất kỳ điều gì khác.",
      "specItem": "Hạng mục",
      "specItemPh": "Khung, túi, giá…",
      "specA": "Dòng thường",
      "specB": "Bản đặc biệt",
      "photosHead": "Ảnh",
      "photosHint": "Các hình ảnh chương trình này đề cập đến. Chú thích cho biết mỗi ảnh đang chỉ vào điều gì.",
      "discoverHead": "Khách hàng tìm thấy sản phẩm bằng cách nào",
      "discoverHint": "Những gì diễn ra trước khi ra mắt, trong ngày ra mắt và sau đó.",
      "discoverPh": "Nội dung, seeding, thư mời…",
      "noLines": "Chưa có gì.",
      "collapseAll": "Thu gọn tất cả",
      "expandAll": "Mở tất cả",
      "fieldTitle": "Tiêu đề",
      "stopHead": "Điều kiện dừng (đề xuất)",
      "stopNone": "Chưa đặt điều kiện dừng nào.",
      "tripped": "Đã kích hoạt điều kiện dừng",
      "holding": "Đang giữ vững",
      "addLine": "Thêm dòng",
      "lineKind": "Loại",
      "persona": "Chân dung khách hàng",
      "channel": "Kênh",
      "inThisProgramme": "Trong chương trình này",
      "remarks": "Ghi chú",
      "select": "Chọn",
      "selectHint": "Đánh dấu một dòng, hoặc chọn nó trong ô Thêm bên dưới, để chọn. Thứ tự các dòng đã chọn chính là mức ưu tiên — kéo dòng hoặc dùng mũi tên để thay đổi.",
      "regionsCount": "Khu vực trong chương trình này",
      "specContent": "Nội dung",
      "timelineOwner": "Người phụ trách",
      "discoverItem": "Hạng mục",
      "discoverDetail": "Việc diễn ra",
      "trkTitle": "Theo dõi GTM",
      "trkSub": "Các chương trình đã duyệt và tiến độ của từng chương trình, theo từng bước trong Tiến trình · Người phụ trách. Đánh dấu một bước là Đang làm hoặc Xong khi công việc tiến triển; bước đã quá ngày dự kiến mà chưa xong sẽ được gắn cờ Quá hạn.",
      "trkApproved": "Chương trình đã duyệt",
      "trkStepsDone": "Bước đã xong",
      "trkOverdue": "Quá hạn",
      "trkOnlyOverdue": "Chỉ hiện chương trình có bước quá hạn",
      "trkSearch": "Tìm chương trình, bước hoặc người phụ trách…",
      "trkToday": "Hôm nay: {{day}}",
      "trkNone": "Chưa có chương trình nào được duyệt.",
      "trkApprovedBy": "Người duyệt",
      "trkStepsOf": "Đã xong {{done}} / {{total}} bước",
      "trkNoSteps": "Chưa có bước nào trong tiến trình",
      "trkOverdueN_one": "{{count}} quá hạn",
      "trkOverdueN_other": "{{count}} quá hạn",
      "trkNext": "Tiếp theo",
      "trkAllDone": "Mọi bước đã xong",
      "trkStatus": "Trạng thái",
      "trkDoneOn": "Ngày xong",
      "trkNoStepsHint": "Chương trình này chưa có bước nào trong tiến trình — hãy thêm trong mục Tiến trình · Người phụ trách của chương trình.",
      "st_not_started": "Chưa bắt đầu",
      "st_in_progress": "Đang làm",
      "st_done": "Xong",
      "trkProgress": "Tiến độ",
      "trkNextDue": "Hạn bước tiếp theo",
      "trkApprovedOn": "Ngày duyệt",
      "listNew": "Mục mới: sẽ được thêm vào danh sách để dùng cho lần sau.",
      "listAllIn": "Mọi mục trong danh sách đã có trong chương trình này. Hãy nhập mục mới.",
      "listDup": "Đã được chọn trong chương trình này.",
      "listHave": "Đã có trong chương trình này.",
      "listPick": "Chọn từ danh sách, hoặc nhập mục mới",
      "addPersona": "Thêm chân dung khách hàng",
      "addChannel": "Thêm kênh",
      "removeRow": "Xóa",
      "removeAsk": "Xóa \"{{name}}\"? Thao tác này không thể hoàn tác.",
      "add": "Thêm",
      "noteOnTable": "Ghi chú cho bảng này",
      "noteOnTableHint": "Những gì bảng trên không thể hiện được — một lưu ý, hoặc phần bảng bỏ qua.",
      "moveUp": "Di chuyển lên",
      "moveDown": "Di chuyển xuống",
      "targetAudience": "Chân dung khách hàng đã chọn — theo thứ tự ưu tiên",
      "notATarget": "Chưa chọn",
      "channelsInUse": "Kênh đã chọn — theo thứ tự ưu tiên",
      "channelsOut": "Chưa chọn",
      "chStatus_green": "Tình trạng kênh toàn công ty: tốt",
      "chStatus_amber": "Tình trạng kênh toàn công ty: cần theo dõi",
      "chStatus_red": "Tình trạng kênh toàn công ty: yếu",
      "notYet": "Chưa thể đánh giá",
      "unmeasured": "Theo dõi thủ công",
      "stopNote": "Người phụ trách chương trình ghi lại tình trạng hiện tại của từng điều kiện.",
      "question": "Câu hỏi {{n}}",
      "emptySection": "Chưa có câu trả lời.",
      "oneChange": "Đã thay đổi một mục",
      "nChanges": "Đã thay đổi {{count}} mục",
      "discard": "Bỏ thay đổi",
      "edit": "Sửa",
      "save": "Lưu",
      "decision": "Cần quyết định",
      "verify": "Cần xác minh",
      "addDecision": "Thêm quyết định",
      "addVerify": "Thêm mục cần xác minh",
      "todo": "Việc cần làm",
      "addTodo": "Thêm việc cần làm",
      "phaseFilter": "Giai đoạn ra mắt",
      "allPhases": "Mọi giai đoạn",
      "phaseHintOne": "Chỉ hiện {{phase}} — {{hidden}} trên {{all}} mục đang mở bị ẩn. Nhấn lại nút đó, hoặc Mọi giai đoạn, để hiện lại.",
      "phaseWhy_all": "Mọi thứ trong kế hoạch gắn với một thời điểm",
      "phaseWhy_before": "Q5 — những gì phải có trước khi bắt đầu công việc, và các quyết định còn đang mở",
      "phaseWhy_pre": "Q6 — TRƯỚC RA MẮT: trước ngày ra mắt",
      "phaseWhy_launch": "Q6 — RA MẮT: ngay trong ngày ra mắt",
      "phaseWhy_post": "Q6 — SAU RA MẮT: sau khi sản phẩm đã ra mắt",
      "workNone": "Chưa có mục nào.",
      "phase_before": "Trước khi bắt đầu",
      "phase_pre": "Trước ra mắt",
      "phase_launch": "Ra mắt",
      "phase_post": "Sau ra mắt",
      "noPhase": "Không có giai đoạn",
      "owner": "Người phụ trách",
      "noOwner": "Chưa có người phụ trách",
      "due": "Hạn",
      "noDue": "Không có ngày",
      "answer": "Trả lời",
      "answered": "Đã trả lời",
      "dropped": "Đã hủy",
      "open": "Đang mở",
      "remove": "Xóa",
      "regionsHead": "Khu vực",
      "region": "Khu vực",
      "person": "Người liên hệ",
      "replyStatus": "Phản hồi",
      "consent": "Chấp thuận",
      "commitQty": "Cam kết",
      "replyDue": "Hạn phản hồi",
      "anchor": "Dẫn đầu",
      "note": "Ghi chú",
      "addRegion": "Thêm khu vực",
      "metricsHead": "Cách đo lường thành công",
      "metric": "Chỉ số",
      "baseline": "Mốc cơ sở",
      "baselineWindow": "Khoảng thời gian",
      "live": "Kể từ",
      "takeBaseline": "Lấy mốc cơ sở",
      "retakeBaseline": "Lấy lại",
      "baselineTaken": "Đã lấy {{when}}",
      "baselineNotTaken": "Chưa lấy",
      "manualMetric": "Nhập tay",
      "baselineWhy": "Được cố định vào ngày lấy. Một đơn Shopify có thể được hoàn tiền nhiều tháng sau, nên một con số tự tính lại sẽ thay đổi ngay dưới phép so sánh mà nó làm mốc.",
      "units": "sản phẩm",
      "sourceDoc": "Tài liệu nguồn",
      "status": "Trạng thái",
      "launchTarget": "Ra mắt",
      "notSet": "Chưa đặt",
      "saved": "Đã lưu",
      "saveFailed": "Không lưu được"
    },
    "account": {
      "profile": "Hồ sơ",
      "listUsers": "Danh sách người dùng",
      "createUser": "Tạo người dùng",
      "accessRequests": "Yêu cầu truy cập",
      "rolesPermissions": "Vai trò & phân quyền",
      "portalInsights": "Thống kê Portal",
      "masterData": "Dữ liệu gốc",
      "activityLog": "Nhật ký hoạt động",
      "logout": "Đăng xuất"
    },
    "quote": {
      "label": "Câu nói hôm nay"
    },
    "doc": {
      "title": "Thư viện",
      "subtitle": "Tài liệu công ty — đọc ngay tại đây, hoặc tải về một bản có ghi số phiên bản. Bản mới nhất luôn nằm trên portal.",
      "folders": "Thư mục",
      "allDocs": "Tất cả tài liệu",
      "unfiled": "Chưa phân loại",
      "newFolder": "Thư mục mới",
      "newFolderIn": "Thư mục mới trong {{name}}",
      "folderName": "Tên thư mục",
      "renameFolder": "Đổi tên",
      "deleteFolder": "Xóa",
      "deleteFolderAsk": "Xóa thư mục \"{{name}}\"? Không có tài liệu nào bên trong bị xóa.",
      "folderField": "Thư mục",
      "folderNone": "Chưa phân loại",
      "folderSaved": "Đã lưu thư mục.",
      "search": "Tìm theo tiêu đề hoặc mã…",
      "upload": "Tải lên",
      "refresh": "Làm mới",
      "none": "Chưa có tài liệu nào được chia sẻ với bạn.",
      "noMatch": "Không có kết quả phù hợp.",
      "unread": "chưa đọc",
      "acknowledged": "đã đọc",
      "code": "Mã",
      "docTitle": "Tiêu đề",
      "version": "Phiên bản",
      "updated": "Cập nhật",
      "status": "Trạng thái",
      "changeNote": "Nội dung thay đổi",
      "uploadedBy": "Người tải lên",
      "author": "Tác giả",
      "authorNone": "— không ghi —",
      "versionAuthor": "Tác giả của phiên bản này",
      "authorSame": "— giống phiên bản trước —",
      "byAuthor": "của {{name}}",
      "authorHint": "Người viết tài liệu. Không phải là người tải lên.",
      "newDoc": "Tài liệu mới",
      "newVersion": "Tải lên phiên bản mới",
      "addingVersionTo": "Đang thêm phiên bản mới cho",
      "findDocPh": "Nhập mã hoặc tiêu đề — HB-0001, sổ tay…",
      "findDocNone": "Không có tài liệu nào khớp với \"{{q}}\".",
      "currentlyAt": "hiện là {{version}} — phiên bản mới sẽ được thêm vào, bản cũ vẫn đọc được trong lịch sử bên dưới",
      "kind": "Loại",
      "codeAuto": "Do Portal cấp",
      "summary": "Mô tả ngắn",
      "everyone": "Mọi người mở được thư viện đều có thể đọc",
      "narrowHint": "Nếu không, chỉ bạn và các quản trị viên thư viện khác đọc được cho đến khi bạn chia sẻ.",
      "file": "Tệp",
      "fileKinds": "HTML, PDF, PNG, JPEG, Word, PowerPoint và Excel (.xlsx) đều đọc được ngay tại đây. Tải về luôn là file gốc.",
      "noPreview": "Không trình duyệt nào hiển thị được loại tệp này trên trang. Tệp được lưu tại đây kèm phiên bản, và khi tải về sẽ mang tên lúc được tải lên.",
      "download": "Tải về",
      "imgBroken": "Không mở được ảnh này — tệp bị hỏng hoặc ở định dạng trình duyệt không đọc được. Tệp vẫn được lưu tại đây, và khi tải về sẽ mang tên lúc được tải lên.",
      "versionLabel": "Phiên bản",
      "versionAuto": "Để trống: Portal sẽ tiếp nối từ phiên bản trước",
      "versionFound": "Đọc từ chính tài liệu: {{version}}",
      "versionNotFound": "Không thấy phiên bản trên bìa tài liệu — để trống là v1.0, hoặc tự gõ vào.",
      "changeNoteLabel": "Nội dung thay đổi (một dòng)",
      "uploading": "Đang tải lên…",
      "allDocuments": "Tất cả tài liệu",
      "history": "Lịch sử phiên bản",
      "latest": "mới nhất",
      "view": "Mở",
      "readingOld": "Bạn đang đọc một phiên bản cũ —",
      "backToLatest": "quay lại bản mới nhất",
      "iHaveRead": "Tôi đã đọc tài liệu này",
      "recording": "Đang ghi nhận…",
      "youAcknowledged": "Bạn đã xác nhận đọc {{version}}",
      "noVersion": "Chưa có phiên bản nào được tải lên.",
      "readers": "Ai đã đọc",
      "readersCount": "{{opened}} trên {{notified}} đã mở · {{acked}} đã xác nhận",
      "notified": "Đã thông báo",
      "opened": "Đã mở",
      "confirmed": "Đã xác nhận",
      "nobody": "Chưa thông báo cho ai.",
      "share": "Chia sẻ",
      "shareLink": "Sao chép liên kết",
      "linkCopied": "Đã sao chép liên kết",
      "shareByEmail": "Gửi qua email",
      "emails": "Địa chỉ email",
      "emailsHint": "Phân cách nhiều địa chỉ bằng dấu phẩy hoặc khoảng trắng.",
      "groups": "Nhóm",
      "person": "Người nhận",
      "groupsNone": "Chọn nhóm…",
      "groupsClear": "Bỏ chọn",
      "addGroup": "Thêm nhóm",
      "addGroupName": "Tên nhóm",
      "addGroupEmail": "Địa chỉ email của nhóm",
      "addGroupSave": "Thêm vào danh sách",
      "addGroupHint": "Từ nay, mọi người chia sẻ tài liệu đều sẽ thấy nhóm này.",
      "groupAdded": "\"{{name}}\" đã có trong danh sách.",
      "groupRemoved": "Đã xóa \"{{name}}\" khỏi danh sách.",
      "removeGroupConfirm": "Xóa \"{{name}}\" khỏi danh sách nhóm của mọi người?",
      "sharers": "Ai được chia sẻ",
      "sharersIntro": "Bạn đã tải lên {{code}}, nên bạn có quyền gửi tài liệu này. Bất kỳ ai bạn chỉ định ở đây cũng có thể gửi.",
      "sharersIntroAdmin": "{{owner}} đã tải lên {{code}}. Bạn có thể gửi với tư cách quản trị viên, và những người được chỉ định ở đây cũng vậy.",
      "sharersNone": "Không còn ai khác. Chỉ {{owner}} và các quản trị viên mới được gửi tài liệu này.",
      "sharersAdd": "Thêm người",
      "sharersPick": "Chọn người…",
      "sharersFind": "Nhập tên hoặc địa chỉ…",
      "sharersNoMatch": "Không có ai phù hợp.",
      "sharersAddN": "Cấp quyền chia sẻ ({{count}})",
      "sharersSaved": "Đã lưu danh sách người được chia sẻ.",
      "sharersUploader": "Người tải lên",
      "cannotShare": "Chỉ {{owner}} và các quản trị viên mới được gửi tài liệu này.",
      "sendNote": "Ghi chú (không bắt buộc — mặc định là ghi chú thay đổi)",
      "send": "Gửi thông báo",
      "sending": "Đang gửi…",
      "sentTo": "Đã gửi đến {{count}} người nhận.",
      "remove": "Xóa",
      "edit": "Sửa",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "savedMsg": "Đã lưu.",
      "noteOfVersion": "Ghi chú thay đổi thuộc về {{version}}, phiên bản đang có trong danh sách lúc này.",
      "comments": "Bình luận",
      "noComments": "Chưa có bình luận. Câu hỏi đầu tiên thường cũng là câu hỏi mà người khác đang có.",
      "commentPlaceholder": "Hỏi về tài liệu này, hoặc trả lời ai đó…",
      "commentHint": "Mọi người mở được tài liệu này đều thấy bình luận của bạn. Nhấn Ctrl+Enter để đăng.",
      "post": "Đăng",
      "posting": "Đang đăng…",
      "commentGone": "Bình luận này đã bị xóa.",
      "deleteComment": "Xóa",
      "deleteCommentTitle": "Xóa bình luận này?",
      "deleteCommentBody": "Bình luận sẽ biến mất với mọi người. Vị trí của nó trong cuộc trao đổi vẫn được giữ lại, đánh dấu là đã xóa.",
      "removeTitle": "Xóa tài liệu này?",
      "removeConfirm": "Tài liệu sẽ rời khỏi danh sách của mọi người và liên kết sẽ không mở được nữa. Lịch sử đọc vẫn được giữ lại, và mã này không bao giờ được cấp cho tài liệu khác.",
      "removedMsg": "Đã xóa {{code}} khỏi thư viện.",
      "cancel": "Hủy",
      "removed": "Đã xóa."
    },
    "home": {
      "morning": "Chào buổi sáng",
      "afternoon": "Chào buổi chiều",
      "evening": "Chào buổi tối",
      "myWork": "Việc của tôi — {{role}}",
      "notLinkedToEmployee": "Tài khoản portal này chưa được liên kết với hồ sơ nhân viên, nên chưa thể gán công việc cho bạn. Hãy nhờ quản trị viên liên kết.",
      "notLinkedToSalesRep": "Tài khoản này chưa được liên kết với một Sales Rep, nên chưa thể gán dự án cho bạn. Hãy nhờ quản trị viên liên kết.",
      "targetLaunch": "Tháng ra mắt dự kiến",
      "ack": "Đã xem",
      "ackTitle": "Xác nhận bạn đã thấy lần từ chối này — nó sẽ không còn hiện trên thẻ này nữa",
      "lateThreshold": "Trễ sau (ngày)",
      "saved": "Đã lưu",
      "lateThresholdRange": "1-365",
      "save": "Lưu",
      "ackUndo": "Khôi phục",
      "seenCount": "Đã xem {{n}} — hiện",
      "viewAs": "Đang xem",
      "allOf": "Mọi người — {{role}}",
      "viewAll": "Mọi người",
      "repNoAccount": "chưa liên kết tài khoản",
      "openThisList": "Mở danh sách này trong Theo dõi mẫu",
      "andMore": "+{{n}} mục nữa",
      "workload": {
        "title": "Khối lượng công việc theo tuần",
        "sub": "Một lần chụp số liệu mỗi thứ Hai — mỗi PIC đang đảm nhận những gì vào sáng hôm đó",
        "rounds": "Vòng đang chạy",
        "projects": "Dự án đang chạy",
        "pic": "PIC",
        "change": "so với tuần trước",
        "total": "Tổng",
        "reconstructed": "Tuần này không được đếm vào sáng thứ Hai đó — số liệu được bổ sung sau.",
        "cellRounds": "Đang sản xuất {{prod}} · chờ kết quả {{pending}} · chờ nguyên liệu {{wait}}",
        "note": "Vòng đang chạy = Đang sản xuất + Chờ kết quả. Tuần có dấu * không được đếm vào thứ Hai đó — số liệu được bổ sung sau."
      },
      "noModules": "Tài khoản của bạn chưa được cấp module nào. Hãy liên hệ quản trị viên để được cấp quyền truy cập."
    },
    "tc": {
      "colNo": "STT",
      "colAction": "Thao tác",
      "stateActive": "Đang dùng",
      "stateInactive": "Ngừng dùng",
      "title": "Mã ticket",
      "subtitle": "Danh sách gốc của menu chọn mã ticket. Có {{n}} mã.",
      "readOnly": "— chỉ xem đối với vai trò của bạn.",
      "newCode": "Mã mới",
      "exportExcel": "Xuất Excel",
      "searchPh": "Tìm mã, tên, giai đoạn, bộ phận…",
      "showInactive": "Hiện mã ngừng dùng",
      "clearTools": "Xóa sắp xếp & bộ lọc",
      "countOf": "{{n}} trên {{total}}",
      "loading": "Đang tải…",
      "saving": "Đang lưu…",
      "btnEdit": "Sửa",
      "btnView": "Xem",
      "btnViewHint": "Xem mã này (chỉ đọc)",
      "btnClose": "Đóng",
      "formView": "Mã ticket {{code}}",
      "viewOnly": "Chỉ xem",
      "btnSave": "Lưu",
      "btnCancel": "Hủy",
      "formNew": "Mã ticket mới",
      "formEdit": "Sửa {{code}}",
      "fCode": "Mã",
      "fTeam": "Bộ phận",
      "fCase": "Trường hợp",
      "fCategory": "Danh mục",
      "fName": "Tên ticket",
      "fPhase": "Giai đoạn",
      "fAssignedTo": "Giao cho",
      "fGroupEmail": "Email nhóm",
      "fNote": "Ghi chú",
      "fActive": "Đang dùng — mã ngừng dùng vẫn được giữ trên các ticket đã dùng nó, nhưng không còn xuất hiện trong form tạo ticket mới",
      "phCase": "A / B / để trống",
      "phName": "Yêu cầu phát triển mẫu",
      "phTeamSearch": "Tìm bộ phận…",
      "everyCategory": "Mọi danh mục",
      "created": "Đã tạo {{code}}.",
      "saved": "Đã lưu {{code}}.",
      "nothingToExport": "Không có gì để xuất",
      "preparingExport": "Đang chuẩn bị xuất Excel…",
      "exported": "Đã xuất {{n}} mã",
      "exportFailed": "Xuất không thành công",
      "exportInclInactive": "Bao gồm mã ngừng dùng",
      "exportActiveOnly": "Chỉ mã đang dùng"
    },
    "pa": {
      "title": "Duyệt dự án",
      "subtitle": "Dự án mới ở trạng thái Đang chờ cho đến khi được duyệt tại đây. Không thể tạo ticket cho dự án chưa được duyệt.",
      "tabPending": "Đang chờ",
      "tabApproved": "Đã duyệt",
      "tabRejected": "Bị từ chối",
      "tabSettings": "Cài đặt",
      "loading": "Đang tải…",
      "saving": "Đang lưu…",
      "working": "Đang xử lý…",
      "countAll": "{{n}} dự án",
      "countOf": "{{n}} trên {{total}} dự án",
      "chartPick": "Biểu đồ: {{label}} · {{n}} dự án",
      "chartPickClear": "Hiện lại tất cả dự án",
      "allTeams": "Tất cả nhóm",
      "scopeHint": "Hiện dự án của nhóm nào",
      "clearTools": "Xóa sắp xếp & bộ lọc",
      "searchPh": "Tìm dự án, SKU, nhóm, chủ dự án…",
      "rejectedChip": "Bị từ chối · {{n}} SKU",
      "rejectedChipHint": "{{n}} SKU bị người duyệt trả lại — hãy sửa rồi nhấn Gửi lại.",
      "selected": "Đã chọn {{n}}",
      "decideSelected": "Quyết định các mục đã chọn",
      "clearSelection": "Bỏ chọn",
      "emptyFiltered": "Không có dự án nào khớp với tìm kiếm hoặc bộ lọc cột.",
      "emptyPending": "Không có gì đang chờ duyệt.",
      "emptyTab": "Không có dự án {{tab}}.",
      "colNo": "STT",
      "colProjectId": "ID nhóm dự án",
      "colProjectName": "Tên dự án",
      "colTeam": "Nhóm",
      "colManager": "Quản lý",
      "colOwner": "Chủ dự án",
      "colSalesRep": "NV kinh doanh",
      "colCategory": "Danh mục",
      "colSeason": "Mùa",
      "colPartner": "Đối tác / Dòng",
      "colTargetLaunch": "Ra mắt dự kiến",
      "colSkus": "SKU",
      "colRequestedBy": "Người yêu cầu",
      "colRequestedAt": "Thời điểm yêu cầu",
      "colManagerNote": "Ghi chú của quản lý",
      "colApprovedBy": "Người duyệt",
      "colApprovedAt": "Thời điểm duyệt",
      "colApprovedOpinion": "Ý kiến duyệt",
      "colRejectedBy": "Người từ chối",
      "colRejectedAt": "Thời điểm từ chối",
      "colReason": "Lý do",
      "colAction": "Thao tác",
      "btnView": "Xem",
      "btnApprove": "Duyệt",
      "btnEdit": "Sửa",
      "btnResubmit": "Gửi lại",
      "btnCancel": "Hủy",
      "btnClose": "Đóng",
      "btnSaveChanges": "Lưu thay đổi",
      "btnApproveN": "Duyệt {{n}}",
      "btnRejectN": "Từ chối {{n}}",
      "notYourTeam": "Dự án này thuộc nhóm khác — chỉ chủ dự án, quản lý của nhóm đó hoặc quản trị viên mới được thay đổi.",
      "dlgResubmitTitle": "Gửi lại {{id}}",
      "dlgDecisionOne": "Quyết định cho {{id}}",
      "dlgDecisionBulk": "Quyết định cho {{n}} dự án",
      "dlgStatus": "Trạng thái duyệt",
      "dlgAgree": "Đồng ý",
      "dlgReject": "Từ chối",
      "skuToggle": "Hiện {{n}} SKU trong dự án này",
      "skuNone": "Dự án này chưa có SKU nào.",
      "skuId": "SKU",
      "skuItem": "Mặt hàng",
      "skuCategory": "Danh mục",
      "skuQty": "Số lượng",
      "skuPrice": "Giá mục tiêu",
      "skuExf": "EXF",
      "skuPic": "Developer / Designer",
      "skuStatus": "Giai đoạn",
      "skuTba": "Chưa xác định",
      "skuState": "Tình trạng duyệt",
      "skuNote": "Ghi chú của người duyệt",
      "skuSt_unsent": "Chưa gửi",
      "skuSt_waiting": "Đang chờ",
      "skuSt_approved": "Đã duyệt",
      "skuSt_rejected": "Không duyệt",
      "skuPicked": "Đã chọn {{n}} SKU",
      "skuWithApprover": "Đã gửi — SKU này do người duyệt quyết định.",
      "skuNotYours": "Chưa gửi — nhóm yêu cầu sẽ gửi SKU này.",
      "skuDoneAlready": "Đã có quyết định.",
      "skuNoneYours": "Không có gì ở đây đang chờ bạn.",
      "submitPickFirst": "Đánh dấu các SKU cần gửi, hoặc đánh dấu dự án để gửi tất cả.",
      "skuNotRefused": "Không bị từ chối — không có gì để gửi lại.",
      "resubmitSome": "Gửi lại {{n}}",
      "dlgBackHead": "Thay đổi trên từng SKU ({{n}} SKU gửi lại)",
      "dlgBackWas": "Không duyệt",
      "dlgBackWhy": "Những gì đã thay đổi trên SKU này",
      "skuMgrNote": "Ghi chú của quản lý",
      "submitSome": "Gửi {{n}}",
      "submitSomeHint": "Chỉ gửi {{n}} SKU được đánh dấu bên dưới; các SKU còn lại giữ nguyên.",
      "approveSome": "Quyết định {{n}}",
      "approveSomeHint": "Chỉ quyết định {{n}} SKU được đánh dấu bên dưới.",
      "dlgSkuHead": "Quyết định từng SKU ({{n}} đang chờ)",
      "dlgAllApprove": "Duyệt tất cả",
      "dlgAllReject": "Từ chối tất cả",
      "dlgSkuWhy": "Lý do SKU này không được duyệt",
      "dlgSkuDefault": "Mọi SKU ở đây đều được duyệt trừ khi bạn đánh dấu ✕.",
      "dlgSkuYes": "Duyệt",
      "dlgSkuNo": "Không duyệt",
      "dlgSkuUndo": "Đưa SKU này về trạng thái được duyệt",
      "dlgWasApproved": "đã duyệt trước đó",
      "dlgWasRejected": "đã bị từ chối trước đó",
      "btnApproveSkus": "Duyệt {{n}} SKU",
      "btnRejectSkus": "Từ chối {{n}} SKU",
      "btnPartial": "Duyệt {{yes}}, từ chối {{no}}",
      "stPartial": "Duyệt một phần",
      "dlgUnchangedTitle": "Chưa có gì được sửa kể từ lần bị từ chối.",
      "dlgUnchangedBody": "Hãy sửa theo yêu cầu của người duyệt (nút Sửa trên dòng), hoặc giải thích bên dưới vì sao nên duyệt như hiện tại — cần có ghi chú để gửi lại mà không thay đổi.",
      "dlgManagerOpinion": "Ý kiến của quản lý",
      "dlgApproverOpinion": "Ý kiến của người duyệt",
      "dlgPhReject": "Vì sao dự án này không được duyệt? Nhóm sẽ thấy nội dung này.",
      "dlgPhResubmitRequired": "Bắt buộc — vì sao nên duyệt mà không cần thay đổi?",
      "dlgPhResubmit": "Những gì đã thay đổi kể từ lần bị từ chối? (không bắt buộc)",
      "dlgPhOptional": "Nhập nội dung (không bắt buộc)",
      "secProject": "Thông tin dự án",
      "secSku": "Thông tin SKU",
      "fTeam": "Nhóm",
      "fOwner": "Chủ dự án (Sales OP)",
      "fCategory": "Danh mục",
      "fSeason": "Mùa",
      "fPartner": "Đối tác / Dòng",
      "fKeyword": "Từ khóa",
      "fTargetLaunch": "Ra mắt dự kiến (tháng)",
      "fCase": "Trường hợp",
      "fEntity": "Pháp nhân",
      "selectTeam": "Chọn nhóm…",
      "selectOwner": "Chọn chủ dự án…",
      "pickTeamFirst": "Chọn nhóm trước",
      "noMember": "Nhóm này chưa có thành viên — hãy thiết lập trong Danh sách người dùng",
      "addSku": "+ Thêm SKU",
      "noSkuYet": "Chưa có SKU — không sao. Có thể thêm SKU bất cứ lúc nào.",
      "skuSaveHint": "SKU mới được tạo khi bạn lưu. Việc xóa một SKU đã có diễn ra ngay lập tức, không đợi đến khi lưu.",
      "fillRequired": "Hãy điền các trường bắt buộc trước:",
      "couldNotSave": "Không lưu được:",
      "rejectedBy": "Bị {{who}} từ chối:",
      "managerNoteLabel": "Ghi chú của quản lý:",
      "submit": "Gửi",
      "submitSelected": "Gửi các mục đã chọn cho người duyệt",
      "readyToSubmit": "{{n}} trên {{total}} sẵn sàng để gửi",
      "nothingToSubmit": "Không có mục nào được đánh dấu có thể gửi — đã gửi rồi, hoặc thuộc nhóm khác.",
      "sent": "Đã gửi",
      "submittedOn": "Đã gửi cho người duyệt {{when}}",
      "remind": "Nhắc",
      "remindHint": "Đã gửi {{when}} · {{n}} SKU vẫn đang chờ người duyệt. Gửi lời nhắc.",
      "remindSent": "Đã gửi lời nhắc đến {{to}} — {{n}} SKU vẫn đang chờ",
      "lockedSubmitted": "Đã gửi duyệt — người duyệt đang giữ dự án này, và mail người duyệt nhận được vẫn hiển thị các giá trị như lúc gửi.",
      "drop": "Xóa",
      "dropTitle": "Xóa dự án này",
      "dropSubmitted": "Đã gửi duyệt — không thể xóa.",
      "dropHead": "Xóa {{id}}?",
      "dropChecking": "Đang kiểm tra những gì thuộc dự án này…",
      "dropWarnOne": "1 SKU sẽ bị xóa. Các vòng mẫu được giữ lại — chúng vẫn nằm trong Theo dõi mẫu mà không có dự án. Không thể hoàn tác.",
      "dropWarnMany": "{{n}} SKU sẽ bị xóa. Các vòng mẫu được giữ lại — chúng vẫn nằm trong Theo dõi mẫu mà không có dự án. Không thể hoàn tác.",
      "dropTicketsOne": "1 ticket của dự án này sẽ bị hủy, và bộ phận nhận sẽ được thông báo:",
      "dropTicketsMany": "{{n}} ticket của dự án này sẽ bị hủy, và bộ phận nhận sẽ được thông báo:",
      "dropEmailed": "đã gửi email",
      "dropReason": "Vì sao hủy? (sẽ có trong mail)",
      "dropConfirm": "Xóa dự án",
      "dropBusy": "Đang xóa…",
      "approverNoteLabel": "Ghi chú của người duyệt:",
      "setTitle": "Email duyệt",
      "setNote": "Nơi nhận mail “dự án cần duyệt”. Thay đổi tại đây — không cần triển khai lại.",
      "setApprover": "Người duyệt (To)",
      "setCc": "CC (phân cách bằng dấu phẩy)",
      "setGate": "Bật cổng duyệt (dự án mới bắt đầu ở trạng thái Đang chờ và ticket bị chặn)",
      "setSave": "Lưu cài đặt duyệt",
      "setSaved": "Đã lưu cài đặt duyệt."
    },
    "tour": {
      "title": "Hướng dẫn màn hình",
      "ciTabsT": "Mỗi biểu mẫu một tab",
      "ciTabsB": "Biểu mẫu 1 là Báo cáo tiền mặt hằng tuần, Biểu mẫu 2 là Kế hoạch tiền mặt 13 tuần, Biểu mẫu 3 là Đối chiếu cuối tháng. Chọn biểu mẫu bạn đang nộp.",
      "ciPeriodT": "Pháp nhân của bạn và kỳ báo cáo",
      "ciPeriodB": "Pháp nhân đi theo bạn: lấy từ dòng Người lập của bạn trong danh sách người dùng Báo cáo tiền mặt, và menu chọn chỉ xuất hiện nếu bạn lập báo cáo cho nhiều hơn một pháp nhân. Các mũi tên chuyển sang tuần (hoặc tháng) trước hoặc sau; dòng bên cạnh cho biết hạn nộp báo cáo.",
      "ciStepsT": "Báo cáo đang ở bước nào",
      "ciStepsB": "Người lập → Người duyệt. Một bước sẽ sáng lên khi đã hoàn thành; khi Người duyệt đồng ý, số liệu của báo cáo sẽ hiện trong Báo cáo tiền mặt.",
      "ciTemplateT": "Tải biểu mẫu",
      "ciTemplateB": "Biểu mẫu Excel cho pháp nhân và kỳ này, đã điền sẵn các tài khoản. Điền vào rồi nhập lên — số liệu không được gõ trực tiếp trên Portal.",
      "ciImportT": "Nhập tệp",
      "ciImportB": "Nhập biểu mẫu đã điền. Tệp trở thành một phiên bản: Kiểm tra dữ liệu được chạy và số liệu hiện ở bên dưới. Tệp sai có thể hủy và nhập lại tệp đã sửa.",
      "ciFormT": "Sửa tại đây",
      "ciFormB": "Sau khi nhập biểu mẫu, số liệu sẽ mở ở đây. Sửa một số liệu rồi Lưu: nó trở thành phiên bản tiếp theo, qua cùng bước Kiểm tra dữ liệu — không cần nhập lại tệp.",
      "ciCheckT": "Kiểm tra dữ liệu",
      "ciCheckB": "Mọi phiên bản đều được kiểm tra. Lỗi phải được sửa trước khi gửi báo cáo; cảnh báo được gửi kèm để Người duyệt đọc.",
      "ciSendT": "Gửi cho Người duyệt",
      "ciSendB": "Thêm ghi chú nếu Người duyệt cần biết điều gì, rồi gửi. Báo cáo đã gửi không thể thay đổi; nếu bị trả lại, bạn sửa tại đây rồi gửi lại.",
      "ciFilesT": "Sao kê ngân hàng và ảnh chụp màn hình",
      "ciFilesB": "Đính kèm sao kê hoặc ảnh chụp số dư của từng tài khoản. Mọi người xem xét hoặc duyệt báo cáo đều thấy các tệp này.",
      "ciHistoryT": "Lịch sử và bình luận",
      "ciHistoryB": "Mọi lần nhập tệp, nhập liệu, gửi và quyết định đều được liệt kê ở đây kèm người thực hiện và thời điểm. Viết bình luận để hỏi hoặc trả lời câu hỏi về báo cáo này.",
      "ciTestAsT": "Thử với vai trò",
      "ciTestAsB": "Chỉ dùng để thử nghiệm: trong lúc mail Báo cáo tiền mặt đang bị giữ, hãy đóng vai từng vai trò để thử toàn bộ quy trình. Mỗi bước thực hiện đều được ghi là \"test as …\".",
      "cqTabsT": "Ba tab",
      "cqTabsB": "Chờ bạn xử lý chứa các báo cáo đang chờ bạn xem xét, cũ nhất xếp trước. Đang làm chứa các báo cáo đang ở chỗ Người duyệt khác, và các báo cáo bị trả lại cho Người lập kèm lý do. Đã đồng ý chứa các báo cáo Người duyệt đã đồng ý — đó là những báo cáo hiện trong Báo cáo tiền mặt.",
      "cqListT": "Mọi báo cáo đã gửi, trong một danh sách",
      "cqListB": "Báo cáo tiền mặt hằng tuần, Kế hoạch tiền mặt 13 tuần và Đối chiếu cuối tháng, của mọi pháp nhân và mọi kỳ. Mỗi tiêu đề cột đều sắp xếp và lọc được như Excel. Nhấn vào một dòng để mở báo cáo đó bên dưới; nhấn lần nữa để đóng.",
      "cqDecideT": "Quyết định của bạn",
      "cqDecideB": "Xem xét & đồng ý là bước cuối cùng: khi bạn đồng ý, số liệu của báo cáo sẽ hiện trong Báo cáo tiền mặt. Nút này mở một hộp thoại để bạn đồng ý, hoặc trả báo cáo lại cho Người lập kèm lý do. Báo cáo đã đồng ý có thể được mở lại tại đây để sửa, kèm lý do. Báo cáo bị trả lại sẽ chờ trong Đang làm cho đến khi được gửi lại.",
      "cqCheckT": "Kiểm tra dữ liệu",
      "cqCheckB": "Lỗi sẽ khiến Người lập không gửi được, nên báo cáo đã gửi không có lỗi nào. Cảnh báo được gửi kèm để bạn đọc trước khi quyết định.",
      "cqBodyT": "Những gì đã được nhập",
      "cqBodyB": "Số liệu đúng như Người lập đã nhập từ biểu mẫu — Mục 1 đến 6 của báo cáo tuần, 13 tuần của kế hoạch, hoặc phần đối chiếu của từng tài khoản. Không thể thay đổi gì ở đây; số liệu sai thì trả lại.",
      "cqFilesT": "Sao kê ngân hàng và ảnh chụp màn hình",
      "cqFilesB": "Những gì Người lập đã đính kèm cho từng tài khoản. Mở ra để đối chiếu số liệu với ngân hàng.",
      "cqHistoryT": "Lịch sử và bình luận",
      "cqHistoryB": "Ai đã nhập, gửi và quyết định, vào lúc nào. Viết bình luận để hỏi Người lập mà không cần trả báo cáo lại.",
      "crNewT": "Tạo yêu cầu",
      "crNewB": "Hàng gửi cho ai, hãng chuyển phát và tài khoản Helinox chịu phí, điểm đi và điểm đến, trọng lượng, chi phí ước tính của bạn và điều kiện giao hàng. Phần kiểm tra chi phí bên cạnh biểu mẫu so sánh ước tính của bạn với giá hợp đồng FedEx của HINC ngay khi bạn nhập. Lưu nháp giữ lại biểu mẫu đang điền dở; Gửi duyệt gửi yêu cầu đến người duyệt.",
      "crListT": "Yêu cầu của bạn",
      "crListB": "Mỗi yêu cầu một dòng. Năm cột đầu được cố định trong khi các cột còn lại cuộn ngang. Nhấn vào một dòng để đọc yêu cầu dưới dạng biểu mẫu như lúc gửi.",
      "crCheckT": "Kiểm tra chi phí",
      "crCheckB": "Ước tính của bạn so với giá hợp đồng: Hợp lý (cao hơn tối đa 15%), Cần xem xét (tối đa 35%) hoặc Có thể cao. Tuyến hoặc hãng chuyển phát không nằm trong hợp đồng sẽ được kiểm tra thủ công.",
      "crStatusT": "Tình trạng",
      "crStatusB": "Nháp (chưa gửi), Đang chờ (người duyệt đang xử lý), Đã duyệt, Bị từ chối hoặc Đã rút lại.",
      "crNoteT": "Ghi chú của quản lý",
      "crNoteB": "Nội dung người duyệt ghi kèm quyết định. Bấm vào để đọc toàn bộ.",
      "crActT": "Bạn có thể làm gì",
      "crActB": "Xem · Sửa (bản nháp, yêu cầu bị từ chối hoặc đã rút lại, hoặc yêu cầu còn đang chờ — khi lưu, người duyệt sẽ được báo những gì đã thay đổi) · Gửi bản nháp · Nhân bản thành yêu cầu mới · Xóa mọi yêu cầu chưa được duyệt. Nút bị mờ sẽ cho biết lý do khi rê chuột lên.",
      "crqTabsT": "Ba tab",
      "crqTabsB": "Chờ quyết định là danh sách việc của bạn; Đã duyệt và Bị từ chối lưu lại những gì đã được quyết định.",
      "crqListT": "Các yêu cầu",
      "crqListB": "Ai yêu cầu, từ pháp nhân nào, tuyến đường và hãng chuyển phát. Năm cột đầu luôn cố định. Bấm vào một dòng để xem yêu cầu cùng phần kiểm tra chi phí.",
      "crqNoteT": "Ghi chú của quản lý",
      "crqNoteB": "Nội dung bạn ghi kèm quyết định; người yêu cầu cũng thấy nội dung này trong danh sách của họ.",
      "crqActT": "Xem · Sửa · Duyệt",
      "crqActB": "Sửa dùng để chỉnh một yêu cầu đang chờ — yêu cầu vẫn ở trạng thái chờ và người yêu cầu nhận email về những gì đã thay đổi. Duyệt mở hộp quyết định; Từ chối nằm bên trong và cần ghi lý do.",
      "crqRatesT": "Biểu giá",
      "crqRatesB": "Tệp biểu giá hợp đồng FedEx mà phần kiểm tra chi phí sử dụng, chỗ tải tệp lên, phụ phí nhiên liệu và hai ngưỡng.",
      "crTabsT": "Ba báo cáo",
      "crTabsB": "Báo cáo tiền mặt hằng tuần, Kế hoạch tiền mặt 13 tuần và Đối chiếu cuối tháng. Ở đây chỉ hiển thị số liệu đã được Người duyệt đồng ý; báo cáo còn ở chỗ Người lập hoặc Người duyệt chỉ hiện một dòng cho biết đang ở bước nào.",
      "crPeriodT": "Kỳ báo cáo",
      "crPeriodB": "Chọn một tuần (hoặc một tháng ở tab Cuối tháng); các mũi tên chuyển sang kỳ trước hoặc kỳ sau. Dòng bên cạnh cho biết hạn nộp báo cáo.",
      "crChartsT": "Biểu đồ",
      "crChartsWB": "Tiền mặt theo pháp nhân, chia thành Khả dụng, Bị hạn chế và Tiền gửi có kỳ hạn, cùng tiền mặt của GROUP trong 12 tuần gần nhất. Rê chuột lên một cột hoặc một điểm để xem số liệu.",
      "crChartsPB": "Dòng tiền vào theo kế hoạch hướng lên, dòng tiền ra theo kế hoạch hướng xuống; đường nét đứt là số dư cuối kỳ theo kế hoạch, đường liền là số dư cuối kỳ thực tế từ Báo cáo tiền mặt hằng tuần.",
      "crChartsMB": "Tiền mặt cuối tháng theo pháp nhân, cùng số tài khoản đã khớp và số tài khoản còn chênh lệch.",
      "crWeekT": "GROUP, rồi đến từng pháp nhân",
      "crWeekB": "Dòng đầu tiên là GROUP; tiếp theo là từng pháp nhân, tính bằng SGD. Bấm vào dòng của một pháp nhân để mở dòng giao dịch liên công ty và các tài khoản của pháp nhân đó — khi đó các cột Ngân hàng, Số tài khoản, Loại tài khoản và Hạn chế / Tiền gửi có kỳ hạn sẽ xuất hiện, và mỗi tài khoản hiển thị theo loại tiền riêng của nó, đúng như khi tải lên.",
      "crExpandT": "Mở hoặc thu gọn mọi pháp nhân",
      "crExpandB": "Mở tất cả sẽ mở mọi pháp nhân ra các tài khoản ở đây và Top 3 bên dưới; Thu gọn tất cả sẽ thu chúng lại.",
      "crTopT": "Top 3",
      "crTopB": "Ba khoản chi chính trong tuần này và ba khoản phải trả tuần sau của từng pháp nhân, tính bằng SGD. Pháp nhân chưa tải lên cũng được liệt kê để không bỏ sót ai.",
      "crFiltersT": "Hai bộ lọc",
      "crFiltersB": "Pháp nhân: GROUP, một pháp nhân, hoặc tick chọn nhiều pháp nhân cùng lúc (số liệu được cộng dồn). Năm: năm của các tuần cần hiển thị. Biểu đồ và bảng bên dưới đều theo cả hai bộ lọc.",
      "crPlanTableT": "Mọi tuần trong năm",
      "crPlanTableB": "Mỗi tuần một dòng. Tuần đã qua lấy số từ kế hoạch nộp cho tuần đó, tuần sắp tới lấy từ kế hoạch mới nhất; cột Từ kế hoạch ghi rõ là kế hoạch nào. Số thực tế lấy từ Báo cáo tiền mặt hằng tuần sau khi báo cáo được đồng ý. Tuần đang xem được tô sáng, và mọi tiêu đề cột đều sắp xếp, lọc được như Excel.",
      "crPlanListT": "Ai đã lập kế hoạch tuần này",
      "crPlanListB": "Kế hoạch của từng pháp nhân cho tuần đang xem: số dư cuối kỳ theo kế hoạch ở tuần 13 và tình trạng của kế hoạch.",
      "crMonthT": "Đối chiếu",
      "crMonthB": "Dòng của mỗi pháp nhân ghi số dư cuối tháng bằng SGD cùng người lập và người duyệt; tiếp theo là các tài khoản, theo loại tiền riêng của từng tài khoản. Mục Đối chiếu phải bằng 0 ở mọi tài khoản.",
      "crWaitingT": "Đang chờ bạn",
      "crWaitingB": "Báo cáo mà bước tiếp theo thuộc về bạn sẽ mang nhãn này. Bấm vào để mở báo cáo trong màn hình Duyệt, nơi bạn đồng ý hoặc trả lại.",
      "step": "Bước {{n}}/{{of}}",
      "next": "Tiếp",
      "back": "Quay lại",
      "done": "Xong",
      "skip": "Bỏ qua",
      "stCreateT": "Tạo mẫu mới tại đây",
      "stCreateB": "Chọn SKU dự án mà mẫu này dành cho. Chỉ những SKU chưa có mẫu mới được liệt kê, vì mỗi SKU chỉ có đúng một mẫu. Bạn không cần vào Theo dõi dự án để làm việc này nữa.",
      "stRoundT": "Thêm vòng cho mẫu đã có",
      "stRoundB": "P1, P2, P3, v.v. Trước tiên, nhập Sample ID, Base ID hoặc tên style để tìm mẫu — các mục còn lại sẽ mở ra sau khi bạn chọn.",
      "stTrialT": "Mẫu không thuộc dự án nào",
      "stTrialB": "Trường hợp ngoại lệ, dành cho công việc chưa trở thành SKU dự án. Mẫu này nhận số TSMP thay vì SMP.",
      "stCardsT": "Các thẻ chính là bộ lọc",
      "stCardsB": "Bấm vào một thẻ, bảng bên dưới chỉ hiện các mục đó. Bấm lại để bỏ lọc. Hàng trên đếm số mẫu, hàng dưới đếm số vòng.",
      "stFiltersT": "Lọc thêm",
      "stFiltersB": "Theo developer, designer hoặc địa điểm R&D, hoặc nhập vào ô tìm kiếm. Xóa lọc sẽ đưa mọi thứ về như cũ, kể cả bộ lọc trên tiêu đề cột.",
      "stRowT": "Mỗi mẫu mở ra các vòng của nó",
      "stRowB": "Bấm mũi tên ở một dòng bất kỳ để xem mọi vòng của Base ID đó. Mở tất cả sẽ mở toàn bộ cùng lúc.",
      "stExportT": "Xuất ra Excel",
      "stExportB": "Xuất đúng những gì bảng đang hiển thị, kể cả các bộ lọc."
    },
    "st": {
      "tabAll": "Tất cả mẫu",
      "tabSummary": "Tổng hợp theo mẫu",
      "tagTrial": "Thử nghiệm",
      "pillProject": "Mẫu dự án (SMP)",
      "pillTrial": "Mẫu thử nghiệm (TSMP)",
      "pillBoth": "Cả hai",
      "pillCtrlHint": "Ctrl / ⌘ + bấm để hiện loại này cùng với loại kia",
      "hintTrial": "Mẫu làm một lần, không thuộc SKU dự án nào. Base ID của các mẫu này là TSMP, không phải SMP.",
      "titleTracker": "Theo dõi mẫu",
      "titleSummary": "Tổng hợp theo mẫu",
      "hintTracker": "Bấm vào thẻ để cập nhật bảng - bấm vào dòng mẫu để mở các vòng",
      "hintSummary": "Mỗi Base ID / sản phẩm một dòng, kèm lịch mới nhất và trạng thái vòng",
      "groupSample": "Mẫu / Base ID",
      "groupRounds": "Vòng / Quy trình",
      "totalSamples": "Tổng số mẫu",
      "totalSamplesSub": "Bản ghi mẫu ở mọi trạng thái",
      "inProgressSamples": "Mẫu đang làm",
      "confirmedSamples": "Mẫu đã xác nhận",
      "reworkSamples": "Mẫu làm lại",
      "droppedSamples": "Mẫu đã hủy",
      "onHoldSamples": "Mẫu tạm dừng",
      "totalRounds": "Tổng số vòng",
      "totalRoundsSub": "Bản ghi vòng ở mọi trạng thái",
      "inProgressRounds": "Vòng đang làm",
      "confirmedRounds": "Vòng đã xác nhận",
      "reworkRounds": "Vòng làm lại",
      "droppedRounds": "Vòng đã hủy",
      "onHoldRounds": "Vòng tạm dừng",
      "pendingOutcome": "Chờ kết quả",
      "pendingOutcomeSub": "Đã có ngày hoàn thành, chưa có kết quả",
      "rmWaiting": "Chờ RM",
      "rmWaitingSub": "Nguyên liệu chưa sẵn sàng",
      "inProduction": "Đang sản xuất",
      "inProductionSub": "RM đã sẵn sàng, chưa xong",
      "allRounds": "Tất cả vòng",
      "allDevelopers": "Tất cả Developer",
      "allDesigners": "Tất cả Designer",
      "allLocations": "Tất cả địa điểm R&D",
      "allStatus": "Tất cả trạng thái",
      "searchPlaceholder": "Tìm ID hoặc mặt hàng...",
      "clear": "Xóa lọc",
      "newRound": "+ Vòng mới",
      "csButton": "+ Tạo mẫu",
      "tourButton": "Hướng dẫn",
      "tourReopen": "Hướng dẫn cách dùng màn hình này",
      "csTitle": "Tạo mẫu",
      "csIntro": "Chọn SKU dự án mà mẫu này dành cho. Chỉ liệt kê các SKU chưa có mẫu — mỗi SKU chỉ có đúng một mẫu.",
      "csSearch": "Tìm dự án, mã SKU hoặc style…",
      "csCount": "{{skus}} SKU trong {{projects}} dự án",
      "csNone": "Mọi SKU đang hoạt động đều đã có mẫu.",
      "csNoMatch": "Không có mục nào khớp.",
      "csMore": "và {{n}} mục khác — thu hẹp tìm kiếm để xem",
      "trButton": "+ Mẫu thử nghiệm (ngoài dự án)",
      "trTitleNew": "Mẫu thử nghiệm mới",
      "trAddNewSample": "Thêm mẫu mới",
      "trTitle": "Mẫu thử nghiệm — không thuộc dự án",
      "trSub": "Dành cho mẫu làm một lần, không thuộc SKU dự án nào. Base ID được cấp theo dạng TSMP, không phải SMP.",
      "trStylePh": "Nhập tên style / mặt hàng",
      "trStyleHint": "Nhập ở trên — mẫu thử nghiệm không có SKU dự án để lấy tên",
      "expandAll": "Mở tất cả",
      "collapseAll": "Thu gọn tất cả",
      "exportExcel": "Xuất Excel",
      "backToBase": "Quay lại chế độ xem Base ID",
      "colBaseId": "Base ID",
      "colStyleItem": "Style / Mặt hàng",
      "colRound": "Vòng",
      "colSeason": "Mùa",
      "colLocation": "Địa điểm R&D",
      "colDeveloper": "Developer",
      "colDesigner": "Designer",
      "colProjectId": "ID SKU dự án",
      "colRequestDate": "Ngày yêu cầu",
      "colDevelopmentDue": "Hạn phát triển",
      "colRmReady": "RM sẵn sàng",
      "colRoundDue": "Hạn vòng",
      "colSampleFinish": "Ngày hoàn thành mẫu",
      "colReceived": "Ngày nhận",
      "colComment": "Ngày nhận xét",
      "colQty": "SL",
      "colRounds": "Số vòng",
      "colStatus": "Trạng thái",
      "colDday": "D-day",
      "colDdayHint": "D-DAY = hôm nay − Hạn phát triển. Giá trị dương nghĩa là mẫu đã trễ hạn chừng ấy ngày; giá trị âm nghĩa là còn chừng ấy ngày.",
      "colDaysWaiting": "Số ngày chờ",
      "goToProject": "Mở SKU này trong Theo dõi dự án",
      "colRemarks": "Ghi chú",
      "colActions": "Thao tác",
      "colRework": "Làm lại",
      "ptNo": "STT",
      "ptId": "Mã",
      "ptProjectItem": "Dự án / Mặt hàng",
      "ptNotYours": "Chỉ chủ dự án, trưởng nhóm hoặc quản trị viên mới được thay đổi dự án này.",
      "ptNotYourSku": "Chỉ developer được giao SKU này, chủ dự án hoặc trưởng nhóm mới được thay đổi SKU.",
      "ptDeleteNotYours": "Chỉ chủ dự án, trưởng nhóm hoặc quản trị viên mới được xóa SKU.",
      "ptCompletedLocked": "SKU này đã Hoàn thành và bộ phận Sản xuất đã được thông báo — không thể sửa hoặc xóa nữa.",
      "ptTicketNotYours": "Chỉ chủ dự án, trưởng nhóm hoặc quản trị viên mới được tạo ticket cho dự án này.",
      "ptTeam": "Nhóm",
      "ptOwner": "Chủ dự án",
      "ptCategory": "Danh mục",
      "ptCase": "Trường hợp",
      "ptEntity": "Pháp nhân",
      "ptItemCategory": "Loại mặt hàng",
      "ptFrameColor": "Màu khung",
      "ptQty": "SL",
      "ptAssigned": "Người được giao",
      "ptAllocation": "Phân bổ",
      "ptStatus": "Trạng thái",
      "ptSalesRep": "NV kinh doanh",
      "ptWhere": "Trạng thái dự án",
      "ptWhereComplete": "Hoàn thành",
      "ptWhereDropped": "Đã hủy",
      "ptWhereActive": "Đang chạy",
      "ptAiHead": "Tóm tắt của Claude",
      "ptAiWriting": "Đang tóm tắt…",
      "ptStart": "Ngày bắt đầu",
      "ptExfDate": "Ngày EXF",
      "ptTargetPrice": "Giá mục tiêu (USD)",
      "ptLaunchDate": "Ngày ra mắt",
      "ptWeeksLeft": "Số tuần còn lại",
      "ptProgress": "Tiến độ",
      "ptRemark": "Ghi chú",
      "ptSampleId": "Mã mẫu",
      "ptAction": "Thao tác",
      "ptTitle": "Theo dõi dự án",
      "ptHint": "Quản lý và theo dõi mọi dự án phát triển",
      "ptGroups": "Nhóm dự án",
      "ptProjectComplete": "Dự án hoàn thành",
      "ptProjectCompleteSub": "mọi SKU đều Hoàn thành (hoặc Đã hủy)",
      "ptProjectDropped": "Dự án đã hủy",
      "ptProjectDroppedSub": "mọi SKU đều Đã hủy",
      "ptProjectActive": "Dự án đang chạy",
      "ptProjectActiveSub": "vẫn còn SKU chưa xong",
      "ptSkus": "SKU dự án",
      "ptComplete": "SKU hoàn thành",
      "ptDrop": "SKU đã hủy",
      "ptActive": "SKU đang chạy",
      "ptPriority": "SKU ưu tiên",
      "ptViewProject": "Xem dự án này (chỉ đọc)",
      "ptViewSku": "Xem SKU này (chỉ đọc)",
      "ptViewTag": "Chỉ xem",
      "rmTitleView": "Vòng mẫu",
      "viewRound": "Xem vòng này (chỉ đọc)",
      "viewBase": "Xem Base ID này (chỉ đọc)",
      "tkView": "Xem ticket này (chỉ đọc)",
      "tkTitleView": "Phiếu",
      "viewClose": "Đóng",
      "ptViewHint": "Chỉ đọc — không thể thay đổi hay lưu gì ở đây.",
      "ptViewClose": "Đóng",
      "ptOnTrack": "SKU đúng tiến độ",
      "ptConcern": "SKU cần lưu ý",
      "ptDelayed": "SKU trễ",
      "ptOnHold": "SKU tạm dừng",
      "ptShipFinished": "SKU đã giao hàng",
      "ptAllTeams": "Tất cả nhóm",
      "ptAllOwners": "Tất cả chủ dự án",
      "ptByMember": "Theo thành viên",
      "ptByMemberTitle": "Khối lượng công việc theo chủ dự án",
      "ptByMemberHint": "Bấm vào một dòng để lọc tracker theo chủ dự án đó. Số liệu thay đổi theo các bộ lọc ở trên.",
      "ptOverdueExf": "EXF quá hạn",
      "ptAllCategories": "Tất cả danh mục",
      "ptAllAssignees": "Tất cả người được giao",
      "ptAllAllocation": "Tất cả phân bổ",
      "ptSearch": "Tìm dự án / mặt hàng...",
      "ptExpandAll": "Mở tất cả",
      "ptCollapseAll": "Thu gọn tất cả",
      "ptColumns": "Cột",
      "ptReport": "Báo cáo",
      "ptNewProject": "+ Dự án mới",
      "ptExpand": "Mở rộng",
      "ptCollapse": "Thu gọn",
      "ptNoProjects": "Không tìm thấy dự án nào.",
      "stgLdSoff": "L/D S/OFF",
      "stgProto": "Proto",
      "stgCounter": "Counter",
      "stgCosting": "Tính giá",
      "stgHandOffMeeting": "Họp bàn giao",
      "stgPpsPpm": "PPS/PPM",
      "stgProduction": "Sản xuất",
      "stgFinalInspection": "Kiểm tra cuối",
      "stgExfShipment": "Trạng thái giao hàng",
      "stgPayment": "Thanh toán",
      "stgPoStatus": "Trạng thái PO",
      "pfNewProject": "Dự án mới",
      "pfProjectInfo": "Thông tin dự án",
      "pfProjectInfoHint": "Thông tin cơ bản, lịch, trạng thái, các giai đoạn và mẫu liên kết",
      "pfCategory": "Danh mục",
      "pfSelectCategory": "Chọn danh mục...",
      "dgpTitle": "Xóa dự án {{id}}?",
      "dgpChecking": "Đang kiểm tra những gì thuộc dự án này…",
      "dgpSkus": "Sẽ xóa {{n}} SKU.",
      "dgpRounds": "Các vòng mẫu KHÔNG bị xóa — chúng vẫn nằm trong Theo dõi mẫu, chỉ không còn liên kết với dự án.",
      "dgpTickets": "Sẽ hủy {{n}} ticket, và các bộ phận đang giữ ticket sẽ được thông báo.",
      "dgpUndo": "Không thể hoàn tác thao tác này trên portal.",
      "dgpConfirm": "Xóa dự án",
      "dt1Title": "Xóa ticket {{id}}?",
      "dt1Emailed": "Ticket này đã được gửi email đến {{to}}. Xóa ticket sẽ hủy yêu cầu và họ sẽ được thông báo — kèm lý do bên dưới.",
      "dt1NotEmailed": "Ticket này chưa từng được gửi email, nên ngoài portal không ai biết đến nó. Xóa ticket sẽ không thông báo cho ai.",
      "dt1ReasonHint": "Dòng này là nội dung bộ phận nhận đọc để biết vì sao yêu cầu của họ biến mất.",
      "dt1Confirm": "Xóa ticket",
      "dt1ConfirmMail": "Xóa và thông báo",
      "dtTitle": "Xóa {{id}} — dự án có ticket",
      "dtLead": "{{n}} ticket sau thuộc dự án này. Xóa dự án sẽ hủy các ticket đó, và các bộ phận đã nhận sẽ được thông báo:",
      "dtNeverEmailed": "chưa từng gửi email",
      "dtReason": "Vì sao xóa dự án này?",
      "dtReasonPh": "vd. đối tác đã hủy hợp tác",
      "dtReasonHint": "Dòng này được đưa vào email thông báo hủy — đây là nội dung bộ phận nhận đọc để biết vì sao yêu cầu của họ biến mất.",
      "dtConfirm": "Xóa và hủy các ticket",
      "gmSkuOnlyHint": "Nhóm của bạn chỉ được sửa phần SKU — thông tin dự án ở trên thuộc Sales OP.",
      "pfReadOnlyHere": "Chỉ đọc ở đây — sửa tại Sửa nhóm dự án",
      "bmHint": "Những gì thuộc về chính Base ID, không thuộc riêng một vòng: ảnh, và tên style mà mọi vòng của nó dùng chung ({{rounds}} vòng tại đây).",
      "bmStyleHint": "Đổi tên sẽ áp dụng cho mọi vòng của Base ID này trong một lần ghi.",
      "bmRename": "Đổi tên style",
      "rmBasePhotos": "Ảnh mẫu (Base ID)",
      "rmPhotoRequired": "Bắt buộc",
      "rmPhotoNewBase": "Đây là style mới, nên khi lưu sẽ tạo Base ID mới — cần ít nhất một ảnh của mẫu. Ảnh thuộc về Base ID nên các vòng sau sẽ không hỏi lại.",
      "rmPhotoExistingBase": "Style này đã có với mã {{baseId}}, kèm ảnh riêng. Không cần thêm gì ở đây.",
      "rmPhotoNoStyle": "Hãy nhập Style / Mặt hàng trước. Style mới sẽ tạo Base ID mới, và Base ID mới cần có ảnh.",
      "pfPurpose": "Mục đích dự án",
      "pfPurposePh": "vì sao làm dự án này, và sẽ bán ở đâu.",
      "pfPurposeHint": "Quản lý Sales OP phải xác nhận với Sales Rep. CEO đọc dòng này để quyết định có làm hay không.",
      "pfNote": "Ghi chú",
      "pfTeam": "Nhóm",
      "pfOwner": "Chủ dự án (Sales OP)",
      "pfHandover": "Bạn đang chuyển dự án này cho {{who}}. Sau khi lưu, bạn sẽ không thể sửa nữa — chỉ {{who}}, {{mgr}} hoặc quản trị viên mới sửa được.",
      "pfHandoverMgr": "trưởng nhóm",
      "pfYear": "Năm",
      "pfYearPick": "Chọn năm…",
      "pfSeasonParts": "Mùa",
      "pfSeasonMax2": "Không bắt buộc — chọn tối đa hai",
      "pfSeasonCode": "Mã dự án: {{code}}",
      "seasonSpring": "Xuân",
      "seasonSummer": "Hè",
      "seasonFall": "Thu",
      "seasonWinter": "Đông",
      "pfSeason": "Mùa",
      "pfPartner": "Đối tác / Dòng sản phẩm",
      "pfKeyword": "Từ khóa",
      "pfTargetLaunch": "Tháng ra mắt dự kiến",
      "pfNameHint": "Do hệ thống tạo. PRJ-ID là mã cố định lâu dài; đây là tên để mọi người đọc.",
      "pfSelectTeam": "Chọn nhóm…",
      "pfSelectOwner": "Chọn chủ dự án…",
      "pfPickTeamFirst": "Chọn nhóm trước",
      "gmTitle": "Sửa nhóm dự án",
      "gmSaveGroup": "Lưu nhóm",
      "gmSaveTickets": "Lưu ticket",
      "pfProjectName": "Tên dự án",
      "pfProjectNamePh": "vd. 25 PARTICULIER",
      "pfCase": "Trường hợp",
      "pfSelectCase": "Chọn trường hợp...",
      "pfEntity": "Pháp nhân",
      "pfSelectEntity": "Chọn pháp nhân...",
      "pfSkuInfo": "Thông tin SKU",
      "pfAddSku": "+ Thêm SKU",
      "mvBtn": "Chuyển SKU từ dự án khác",
      "mvBtnTitle": "Mang các SKU đã duyệt từ một dự án khác của nhóm này sang — chúng vẫn giữ trạng thái đã duyệt",
      "mvNeedTeam": "Hãy chọn nhóm của dự án trước",
      "mvNotManager": "Chỉ quản trị viên hoặc trưởng nhóm này mới được chuyển SKU",
      "mvHead": "Chuyển SKU đã duyệt vào dự án này",
      "mvIntro": "Chọn một dự án cùng nhóm và tick các SKU đã duyệt của dự án đó. SKU sẽ được chuyển khi bạn lưu biểu mẫu này, giữ nguyên SKU ID, trạng thái duyệt, mẫu và các giai đoạn — không phải gửi lại CEO. Các ticket đã tạo vẫn ở dự án cũ. Developer, designer và các chủ dự án sẽ nhận được email.",
      "mvSource": "Lấy từ",
      "mvSearch": "Tìm dự án hoặc SKU",
      "mvSearchPh": "Số PRJ, tên dự án, số SKU hoặc tên mặt hàng…",
      "mvNoMatch": "Không có kết quả — thử từ khóa ngắn hơn.",
      "mvPicked": "Đã chọn {{n}}",
      "mvChoose": "Chọn dự án…",
      "mvLoading": "Đang tải…",
      "mvApprovedN": "{{n}} đã duyệt",
      "mvNone": "Không có dự án nào khác của nhóm này có SKU đã duyệt.",
      "mvAllTaken": "Mọi SKU đã duyệt của dự án này đều đã được chọn.",
      "mvAll": "Chọn tất cả",
      "mvColItem": "Mặt hàng",
      "mvColApproved": "Đã duyệt",
      "mvColDeveloper": "Developer",
      "mvColDesigner": "Designer",
      "mvCancel": "Hủy",
      "mvAdd": "Thêm {{n}} SKU",
      "mvListHead": "Sẽ chuyển vào khi lưu — {{n}} SKU",
      "mvFrom": "từ {{id}}",
      "mvApprovedBy": "do {{who}} duyệt",
      "mvRemove": "Không chuyển SKU này",
      "mvSaveHint": "Chưa có gì được chuyển: các SKU này sẽ chuyển vào dự án khi bạn lưu biểu mẫu.",
      "mvTeamChanged": "Các SKU này đến từ dự án của một nhóm khác với nhóm đã chọn ở trên — hãy bỏ chúng ra hoặc đổi lại nhóm.",
      "pfSkuHint": "Mỗi SKU được lưu thành một mục PRJ riêng thuộc một dự án PG. Mở một SKU để sửa thông tin, các giai đoạn ban đầu và mẫu liên kết.",
      "pfUnassigned": "Chưa giao",
      "pfNoCategory": "Chưa có danh mục",
      "pfQty": "SL",
      "pfStageChip": "giai đoạn",
      "pfRemoveSku": "Bỏ SKU",
      "pfDuplicateSku": "Nhân bản SKU này",
      "pfApprovalNoteHead": "Đã lưu ở trạng thái Chờ duyệt — chưa gửi đến người duyệt.",
      "pfApprovalNoteBody": "Mở Duyệt dự án và bấm Gửi để gửi yêu cầu. Có thể tạo ticket sau khi dự án được duyệt.",
      "pfDeveloper": "Developer",
      "pfDesigner": "Designer",
      "pfNoDesigner": "Không có designer",
      "ptDesigner": "Designer",
      "ptAllSalesReps": "Tất cả Sales Rep",
      "ptAllDesigners": "Tất cả Designer",
      "pfAssignedTo": "Giao cho",
      "pfAllocation": "Phân bổ",
      "pfProductCategory": "Danh mục sản phẩm",
      "pfFrameColor": "Màu khung",
      "pfFrameColorPh": "Tìm hoặc thêm màu…",
      "pfItemName": "Tên mặt hàng / SKU",
      "pfItemNamePh": "vd. Backpack 17L",
      "pfEstQty": "SL dự kiến",
      "pfStartDate": "Ngày bắt đầu",
      "pfExfShipDate": "Ngày giao EXF",
      "pfTargetPrice": "Giá mục tiêu (USD)",
      "pfLaunchDate": "Ngày ra mắt",
      "pfProjectStatus": "Trạng thái dự án",
      "pfRemark": "Ghi chú",
      "pfInitialStages": "Các giai đoạn ban đầu",
      "pfPctComplete": "hoàn thành",
      "pfStageHint": "Chọn trạng thái trong danh sách hoặc tự nhập — dùng dd/mm/yyyy nếu nhập ngày. Để trống ô sẽ lưu là Đang chờ.",
      "pfRepeatOrder": "Đơn hàng lặp lại",
      "pfRepeatOrderHint": "Style đã phát triển trước đây, nay được đặt hàng lại — không cần mẫu proto, counter, L/D S/OFF hay họp hand-off, nên cả bốn giai đoạn được đặt là Hoàn thành.",
      "pfStagePh": "Đang chờ hoặc dd/mm/yyyy",
      "pfStageAuto": "Tự động — theo mẫu liên kết",
      "pfLinkSample": "Liên kết mẫu (không bắt buộc)",
      "pfLinkSampleHint": "Một hoặc nhiều Sample ID/Base ID, cách nhau bằng dấu phẩy. Chọn một mẫu sẽ liên kết mẫu đó với mục PRJ này.",
      "pfLinkSamplePh": "Chọn hoặc nhập một Sample ID/Base ID",
      "pfGtm": "Chương trình GTM (không bắt buộc)",
      "pfGtmHint": "Chương trình GTM mà SKU này được ra mắt theo. SKU cũng hiện trên phiếu GTM",
      "pfGtmPh": "Chọn hoặc nhập mã GTM, vd. GTM-26-001",
      "pfTickets": "Ticket",
      "pfTicketsAdded": "Đã thêm {{count}} ticket",
      "pfNoTicketYet": "Chưa thêm ticket nào",
      "pfAllReceivingTeams": "Tất cả bộ phận nhận",
      "pfAddTicket": "＋ Thêm ticket…",
      "pfTicketHint": "Chỉ hiển thị các mã khớp với Nhóm, Trường hợp và Danh mục của dự án này, xếp theo giai đoạn. Chọn bộ phận nhận, rồi bấm “＋ Thêm ticket”. Ticket mới được tạo khi bạn lưu nhóm.",
      "pfClearTickets": "Xóa các ticket",
      "pfPhotosOnSku": "Ảnh được đính kèm trên từng SKU ở trên — mở một SKU và dùng Thêm ảnh.",
      "pfTicketEmpty": "Chưa thêm ticket nào — chọn ticket từ “＋ Thêm ticket”.",
      "pfCancel": "Hủy",
      "pfSaving": "Đang lưu...",
      "pfAddProject": "Thêm dự án",
      "pfDiscardTitle": "Bỏ dự án này?",
      "pfDiscardBody": "Những gì bạn đã nhập chưa được lưu. Đóng biểu mẫu là sẽ mất hết.",
      "pfDiscardKeep": "Tiếp tục sửa",
      "pfDiscardConfirm": "Bỏ",
      "dgEditTitle": "Bỏ các thay đổi?",
      "dgEditBody": "Những gì bạn thay đổi ở đây chưa được lưu. Đóng biểu mẫu là các thay đổi sẽ mất.",
      "pfSaveChanges": "Lưu thay đổi",
      "pfViewSample": "Xem mẫu liên kết",
      "pfSampleBtn": "Mẫu",
      "pfNewSku": "SKU mới",
      "pfEditPrefix": "Sửa",
      "pfGroupLevelHint": "Thông tin cấp nhóm — sửa tại nhóm dự án",
      "pfNewTag": "Mới",
      "pfSaveAddSku": "Thêm SKU",
      "thSortFilter": "Sắp xếp và lọc",
      "thSortAZ": "Sắp xếp từ A đến Z",
      "thSortOldNew": "Sắp xếp từ cũ nhất đến mới nhất",
      "thSortZA": "Sắp xếp từ Z đến A",
      "thSortNewOld": "Sắp xếp từ mới nhất đến cũ nhất",
      "thSearch": "Tìm...",
      "thSelectAll": "(Chọn tất cả)",
      "thNoMatches": "Không có kết quả",
      "thOk": "Đồng ý",
      "thCancel": "Hủy",
      "thBlanks": "(Trống)",
      "thFiltered": "Đang lọc — giữ {{count}} giá trị",
      "pgSharedHint": "Thông tin cơ bản dùng chung cho mọi SKU trong nhóm này",
      "pgPrjItems": "mục PRJ",
      "pgSkuHint": "Mỗi SKU là một mục PRJ riêng thuộc dự án PG này. Bấm vào một SKU để sửa thông tin, các giai đoạn và mẫu liên kết.",
      "pgNoSku": "Nhóm này chưa có SKU nào.",
      "pgRemoveSku": "Bỏ SKU này khỏi nhóm",
      "rmTitleNew": "Vòng mới",
      "rmTitleNewSample": "Mẫu mới",
      "rmTitleEdit": "Sửa vòng hiện có",
      "rmTitleAdvance": "Vòng tiếp theo (bắt buộc khi chọn Advance)",
      "tkFiles": "Tệp đính kèm",
      "tfPick": "Bấm để đính kèm tệp",
      "tfHint": "PDF, Excel, CSV, Word, hình ảnh — tối đa {{max}} MB mỗi tệp, gửi kèm email ticket",
      "tfUploading": "Đang tải lên…",
      "tfRemove": "Bỏ tệp này",
      "tfTotal": "{{n}} tệp, {{size}} — sẽ được gửi làm tệp đính kèm trong email ticket",
      "tfSaveFirst": "Ticket này không thể đính kèm tệp.",
      "tfDraftNote": "tệp sẽ được đính kèm khi bạn lưu ticket",
      "tfTooBig": "{{name}} có dung lượng {{mb}} MB; giới hạn là {{max}} MB mỗi tệp.",
      "rmPickSample": "Chọn một mẫu có sẵn để thêm vòng",
      "rmPickSampleSub": "— nhập Sample ID, Base ID hoặc tên style",
      "rmPickPh": "vd. SMP-2601-P1 hoặc SMP-2601...",
      "rmPickRequired": "Chọn mẫu mà vòng này thuộc về — vòng luôn được thêm vào một mẫu có sẵn.",
      "rmPickFirst": "Bắt đầu ở đây. Nhập Sample ID — phần còn lại của biểu mẫu sẽ mở ra khi đã chọn mẫu.",
      "rmStyleFromSample": "Lấy từ mẫu bạn chọn ở trên",
      "rmStyleFromSku": "Lấy từ SKU dự án mà mẫu này dành cho",
      "rmStylePlaceholder": "Chọn một mẫu ở trên",
      "rmSalesTeam": "Nhóm Sales",
      "rmProjectOwner": "Chủ dự án",
      "rmProjectName": "Dự án",
      "rmNoLinkedSku": "Chưa liên kết với SKU",
      "rmClear": "Bỏ chọn",
      "rmAddingTo": "Đang thêm vòng cho",
      "rmChange": "Đổi",
      "rmAdvanceNote": "đang được đặt là Advance, nghĩa là việc phát triển chuyển sang vòng tiếp theo. Hãy điền vòng đó và lưu — cả hai được lưu cùng lúc.",
      "rmAdvanceNoteSub": "Nếu bạn hủy, kết quả Advance cũng không được lưu và vòng vẫn giữ nguyên như cũ.",
      "rmDupWarn": "Có thể bị trùng: {{sampleId}} đã có vòng \"{{round}}\" cho style này (kết quả: {{outcome}}).",
      "rmDupOpen": "chưa xác định",
      "rmOwnership": "Phụ trách nhập:",
      "rmHevnFills": "HEVN nhập",
      "rmHincFills": "HINC Design nhập",
      "rmBothTeams": "Cả hai nhóm",
      "rmAutoGen": "Tự động tạo",
      "rmMandatory": "= Trường bắt buộc",
      "rmSampleIdent": "Nhận dạng mẫu",
      "rmStyleItem": "Style / Mặt hàng",
      "rmStyleHint": "Chọn style có sẵn hoặc nhập mới — Base ID được cấp tự động",
      "rmStylePh": "vd. Chair Zero LT",
      "rmBaseId": "Base ID",
      "rmAutoAssigned": "Cấp tự động",
      "rmSampleId": "Mã mẫu",
      "rmSampleIdHint": "Base ID + Vòng + Option (tự động)",
      "rmRound": "Vòng",
      "rmOption": "Tùy chọn",
      "rmOptionHint": "Chỉ khi kết cấu khác",
      "rmOptionPh": "Vải / Lưới (để trống nếu chỉ khác màu)",
      "rmCategory": "Danh mục",
      "rmSeason": "Mùa",
      "rmDevelopmentDue": "Hạn phát triển",
      "rmDevDueHint": "Bắt buộc — tô vàng trong Sheet",
      "rmTargetPrice": "Giá mục tiêu (USD)",
      "rmLinkedSku": "SKU dự án liên kết",
      "rmOptional": "Không bắt buộc",
      "rmLinkedSkuHint": "Liên kết mẫu này với một SKU dự án",
      "rmSearchProject": "Tìm dự án...",
      "rmReviewType": "Loại đánh giá",
      "rmHevn": "HEVN",
      "rmRequiresDesigner": "Cần designer đánh giá",
      "rmInternalOnly": "Chỉ HEVN đánh giá nội bộ",
      "rmInternalNote": "Dùng Ngày đánh giá và Ghi chú để lưu đánh giá nội bộ của HEVN. Vòng này không được tính vào khối lượng việc của designer hay phản hồi đang chờ.",
      "rmDesignerNote": "Đánh giá của designer giữ nguyên quy trình đánh giá và kết quả hiện tại của HINC.",
      "rmInternalReview": "Đánh giá nội bộ HEVN",
      "rmRequestDate": "Ngày yêu cầu",
      "rmInternalReqHint": "Cùng trường với Ngày yêu cầu trong Đánh giá thiết kế HINC — ở đây là ngày đánh giá nội bộ",
      "rmRemarks": "Ghi chú",
      "rmInternalRemarksPh": "Ghi chú cho lần đánh giá nội bộ này...",
      "rmSamplePlan": "Kế hoạch mẫu",
      "rmDeveloper": "Developer",
      "rmDeveloperPh": "Chọn hoặc nhập tên...",
      "rmEitherName": "Một Developer hoặc một Designer — ai cũng được.",
      "rmLocation": "Địa điểm R&D",
      "rmRmReady": "Ngày RM sẵn sàng",
      "rmRmReadyHint": "Tick Dự kiến nếu đây là ngày theo kế hoạch; bỏ tick khi nguyên liệu/thông số đã sẵn sàng.",
      "pfNeedOwner": "Dự án này chưa có Chủ dự án nên chưa thể tạo ticket — email sẽ gửi đi với \"Chủ dự án: -\" và bộ phận nhận sẽ không biết phải liên hệ lại với ai. Mở dự án bằng biểu tượng bút chì trên dòng của nó, đặt Chủ dự án, lưu, rồi quay lại đây.",
      "pfNeedOwnerShort": "Hãy đặt Chủ dự án cho dự án trước",
      "rmMaterials": "Danh sách nguyên liệu",
      "rmMaterialsHint": "Mọi cột ở đây thuộc về SKU và được sửa trên SKU — chỉ có một danh sách, không phải bản sao, nên nguyên liệu thêm ở đó sẽ hiện ở mọi vòng. Ngoại lệ là ngày RM sẵn sàng: mục này thuộc về vòng này và được lưu cùng vòng.",
      "rmMaterialsNoSku": "Chưa có danh sách nguyên liệu — danh sách thuộc về SKU dự án, mà vòng này chưa liên kết với SKU nào. Điền SKU dự án liên kết ở trên, nguyên liệu của SKU đó sẽ hiện ở đây.",
      "rmExpectedDate": "Ngày dự kiến",
      "rmSampleFinish": "Ngày hoàn thành mẫu",
      "rmQty": "SL",
      "rmActualCost": "Chi phí thực tế (USD)",
      "rmAutoCalc": "Tự động tính (chỉ đọc):",
      "rmMakeDays": "Số ngày làm",
      "rmShipDays": "Số ngày gửi",
      "rmRoundCycle": "Chu kỳ vòng",
      "rmDday": "D-day",
      "rmHincReview": "Đánh giá thiết kế HINC",
      "rmHincDesigner": "Designer HINC",
      "rmHincReqHint": "Ngày HINC yêu cầu mẫu này",
      "rmRoundDue": "Hạn vòng",
      "rmRoundDueHint": "Mốc HINC đặt ra để hoàn thành mẫu",
      "rmReceivedDate": "Ngày nhận",
      "rmReceivedHint": "Ngày HINC nhận mẫu",
      "rmReviewDate": "Ngày đánh giá (Ngày nhận xét)",
      "rmReviewDateHint": "Ngày HINC gửi phản hồi",
      "rmRoundOutcome": "Kết quả vòng",
      "rmOutcomeHint": "Đặt sau buổi họp nhận xét hằng tuần",
      "rmNotSetYet": "— chưa đặt —",
      "rmOutcomePick": "Chọn một kết quả để xem ý nghĩa.",
      "rmReworkTitle": "Làm lại — cần nêu lý do",
      "rmReworkReason": "Lý do làm lại",
      "rmSelectAll": "(chọn tất cả mục phù hợp)",
      "rmRoundRemarksPh": "Ghi chú cho vòng này...",
      "rmSaving": "Đang lưu...",
      "rmSaveChanges": "Lưu thay đổi",
      "rmSaveAdvance": "Lưu Advance + vòng mới",
      "rmAddNewRound": "Thêm vòng mới",
      "rmCancel": "Hủy",
      "rmCancelAdvance": "Hủy (bỏ cả Advance)",
      "tkTitle": "Ticket Station",
      "tkHint": "Theo dõi ticket của dự án, việc theo sát của chủ dự án, hạn và cập nhật trạng thái.",
      "tkAll": "Tất cả ticket",
      "tkDone": "Đã đóng",
      "tkCancelled": "Đã hủy",
      "tkPending": "Đang mở",
      "tkOverdue": "Quá hạn",
      "tkAllRequesters": "Tất cả người yêu cầu",
      "tkAllTeams": "Tất cả bộ phận nhận",
      "tkAllSopTeams": "Tất cả nhóm Sales OP",
      "tkAllPriority": "Mọi mức ưu tiên",
      "tkSearch": "Tìm ticket / dự án...",
      "tkNewTicket": "+ Ticket mới",
      "tkTabTickets": "Ticket Station",
      "tkManageCodes": "Mã ticket",
      "tkColTicketId": "ID ticket",
      "tkColTicket": "Phiếu",
      "tkColProject": "Dự án",
      "tkColProjectName": "Tên dự án",
      "tkColTeam": "Bộ phận nhận",
      "tkColRequester": "Người yêu cầu",
      "tkColType": "Loại",
      "tkColPriority": "Ưu tiên",
      "tkColDue": "Hạn",
      "tkColCreatedBy": "Người tạo",
      "tkColCreatedAt": "Ngày tạo",
      "tkColUpdatedBy": "Người sửa",
      "tkColUpdatedAt": "Ngày sửa",
      "tkColNote": "Ghi chú",
      "tkColAssigneeReply": "Phản hồi của người được giao",
      "tkLinkNotSent": "Hãy gửi ticket trước — chưa ai ở bộ phận nhận biết ticket này tồn tại, nên chưa có ai để trả lời qua liên kết này.",
      "tkColDescription": "Mô tả",
      "tkColAssigneeNote": "Ghi chú của người được giao",
      "tkColEmailSent": "Ngày gửi email",
      "tkExportEmpty": "Không có gì để xuất — không có ticket nào khớp với bộ lọc hiện tại.",
      "tkManagerStatus": "Trạng thái của quản lý",
      "tkRemind": "Nhắc",
      "tkRemindHint": "Gửi email nhắc bộ phận nhận rằng ticket này vẫn đang mở",
      "tkSend": "Gửi",
      "tkSendHint": "Ticket này chưa từng được gửi email — gửi yêu cầu đến bộ phận nhận",
      "tkSendDone": "Đã gửi email ticket {{id}} đến {{to}}.",
      "tkSendFailed": "Gửi thất bại: {{err}}",
      "tkDdayHint": "D-DAY = hôm nay − hạn chót. Giá trị dương nghĩa là ticket đã quá hạn bấy nhiêu ngày. Khi ticket Xong hoặc Đã hủy, giá trị dừng lại ở ngày ticket được đóng.",
      "tkNotYourTeam": "Chỉ người tạo ticket, chủ dự án, quản lý của bộ phận đó hoặc admin mới có thể thay đổi ticket này.",
      "tkExpandAll": "Mở tất cả",
      "tkCollapseAll": "Thu gọn tất cả",
      "tkTicketsSingular": "phiếu",
      "tkTicketsPlural": "ticket",
      "tkNoProject": "(không có dự án)",
      "tkEdit": "Sửa ticket",
      "tkDuplicate": "Nhân bản ticket",
      "tkDelete": "Xóa ticket",
      "tkOpenLink": "Mở liên kết trạng thái công khai",
      "tkLink": "Liên kết",
      "tkNoTickets": "Không tìm thấy ticket nào.",
      "tkTitleNew": "Ticket mới",
      "tkTitleEdit": "Sửa ticket",
      "tkTitleDup": "Nhân bản ticket",
      "tkAuto": "Tự động",
      "tkProjectGroup": "Nhóm dự án",
      "tkSearchGroup": "Tìm nhóm dự án...",
      "tkAutoFromGroup": "Tự động theo nhóm dự án",
      "tkSelectTeam": "Chọn bộ phận nhận...",
      "tkTicketCode": "Mã ticket",
      "tkSelectCode": "Chọn loại ticket đã thống nhất...",
      "tkTicketName": "Tên ticket",
      "tkSelectTypeFirst": "Chọn loại ticket",
      "tkDescription": "Mô tả",
      "tkDescriptionPh": "Chi tiết ticket / kết quả mong đợi",
      "tkRequesterPh": "Tự động theo người đăng nhập",
      "tkGroupEmail": "Email nhóm",
      "tkGroupEmailPh": "Tự động theo bộ phận nhận",
      "tkDueDate": "Hạn chót",
      "tkSentAt": "Ngày gửi email",
      "tkAttachment": "Liên kết đính kèm",
      "tkAttachmentPh": "Dán liên kết Drive/tệp",
      "tkNotePh": "Ghi chú nội bộ hoặc cập nhật mới nhất",
      "tkSendAfterSave": "Gửi email sau khi lưu",
      "tkSent": "Đã gửi",
      "tkNotSent": "Chưa gửi",
      "tkEmailSubject": "Tiêu đề email",
      "tkSystemGenerated": "hệ thống tạo",
      "tkEmailCc": "CC email",
      "tkEmailMessage": "Nội dung email",
      "tkReadOnly": "chỉ đọc",
      "tkEmailMessagePh": "Nội dung email",
      "tkGeneratedNote": "Tiêu đề và nội dung email được tạo tự động và không thể sửa.",
      "tkSendEmail": "Gửi email",
      "tkDeleteTicket": "Xóa ticket",
      "tkSaveTicket": "Lưu ticket",
      "tkNoDueDate": "Không có hạn",
      "tkRemoveTicket": "Gỡ ticket",
      "tkOptionalNote": "Ghi chú (không bắt buộc)",
      "tkWillSend": "Sẽ gửi khi lưu",
      "tkQueued": "Đang chờ gửi",
      "tkQueuedCancelTitle": "Đang chờ gửi — bấm để hủy",
      "tkSendBlocked": "Hãy điền các trường bắt buộc ở trên trước — thiếu chúng thì không gửi được email",
      "tkSendTitle": "Ticket được tạo khi lưu, nên email sẽ được gửi ngay sau đó"
    },
    "rt": {
      "bold": "In đậm (Ctrl+B)",
      "italic": "In nghiêng (Ctrl+I)",
      "underline": "Gạch chân (Ctrl+U)",
      "strike": "Gạch ngang",
      "colour": "Màu chữ",
      "bullets": "Danh sách dấu đầu dòng",
      "numbers": "Danh sách đánh số",
      "clear": "Xóa định dạng",
      "cDefault": "Mặc định",
      "cRed": "Đỏ",
      "cOrange": "Cam",
      "cGreen": "Xanh lá",
      "cBlue": "Xanh dương",
      "cPurple": "Tím",
      "cGrey": "Xám"
    },
    "nfc": {
      "stDraft": "CHƯA GỬI",
      "stWaiting": "CHỜ DUYỆT",
      "stApproved": "ĐÃ DUYỆT",
      "stRejected": "BỊ TỪ CHỐI",
      "replOk": "Hợp lệ",
      "replNotFound": "Không tìm thấy",
      "replReplaced": "Đã được thay",
      "replDuplicate": "Trùng lặp",
      "notSignedIn": "(chưa đăng nhập)",
      "role": "Vai trò",
      "manager": "Quản lý",
      "coordinator": "Điều phối viên",
      "unassigned": "chưa gán",
      "loading": "Đang tải…",
      "noAccessTitle": "Không có quyền truy cập",
      "noAccessBody": "chưa được gán vai trò Điều phối viên/Quản lý cho cổng NFC. Liên hệ Special Project để được thêm vào.",
      "accountWord": "Tài khoản",
      "createTitle": "Tạo yêu cầu cấp token",
      "tabIssuance": "Cấp token",
      "tabReplacement": "Thay NFC lỗi",
      "labelType": "Loại nhãn",
      "labelNfc": "Nhãn NFC",
      "labelQr": "Nhãn QR ép nhiệt",
      "projectName": "Tên dự án",
      "batchName": "Tên lô",
      "qty": "Số lượng (QTY)",
      "qtyPh": "Bắt buộc nếu không nhập danh sách mặt hàng",
      "style": "Style / Sản phẩm",
      "stylePh": "VD: Chair One (re)",
      "color": "Màu",
      "vendor": "Nhà cung cấp",
      "vendorPh": "VD: Metric / TheSang",
      "code": "Mã",
      "codePh": "VD: 10001555",
      "importTitle": "Nhập nhiều mặt hàng (không bắt buộc)",
      "importReplTitle": "Nhập các token NFC lỗi",
      "downloadTemplate": "Tải mẫu CSV",
      "chooseCsv": "Chọn CSV",
      "noFile": "Chưa chọn tệp",
      "importSummary": "Đã tải {{count}} mặt hàng, tổng QTY {{qty}}. Kiểm tra và chỉnh sửa trước khi gửi.",
      "importInvalid": "Một số dòng không hợp lệ (cần Dự án + Lô + Số lượng).",
      "importEmpty": "Chưa tải tệp nhập — để trống để dùng các ô một mặt hàng ở trên.",
      "replSummary": "Đã tải {{count}} token lỗi. Kiểm tra trước khi gửi.",
      "replChecking": "Đang đối chiếu với sổ cái…",
      "warning": "Cảnh báo:",
      "oldToken": "Token cũ / URL NFC",
      "reason": "Lý do",
      "notes": "Ghi chú",
      "status": "Trạng thái",
      "checking": "Đang kiểm tra…",
      "notChecked": "Chưa kiểm tra",
      "replEmpty": "Chưa tải token lỗi nào — tải mẫu về, rồi tải lên tệp CSV để bắt đầu.",
      "optional": "Không bắt buộc",
      "saving": "Đang lưu…",
      "save": "Lưu",
      "cancel": "Hủy",
      "myRequests": "Yêu cầu của tôi",
      "reload": "Tải lại",
      "colId": "ID",
      "colProject": "Dự án",
      "colBatch": "Lô",
      "colQty": "Số lượng",
      "colItems": "Mặt hàng",
      "colLabel": "Nhãn",
      "colVendor": "Nhà cung cấp",
      "colCode": "Mã",
      "colStatus": "Trạng thái",
      "colUpdated": "Cập nhật",
      "colFile": "Tệp",
      "colAction": "Thao tác",
      "colOld": "Cũ",
      "colNew": "Mới",
      "colOutput": "Kết quả",
      "colRequestedBy": "Người yêu cầu",
      "colEmail": "Email",
      "colAddedBy": "Người thêm",
      "downloadOrder": "Tải tệp đặt hàng",
      "viewDetail": "Xem chi tiết",
      "edit": "Sửa",
      "submitApproval": "Gửi duyệt",
      "delete": "Xóa",
      "reject": "Từ chối",
      "noRequests": "Chưa có yêu cầu nào.",
      "reviewTitle": "Xét duyệt yêu cầu",
      "accessTitle": "Quản lý quyền truy cập cổng",
      "accessHint": "Cấp hoặc thu hồi quyền Điều phối viên / Quản lý cho cổng NFC này. Thay đổi có hiệu lực vào lần tiếp theo người dùng mở cổng.",
      "grantAccess": "Cấp quyền",
      "noUsers": "Chưa có người dùng nào được gán.",
      "detailTitle": "Chi tiết yêu cầu",
      "lblNotes": "GHI CHÚ",
      "lblOutputFile": "TỆP KẾT QUẢ",
      "openOutput": "Mở tệp kết quả",
      "lblDecisionNote": "GHI CHÚ QUYẾT ĐỊNH",
      "replItems": "Mặt hàng thay thế",
      "items": "Mặt hàng",
      "close": "Đóng",
      "genTitle": "Đang tạo token",
      "genLead": "đang được duyệt. Vui lòng giữ tab này mở và",
      "genLeadBold": "đừng bấm Duyệt lần nữa",
      "requestWord": "Yêu cầu",
      "working": "Đang xử lý...",
      "rejectTitle": "Từ chối yêu cầu",
      "rejectReason": "Lý do (gửi cho người yêu cầu)",
      "rejectReasonPh": "Vì sao từ chối yêu cầu này?",
      "rejectReasonReq": "Vui lòng nhập lý do từ chối.",
      "rejectBtn": "Từ chối yêu cầu",
      "deleteTitle": "Xóa yêu cầu",
      "deleteBody": "Xóa yêu cầu {{id}}? Chỉ xóa được yêu cầu Nháp hoặc Bị từ chối.",
      "nReplacements": "{{count}} lượt thay thế",
      "nItems": "{{count}} mặt hàng",
      "single": "Đơn lẻ",
      "nCodes": "{{count}} mã",
      "flashCleared": "Đã làm trống biểu mẫu yêu cầu.",
      "flashSubmitted": "Đã gửi duyệt yêu cầu {{id}}.",
      "flashDraft": "Đã lưu nháp yêu cầu {{id}}.",
      "flashLoadedEdit": "Đã mở {{id}} để chỉnh sửa.",
      "flashDeleted": "Đã xóa yêu cầu {{id}}.",
      "flashApproved": "Đã duyệt yêu cầu {{id}} — đã tạo {{qty}} token.",
      "flashGranted": "Đã cấp quyền {{role}} cho {{email}}.",
      "flashRevoked": "Đã thu hồi quyền {{role}} của {{email}}.",
      "flashEmailReq": "Vui lòng nhập email.",
      "flashLoadedFile": "Đã tải {{name}}.",
      "flashRejected": "Đã từ chối yêu cầu {{id}}.",
      "progStarting": "Đang bắt đầu duyệt...",
      "progCompleted": "Hoàn thành",
      "progGenerated": "Đã tạo {{qty}} token",
      "progSavedImport": "Đã tải dữ liệu nhập đã lưu"
    },
    "dd": {
      "title": "Bảng tổng quan",
      "scopeNote": "Chỉ tính mẫu thuộc dự án — mẫu thử (TSMP) không được tính vào bất kỳ số liệu nào trên trang này. Theo dõi mẫu liệt kê cả hai loại.",
      "loading": "Đang tải bảng tổng quan…",
      "retry": "Thử lại",
      "noData": "Không có dữ liệu",
      "totalRounds": "Tổng số vòng",
      "acrossSamples": "trên {{count}} mẫu",
      "avgRoundsSample": "Số vòng TB / mẫu",
      "higherSpinning": "càng cao = càng lặp nhiều vòng",
      "reworkRatio": "Tỷ lệ làm lại",
      "mainKpi": "KPI chính",
      "pastDue": "Quá hạn phát triển",
      "pastDueSub": "{{unit}} có D-day ≥ 0",
      "reworkByRoom": "Tỷ lệ làm lại theo phòng phát triển",
      "reworkAttribution": "Quy trách nhiệm làm lại (hai chiều)",
      "hevnCaused": "HEVN (gây ra)",
      "hincCaused": "HINC (gây ra)",
      "external": "Bên ngoài",
      "hevnRatio": "Tỷ lệ do HEVN",
      "stuckTime": "Chỉ báo thời gian bị kẹt",
      "avgCommentDiffers": "Số ngày nhận xét TB — vòng 'differs'",
      "avgCommentAdvance": "Số ngày nhận xét TB — vòng Advance",
      "avgCommentAll": "Số ngày nhận xét TB — tất cả",
      "spinning": "Mẫu lặp nhiều vòng (từ 4 vòng)",
      "sampleSpeed": "Tốc độ làm mẫu",
      "sampleSpeedNote": "Ngày RM sẵn sàng = ngày vải/vật tư/thông số đã sẵn sàng và phòng mẫu có thể bắt đầu làm mẫu. Tốc độ làm mẫu tính từ Ngày RM sẵn sàng đến Ngày hoàn thành mẫu; các vòng chưa có ngày sẵn sàng thực tế, hoặc có ngày sẵn sàng dự kiến trong tương lai, vẫn ở trạng thái Chờ RM và không được tính.",
      "avgMakeHevn": "Số ngày làm mẫu TB (HEVN R&D)",
      "avgMakeTs": "Số ngày làm mẫu TB (TS)",
      "avgMakeMs": "Số ngày làm mẫu TB (MS)",
      "avgMakeTotal": "Số ngày làm mẫu TB (Tổng)",
      "byDeveloper": "Theo Developer — chi tiết đầy đủ",
      "colDeveloper": "Developer",
      "colSamples": "Mẫu",
      "colRounds": "Vòng",
      "colRework": "Làm lại",
      "colReworkRate": "Tỷ lệ làm lại",
      "colAvgRounds": "Số vòng TB",
      "colAvgMakeDays": "Số ngày làm TB",
      "colPending": "Đang chờ"
    }
  }
};

export default vi;
